var _regeneratorRuntime = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Gleap = t() : e.Gleap = t();
}(this, function () {
  return function () {
    "use strict";

    var e = {
        d: function d(t, n) {
          for (var a in n) {
            e.o(n, a) && !e.o(t, a) && Object.defineProperty(t, a, {
              enumerable: !0,
              get: n[a]
            });
          }
        },
        o: function o(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }
      },
      t = {};
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function a(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    e.d(t, {
      default: function _default() {
        return Mt;
      }
    });
    var r = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), a(this, "feedbackButton", null), a(this, "injectedFeedbackButton", !1), a(this, "buttonHidden", null), a(this, "lastButtonIcon", null);
      }
      var t, r, o;
      return t = e, o = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (r = [{
        key: "toggleFeedbackButton",
        value: function value(t) {
          this.buttonHidden = !t, e.getInstance().updateFeedbackButtonState(), ct.getInstance().updateContainerStyle();
        }
      }, {
        key: "feedbackButtonPressed",
        value: function value() {
          var e = re.getInstance();
          e.isOpened() ? e.hideWidget() : (e.setAppMode("widget"), e.showWidget());
        }
      }, {
        key: "injectFeedbackButton",
        value: function value() {
          var e = this;
          if (!this.injectedFeedbackButton) {
            this.injectedFeedbackButton = !0;
            var t = document.createElement("div");
            t.onclick = function () {
              e.feedbackButtonPressed();
            }, document.body.appendChild(t), this.feedbackButton = t, this.updateFeedbackButtonState();
          }
        }
      }, {
        key: "updateNotificationBadge",
        value: function value(e) {
          var t = document.querySelector(".bb-notification-bubble");
          if (t) {
            var n = "bb-notification-bubble--hidden";
            e > 0 ? (t.classList.remove(n), t.innerText = e) : t.classList.add(n);
          }
        }
      }, {
        key: "refresh",
        value: function value() {
          document.querySelector(".bb-feedback-button") ? (this.updateFeedbackButtonText(), this.updateFeedbackButtonState()) : (this.injectedFeedbackButton = !1, this.injectFeedbackButton());
        }
      }, {
        key: "updateFeedbackButtonText",
        value: function value() {
          var t = B.getInstance().getFlowConfig();
          if (t.feedbackButtonPosition === e.FEEDBACK_BUTTON_CLASSIC || t.feedbackButtonPosition === e.FEEDBACK_BUTTON_CLASSIC_BOTTOM || t.feedbackButtonPosition === e.FEEDBACK_BUTTON_CLASSIC_LEFT) {
            var n = document.querySelector(".bb-feedback-button-classic");
            n && (n.innerText = t.widgetButtonText);
          }
        }
      }, {
        key: "updateFeedbackButtonState",
        value: function value() {
          if (null !== this.feedbackButton) {
            var t = B.getInstance().getFlowConfig(),
              n = "";
            n = t.buttonLogo ? '<img class="bb-logo-logo" src="'.concat(t.buttonLogo, '" alt="Feedback Button" />') : u("button", "#fff"), this.feedbackButton.className = "bb-feedback-button gleap-font gl-block", this.feedbackButton.setAttribute("dir", $e.getInstance().isRTLLayout ? "rtl" : "ltr"), t.feedbackButtonPosition === e.FEEDBACK_BUTTON_CLASSIC || t.feedbackButtonPosition === e.FEEDBACK_BUTTON_CLASSIC_BOTTOM || t.feedbackButtonPosition === e.FEEDBACK_BUTTON_CLASSIC_LEFT ? (this.feedbackButton.classList.add("bb-feedback-button--classic-button-style"), this.feedbackButton.innerHTML = '<div class="bb-feedback-button-classic '.concat(t.feedbackButtonPosition === e.FEEDBACK_BUTTON_CLASSIC_LEFT ? "bb-feedback-button-classic--left" : "").concat(t.feedbackButtonPosition === e.FEEDBACK_BUTTON_CLASSIC_BOTTOM ? "bb-feedback-button-classic--bottom" : "", '">').concat(t.widgetButtonText, "</div>")) : n !== this.lastButtonIcon && (this.feedbackButton.innerHTML = '<div class="bb-feedback-button-icon">'.concat(n).concat(u("arrowdown", "#fff"), '</div><div class="bb-notification-bubble bb-notification-bubble--hidden"></div>')), this.lastButtonIcon = n;
            var a = !1;
            null === e.getInstance().buttonHidden ? t.feedbackButtonPosition === e.FEEDBACK_BUTTON_NONE && (a = !0) : e.getInstance().buttonHidden && (a = !0), a && this.feedbackButton.classList.add("bb-feedback-button--disabled"), t.feedbackButtonPosition === e.FEEDBACK_BUTTON_BOTTOM_LEFT && this.feedbackButton.classList.add("bb-feedback-button--bottomleft"), re.getInstance().isOpened() && this.feedbackButton.classList.add("bb-feedback-button--open");
            var r = re.getInstance().appMode;
            "survey" !== r && "survey_full" !== r || this.feedbackButton.classList.add("bb-feedback-button--survey"), !0 !== t.hideForGuests || M.getInstance().isUser() || this.feedbackButton.classList.add("bb-feedback-button--hidden");
          }
        }
      }]) && n(t.prototype, r), o && n(t, o), e;
    }();
    function o(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
        if (null == n) return;
        var a,
          r,
          o = [],
          i = !0,
          s = !1;
        try {
          for (n = n.call(e); !(i = (a = n.next()).done) && (o.push(a.value), !t || o.length !== t); i = !0) {
            ;
          }
        } catch (c) {
          s = !0, r = c;
        } finally {
          try {
            i || null == n.return || n.return();
          } finally {
            if (s) throw r;
          }
        }
        return o;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return i(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function i(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, a = new Array(t); n < t; n++) {
        a[n] = e[n];
      }
      return a;
    }
    a(r, "FEEDBACK_BUTTON_BOTTOM_RIGHT", "BOTTOM_RIGHT"), a(r, "FEEDBACK_BUTTON_BOTTOM_LEFT", "BOTTOM_LEFT"), a(r, "FEEDBACK_BUTTON_CLASSIC", "BUTTON_CLASSIC"), a(r, "FEEDBACK_BUTTON_CLASSIC_LEFT", "BUTTON_CLASSIC_LEFT"), a(r, "FEEDBACK_BUTTON_CLASSIC_BOTTOM", "BUTTON_CLASSIC_BOTTOM"), a(r, "FEEDBACK_BUTTON_NONE", "BUTTON_NONE"), a(r, "instance", void 0);
    var s = function s(e, t) {
        3 === (e = e.replace(/^#/, "")).length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
        var n = o(e.match(/.{2}/g), 3),
          a = n[0],
          r = n[1],
          i = n[2],
          s = [parseInt(a, 16) + t, parseInt(r, 16) + t, parseInt(i, 16) + t];
        a = s[0], r = s[1], i = s[2], a = Math.max(Math.min(255, a), 0).toString(16), r = Math.max(Math.min(255, r), 0).toString(16), i = Math.max(Math.min(255, i), 0).toString(16);
        var c = (a.length < 2 ? "0" : "") + a,
          l = (r.length < 2 ? "0" : "") + r,
          u = (i.length < 2 ? "0" : "") + i;
        return "#".concat(c).concat(l).concat(u);
      },
      c = function c(e) {
        return (299 * parseInt(e.substr(1, 2), 16) + 587 * parseInt(e.substr(3, 2), 16) + 114 * parseInt(e.substr(5, 2), 16)) / 1e3 >= 160 ? "#000000" : "#ffffff";
      },
      l = function l(e, t, n, a, o, i, _l, u) {
        var d = c(e),
          p = c(n),
          f = c(o),
          h = c(t),
          g = "#ffffff" === f,
          m = s(t, "#ffffff" === h ? -35 : -15),
          b = s(o, g ? 100 : -120),
          v = s(o, g ? 30 : -12),
          y = s(o, g ? 80 : -30),
          w = (a = parseInt(a, 10), Math.round(1.05 * a)),
          C = Math.round(.8 * a),
          k = Math.round(.6 * a),
          I = Math.round(.4 * a),
          x = Math.round(.25 * a),
          S = 57 + _l;
        u === r.FEEDBACK_BUTTON_CLASSIC_BOTTOM ? S = _l + 15 : (u && u.includes("CLASSIC") || u === r.FEEDBACK_BUTTON_NONE) && (S = _l);
        var L = '\n    .gleap-font, .gleap-font * {\n      font-style: normal;\n      font-variant-caps: normal;\n      font-variant-ligatures: normal;\n      font-variant-numeric: normal;\n      font-variant-east-asian: normal;\n      font-weight: normal;\n      font-stretch: normal;\n      font-size: 100%;\n      line-height: 1;\n      font-family: system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";\n    }\n    .gleap-frame-container {\n      right: '.concat(i, "px;\n      bottom: ").concat(61 + _l, "px;\n      width: calc(100% - 40px);\n      max-width: 400px;\n      position: fixed;\n      z-index: ").concat(2147483631, ";\n      visibility: visible;\n      box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.16);\n      border-radius: ").concat(C, "px;\n      overflow: hidden;\n      animation-duration: .3s;\n      animation-fill-mode: both;\n      animation-name: gleapFadeInUp;\n      user-select: none;\n      pointer-events: none;\n      transition: max-width 0.3s ease-out;\n    }\n\n    :root {\n      --gleap-margin-top: 50px;\n    }\n\n    .gleap-b-frame {\n      width: 100%;\n      height: 100%;\n      border: none;\n      pointer-events: auto;\n      padding: 0px;\n      margin: 0px;\n    }\n\n    .gleap-b-shown {\n      transition: margin 0.3s ease-out;\n      margin-top: var(--gleap-margin-top);\n      position: relative;\n    }\n\n    .gleap-b-f {\n      margin-top: 0px;\n    }\n\n    .gleap-b {\n      display: none;\n      position: absolute;\n      top: calc(-1 * var(--gleap-margin-top));\n      left: 0px;\n      width: 100vw;\n      height: var(--gleap-margin-top);\n    }\n\n    @keyframes gleapSlideIn {\n      from {\n          top: calc(-1 * var(--gleap-margin-top));\n      }\n      to {\n          top: 10px;\n      }\n    }\n\n    .gleap-b-f .gleap-b {\n      position: fixed;\n      top: 10px;\n      animation: gleapSlideIn .25s ease-out forwards;\n      max-width: 800px;\n      width: calc(100% - 20px);\n      left: 50%;\n      z-index: ").concat(2147483699, ";\n      transform: translateX(-50%);\n      border-radius: ").concat(I, "px;\n      overflow: hidden;\n      box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15), 0px 5px 5px rgba(0, 0, 0, 0.05);\n    }\n\n    .gleap-b-shown .gleap-b {\n      display: block;\n    }\n\n    .gleap-image-view {\n      position: fixed;\n      top: 0px;\n      left: 0px;\n      width: 100vw;\n      height: 100vh;\n      z-index: ").concat(2147483699, ";\n      background-color: ").concat(f, "cc;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .gleap-image-view-image {\n      width: 90%;\n      height: auto;\n      max-width: 90%;\n      max-height: 90%;\n      object-fit: contain;\n    }\n\n    .gleap-image-view-close {\n      position: fixed;\n      top: 20px;\n      right: 20px;\n      width: 32px;\n      height: 32px;\n      opacity: 0.8;\n      z-index: ").concat(2147483740, ";\n      box-shadow: 0px 5px 18px rgba(0, 0, 0, 0.16);\n      cursor: pointer;\n    }\n\n    .gleap-image-view-close:hover {\n      opacity: 1;\n    }\n\n    .gleap-image-view-close svg path {\n      fill: ").concat(o, ";\n    }\n\n    [dir=rtl].gleap-frame-container {\n      right: auto;\n      left: ").concat(i, "px;\n      bottom: ").concat(61 + _l, 'px;\n    }\n\n    .gleap-frame-container--loading iframe {\n      opacity: 0;\n    }\n\n    .gleap-frame-container--loading::before {\n      content: " ";\n      position: fixed;\n      top: 0px;\n      left: 0px;\n      right: 0px;\n      height: 100%;\n      max-height: 380px;\n      background: linear-gradient(\n        130deg,\n        ').concat(m, " 0%,\n        ").concat(t, ' 100%\n      );\n    }\n    \n    .gleap-frame-container--loading::after {\n      content: " ";\n      position: fixed;\n      top: 0px;\n      left: 0px;\n      right: 0px;\n      height: 100%;\n      height: 100%;\n      max-height: 380px;\n      background: linear-gradient(\n        180deg,\n        transparent 60%,\n        ').concat(o, "1A 70%,\n        ").concat(o, " 100%\n      );\n    }\n\n    .gleap-frame-container--loading-nogradient::before {\n      max-height: 340px;\n      background: ").concat(t, " !important;\n    }\n\n    .gleap-frame-container--loading-nofade::after {\n      display: none !important;\n    }\n\n    .gleap-frame-container--survey {\n      bottom: ").concat(_l, "px !important;\n    }\n\n    .gleap-frame-container--extended {\n      max-width: 690px !important;\n    }\n\n    .gleap-frame-container--survey-full {\n      position: fixed;\n      top: 0 !important;\n      left: 0 !important;\n      bottom: 0 !important;\n      right: 0 !important;\n      width: 100vw !important;\n      max-width: 100vw !important;\n      height: 100vh !important;\n      background-color: rgba(0, 0, 0, 0.5);\n      backdrop-filter: blur(6px);\n      display: flex !important;\n      justify-content: center !important;\n      align-items: center !important;\n      max-height: 100vh !important;\n      border-radius: 0 !important;\n      animation-name: none !important;\n    }\n\n    .gleap-frame-container--survey-full .gleap-frame-container-inner {\n      max-width: 640px !important;\n      width: calc(100% - 24px);\n      border-radius: ").concat(C, "px;\n      overflow: hidden;\n    }\n\n    .gleap-frame-container--classic {\n      right: ").concat(i, "px;\n      bottom: ").concat(_l, "px;\n    }\n\n    [dir=rtl].gleap-frame-container--classic {\n      right: auto;\n      left: ").concat(i, "px;\n      bottom: ").concat(_l, "px;\n    }\n\n    .gleap-frame-container--no-button {\n      bottom: ").concat(_l, "px;\n    }\n\n    [dir=rtl].gleap-frame-container--classic-left {\n      bottom: ").concat(_l, "px;\n    }\n\n    .gleap-frame-container--classic-left {\n      right: auto;\n      left: ").concat(i, "px;\n      bottom: ").concat(_l, "px;\n    }\n\n    [dir=rtl].gleap-frame-container--classic-left {\n      left: auto;\n      right: ").concat(i, "px;\n      bottom: ").concat(_l, "px;\n    }\n\n    .gleap-frame-container--modern-left {\n      right: auto;\n      left: ").concat(i, "px;\n      bottom: ").concat(61 + _l, "px;\n    }\n\n    [dir=rtl].gleap-frame-container--modern-left {\n      left: auto;\n      right: ").concat(i, "px;\n      bottom: ").concat(61 + _l, "px;\n    }\n\n    .gleap-frame-container--animate {\n      pointer-events: auto !important;\n    }\n\n    @keyframes gleapFadeInUp {\n      from {\n          opacity: 0;\n          transform: translate3d(0, 100%, 0);\n      }\n      to {\n          opacity: 1;\n          transform: translate3d(0, 0, 0);\n      }\n    }\n\n    @keyframes gleapFadeInUpMobile {\n      from {\n          opacity: 0;\n          transform: translate3d(0, 10%, 0);\n      }\n      to {\n          opacity: 1;\n          transform: translate3d(0, 0, 0);\n      }\n    }\n\n    .gleap-notification-container {\n      position: fixed;\n      bottom: ").concat(S, "px;\n      right: ").concat(i, "px;\n      z-index: ").concat(2147483630, ";\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      width: 100%;\n      max-width: min(340px, 80vw);\n    }\n\n    .gleap-notification-container--left {\n      left: ").concat(4 + i, "px;\n      right: initial !important;\n    }\n\n    .gleap-notification-container--no-button {\n      bottom: ").concat(_l, "px;\n    }\n\n    .gleap-notification-item {\n      animation-duration: 0.7s;\n      animation-fill-mode: both;\n      animation-name: bbFadeInOpacity;\n    }\n\n    .gleap-notification-close {\n      border-radius: 100%;\n      width: 28px;\n      height: 28px;\n      background-color: ").concat(b, ";\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-bottom: 8px;\n      cursor: pointer;\n      visibility: hidden;\n      pointer-events: none;\n    }\n\n    .gleap-notification-container:hover .gleap-notification-close {\n      visibility: visible;\n      pointer-events: auto;\n      animation-duration: 0.7s;\n      animation-fill-mode: both;\n      animation-name: bbFadeInOpacity;\n    }\n\n    @media only screen and (max-width: 450px) {\n      .gleap-notification-close {\n        visibility: visible;\n        pointer-events: auto;\n        animation-duration: 0.7s;\n        animation-fill-mode: both;\n        animation-name: bbFadeInOpacity;\n      }\n    }\n\n    .gleap-notification-close svg {\n      width: 45%;\n      height: 45%;\n      object-fit: contain;\n      fill: ").concat(o, ";\n    }\n\n    .gleap-notification-item-news {\n      width: 100%;\n      cursor: pointer;\n    }\n\n    .gleap-notification-item-news-content {\n      align-items: flex-start;\n      display: flex;\n      flex-direction: column;\n      padding: 15px;\n    }\n\n    .gleap-notification-item-news-preview {\n      color: ").concat(b, ";\n      font-size: 15px;\n      line-height: 21px;\n      font-weight: 400;\n      overflow-wrap: break-word;\n      word-break: break-word;\n      display: block;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n\n    .gleap-notification-item-news-sender {\n      display: flex;\n      align-items: center;\n      color: ").concat(b, ";\n      font-size: 15px;\n      line-height: 21px;\n      font-weight: 400;\n    }\n\n    .gleap-notification-item-news-content-title {\n      color: ").concat(f, ";\n      font-size: 15px;\n      font-weight: 500;\n      line-height: 21px;\n      margin-bottom: 6px;\n      max-width: 100%;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n\n    .gleap-notification-item-news-sender img {\n      border-radius: 100%;\n      height: 20px;\n      margin-right: 8px;\n      object-fit: cover;\n      width: 20px;\n    }\n\n    .gleap-notification-item-news-container {\n      display: flex;\n      animation: fadeIn;\n      animation-duration: .45s;\n      background-color: ").concat(o, ";\n      border-radius: ").concat(b, ";\n      box-sizing: border-box;\n      cursor: pointer;\n      flex-direction: column;\n      overflow: hidden;\n      box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.2);\n      border-radius: ").concat(k, "px;\n      margin-bottom: 12px;\n    }\n\n    .gleap-notification-item-news-image {\n      background-color: ").concat(b, ";\n      height: 170px;\n      object-fit: cover;\n      width: 100%;\n    }\n\n    .gleap-notification-item-news:hover .gleap-notification-item-news-content-title {\n      color: ").concat(e, ";\n    }\n\n    .gleap-notification-item {\n      display: flex;\n      align-items: flex-end;\n      cursor: pointer;\n    }\n\n    .gleap-notification-item img {\n      width: 32px;\n      height: 32px;\n      min-width: 32px;\n      border-radius: 100%;\n      object-fit: cover;\n      margin-right: 8px;\n      margin-bottom: 12px;\n      cursor: pointer;\n    }\n\n    .gleap-notification-item-container {\n      box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.2);\n      border-radius: ").concat(k, "px;\n      border-bottom-left-radius: 0px;\n      padding: 20px;\n      background-color: ").concat(o, ";\n      margin-bottom: 12px;\n      cursor: pointer;\n      font-size: 15px;\n      line-height: 21px;\n      color: ").concat(f, ';\n      position: relative;\n    }\n\n    .gleap-notification-item-container::after {\n      content: " ";\n      position: absolute;\n      bottom: 0px;\n      width: 0px;\n      height: 0px;\n      left: -6px;\n      border-style: solid;\n      border-width: 0px 0px 10px 6px;\n      border-color: transparent transparent ').concat(o, ";\n    }\n\n    .gleap-notification-item-sender {\n      color: ").concat(b, ";\n      line-height: 20px;\n    }\n\n    .gleap-notification-item-content {\n      line-height: 20px;\n      color: ").concat(f, ";\n      margin-top: 4px;\n      min-width: min(200px, 50vw);\n      word-wrap: break-word;\n      word-break: break-word;\n    }\n\n    .gleap-frame-container-inner {\n      position: relative;\n      width: 100%;\n      height: calc(100vh - ").concat(130 + _l, "px);\n      max-height: ").concat(660, 'px;\n    }\n\n    .gleap-frame-container--survey .gleap-frame-container-inner {\n      height: calc(100vh - 40px);\n    }\n    \n    .gleap-frame-container-inner:before {\n      content: " ";\n      position: absolute;\n      width: 100%;\n      height: calc(100% - ').concat(C, "px);\n      top: ").concat(C, "px;\n      background-color: ").concat(o, ";\n      z-index: -1;\n    }\n    \n    .gleap-frame-container iframe {\n      height: 100% !important;\n      width: 100% !important;\n      max-width: 100% !important;\n      display: block;\n      pointer-events: auto;\n    }\n    \n    .gleap-frame-container--hidden {\n      display: none !important;\n      pointer-events: none;\n      animation: none !important;\n    }\n    \n    .bb-feedback-button {\n      margin: 0px;\n      position: fixed;\n      bottom: ").concat(_l, "px;\n      right: ").concat(i, "px;\n      border-radius: 30px;\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n      background-color: transparent;\n      color: #000000;\n      z-index: ").concat(2147483630, ";\n      box-sizing: border-box;\n      display: flex;\n      align-items: center;\n      padding: 0px;\n    }\n\n    [dir=rtl].bb-feedback-button {\n      bottom: ").concat(_l, "px;\n      right: auto;\n      left: ").concat(i, "px;\n    }\n    \n    .bb-feedback-button--bottomleft {\n      bottom: ").concat(_l, "px;\n      right: auto;\n      left: ").concat(i, "px;\n    }\n\n    [dir=rtl].bb-feedback-button--bottomleft {\n      bottom: ").concat(_l, "px;\n      right: ").concat(i, 'px;\n      left: auto;\n    }\n    \n    .bb-feedback-button--disabled {\n      display: none !important;\n    }\n\n    .bb-feedback-button--hidden {\n      display: none !important;\n    }\n    \n    .bb-feedback-button-text {\n      padding: 8px 12px;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      justify-content: center;\n      background-color: #fff;\n      border-radius: 8px;\n      box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.15);\n      position: relative;\n      z-index: 99;\n    }\n    \n    .bb-feedback-button-text:before {\n      content: "";\n      position: absolute;\n      box-shadow: rgba(0, 0, 0, 0.04) 6px 6px 5px;\n      transform: rotate(315deg);\n      bottom: 16px;\n      right: -4px;\n      border-width: 10px;\n      border-style: solid;\n      border-color: transparent #fff #fff transparent;\n    }\n    \n    .bb-feedback-button--bottomleft .bb-feedback-button-text:before {\n      display: none;\n    }\n    \n    .bb-feedback-button-text:after {\n      content: "";\n      position: absolute;\n      bottom: 12px;\n      right: 0px;\n      background-color: #fff;\n      width: 5px;\n      height: 30px;\n    }\n    \n    .bb-feedback-button-text-title {\n      font-family: sans-serif;\n      font-size: 14px;\n      color: #666;\n      line-height: 18px;\n      max-width: 220px;\n    }\n    \n    .bb-feedback-button-text-title b {\n      color: #000000;\n      font-weight: 600;\n    }\n\n    .bb-notification-bubble {\n      position: absolute;\n      top: -6px;\n      right: -6px;\n      min-width: 22px;\n      padding: 0px 4px;\n      height: 22px;\n      border-radius: 22px;\n      background-color: red;\n      color: #fff;\n      font-size: 12px;\n      font-family: sans-serif;\n      text-align: center;\n      line-height: 22px;\n    }\n\n    .bb-notification-bubble--hidden {\n      display: none;\n    }\n    \n    .bb-feedback-button-icon {\n      width: 48px;\n      height: 48px;\n      border-radius: 48px;\n      background-color: #485bff;\n      transition: box-shadow, transform 0.2s ease-in-out;\n      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 0px 20px rgba(0, 0, 0, 0.1);\n      position: relative;\n    }\n    \n    .bb-feedback-button-classic {\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n      top: 50%;\n      right: 0px;\n      position: fixed;\n      transform: rotate(-90deg) translate(50%, -50%);\n      transform-origin: 100% 50%;\n      padding: 9px 20px;\n      text-align: center;\n      background-color: #485bff;\n      border-top-left-radius: 8px;\n      border-top-right-radius: 8px;\n      font-family: sans-serif;\n      font-size: 16px;\n      color: #fff;\n      box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.25);\n    }\n\n    [dir=rtl].bb-feedback-button .bb-feedback-button-classic {\n      top: 50%;\n      left: 0px;\n      right: auto;\n      transform: rotate(90deg) translate(-50%, -100%);\n      transform-origin: 0% 0%;\n    }\n    \n    .bb-feedback-button-classic--left {\n      top: 50%;\n      left: 0px;\n      right: auto;\n      transform: rotate(90deg) translate(-50%, -100%);\n      transform-origin: 0% 0%;\n    }\n\n    [dir=rtl].bb-feedback-button .bb-feedback-button-classic--left {\n      top: 50%;\n      right: 0px;\n      left: auto;\n      transform: rotate(-90deg) translate(50%, -50%);\n      transform-origin: 100% 50%;\n    }\n    \n    .bb-feedback-button-classic--bottom {\n      top: auto;\n      bottom: 0px;\n      transform: none;\n      right: ').concat(i, "px;\n      left: auto;\n    }\n    \n    [dir=rtl].bb-feedback-button .bb-feedback-button-classic--bottom {\n      top: auto;\n      bottom: 0px;\n      transform: none;\n      left: ").concat(i, "px;\n      right: auto;\n    }\n\n    .bb-feedback-button--classic-button-style {\n      animation-duration: 0.2s;\n      animation-fill-mode: both;\n      animation-name: bbFadeInOpacity;\n    }\n    \n    .bb-feedback-button--open.bb-feedback-button--classic-button-style {\n      animation-duration: 0.2s;\n      animation-fill-mode: both;\n      animation-name: bbFadeOutRight;\n    }\n    \n    .bb-feedback-button .bb-logo-logo {\n      position: absolute;\n      width: 30px;\n      height: 30px;\n      top: 9px;\n      left: 9px;\n      object-fit: contain;\n      animation-duration: 0.3s;\n      animation-fill-mode: both;\n      animation-name: bbZoomIn;\n    }\n    \n    .bb-feedback-button .bb-logo-arrowdown {\n      position: absolute;\n      width: 14px;\n      height: 14px;\n      top: 17px;\n      left: 17px;\n      object-fit: contain;\n      animation-duration: 0.3s;\n      animation-fill-mode: both;\n    }\n    \n    .bb-feedback-button .bb-logo-arrowdown {\n      animation-name: bbZoomOut;\n    }\n    \n    .bb-feedback-button--open .bb-logo-arrowdown {\n      animation-name: bbZoomIn;\n    }\n    \n    .bb-feedback-button--open .bb-logo-logo {\n      animation-name: bbZoomOut;\n    }\n    \n    .bb-feedback-button-icon:hover {\n      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25), 0px 0px 20px rgba(0, 0, 0, 0.2);\n      transform: scale(1.1);\n    }\n    \n    .bb-feedback-button--open .bb-feedback-button-text {\n      animation-name: bbFadeOutDown;\n    }\n    \n    .bb-feedback-button--open .bb-feedback-button-icon {\n      display: flex;\n    }\n    \n    .bb-capture-svg {\n      position: fixed;\n      z-index: ").concat(2147483614, ";\n      top: 0px;\n      left: 0px;\n      right: 0px;\n      width: 100%;\n      height: 100%;\n      padding: 0px;\n      margin: 0px;\n      cursor: crosshair;\n    }\n\n    .bb-capture-svg--preview {\n      cursor: auto !important;\n    }\n    \n    .bb-rec-on-circle {\n      animation-name: bbRecIconFade;\n      animation-duration: 2s;\n      animation-iteration-count: infinite;\n      animation-direction: alternate;\n    }\n    \n    .bb-rec-on-cont {\n      animation-name: bbRecIconContFade;\n      animation-duration: 2s;\n      animation-iteration-count: infinite;\n      animation-direction: alternate;\n    }\n    \n    .bb-capture-editor-drag-info {\n      position: fixed;\n      top: -200px;\n      left: 0px;\n      z-index: ").concat(2147483616, ";\n      transition: opacity 0.3s ease-in-out;\n    }\n    \n    .bb-capture-editor-drag-info svg {\n      width: 24px;\n      height: 24px;\n    }\n    \n    .bb-capture-editor-borderlayer {\n      position: fixed;\n      top: 0px;\n      left: 0px;\n      width: 100vw;\n      height: 100vh;\n      border: 4px solid ").concat(e, ";\n      cursor: crosshair;\n      z-index: ").concat(2147483610, ";\n      box-sizing: border-box;\n      pointer-events: none;\n    }\n    \n    .bb-capture-editor-notrecording .bb-capture-editor-borderlayer {\n      background-color: rgba(0, 0, 0, 0.8);\n    }\n\n    .bb-capture-editor-recording .bb-capture-editor-borderlayer {\n      border: 4px solid #eb144c !important;\n    }\n    \n    .bb-capture-editor-recording .bb-capture-dismiss {\n      display: none;\n    }\n    \n    .bb-capture-editor-item-inactive {\n      opacity: 0.3;\n      cursor: not-allowed !important;\n    }\n    \n    .bb-capture-editor-notrecording .bb-capture-toolbar-drawingitem {\n      opacity: 0.3;\n      cursor: not-allowed !important;\n    }\n    \n    .bb-capture-editor-notrecording .bb-capture-editor-drag-info {\n      display: none;\n    }\n    \n    .bb-capture-editor-notrecording .bb-capture-svg {\n      pointer-events: none !important;\n    }\n    \n    .bb-capture-toolbar {\n      position: fixed;\n      top: 20px;\n      left: 50%;\n      transform: translateX(-50%);\n      z-index: ").concat(2147483618, ";\n      background-color: #fff;\n      padding: 5px;\n      display: flex;\n      align-items: center;\n      border-radius: 8px;\n      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 0px 20px rgba(0, 0, 0, 0.1);\n      transition: opacity 0.3s ease-in-out;\n    }\n    \n    .bb-capture-dismiss {\n      position: fixed;\n      top: 0px;\n      right: 0px;\n      z-index: ").concat(2147483618, ";\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n      width: 36px;\n      height: 36px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: ").concat(e, ";\n      border-bottom-left-radius: ").concat(x, "px;\n    }\n\n    [dir=rtl] .bb-capture-dismiss {\n      top: 0px;\n      left: 0px;\n      right: auto;\n      border-bottom-left-radius: 0px !important;\n      border-bottom-right-radius: ").concat(x, "px;\n    }\n    \n    .bb-capture-dismiss svg path {\n      fill: ").concat(d, ';\n    }\n    \n    .bb-capture-dismiss svg {\n      width: 20px;\n      height: 20px;\n      object-fit: contain;\n    }\n    \n    .bb-capture-button-next {\n      font-family: sans-serif;\n      box-sizing: border-box;\n      font-weight: 600;\n      text-align: center;\n      width: auto;\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n      margin: 0px;\n      line-height: 36px;\n      padding: 0px 12px;\n      font-size: 15px;\n      margin-left: 12px;\n    }\n\n    [dir=rtl].bb-capture-editor .bb-capture-button-next {\n      margin-left: auto;\n      margin-right: 12px;\n    }\n    \n    .bb-capture-toolbar-item-spacer {\n      width: 1px;\n      height: 38px;\n      min-width: 1px;\n      margin: 0px 5px;\n    }\n    \n    .bb-capture-toolbar-item {\n      width: 42px;\n      height: 38px;\n      min-width: 42px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n      position: relative;\n      margin-right: 5px;\n    }\n    \n    .bb-capture-toolbar-item svg {\n      width: 23px;\n      height: 23px;\n      object-fit: contain;\n    }\n    \n    .bb-capture-toolbar-item-selectedcolor {\n      border-radius: 100%;\n      width: 20px;\n      height: 20px;\n      background-color: #db4035;\n    }\n    \n    .bb-capture-toolbar-item[data-type="undo"] svg {\n      width: 18px;\n      height: 18px;\n    }\n    \n    .bb-capture-toolbar-item[data-active="true"] {\n      position: relative;\n    }\n    \n    .bb-capture-preview {\n      display: none;\n      background-color: rgba(0, 0, 0, 0.6);\n      position: fixed;\n      top: 0px;\n      left: 0px;\n      width: 100vw;\n      height: 100vh;\n      justify-content: center;\n      align-items: center;\n      z-index: ').concat(2147483620, ";\n    }\n    \n    .bb-capture-preview-inner {\n      background-color: #fff;\n      padding: 0px;\n      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 0px 20px rgba(0, 0, 0, 0.1);\n      border-radius: 8px;\n      flex-direction: column;\n      max-width: 640px;\n      width: 100%;\n      margin: 20px;\n    }\n    \n    .bb-capture-preview-inner video {\n      border-radius: 8px 8px 0px 0px;\n      display: block;\n      border: 0px;\n      outline: none;\n      width: 100%;\n      max-height: 60vh;\n    }\n    \n    .bb-capture-preview-buttons {\n      display: flex;\n      justify-content: space-between;\n      padding: 14px;\n    }\n    \n    .bb-capture-preview-retrybutton {\n      font-family: sans-serif;\n      border-radius: 21px;\n      box-sizing: border-box;\n      padding: 12px 26px;\n      font-size: 16px;\n      line-height: 19px;\n      font-weight: 600;\n      text-align: center;\n      margin-top: 0px;\n      margin-bottom: 0px;\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n    }\n    \n    .bb-capture-preview-sendbutton {\n      font-family: sans-serif;\n      border-radius: 21px;\n      box-sizing: border-box;\n      padding: 12px 26px;\n      font-size: 16px;\n      line-height: 19px;\n      font-weight: 600;\n      text-align: center;\n      margin-top: 0px;\n      margin-bottom: 0px;\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n    }\n    \n    .bb-capture-preview-retrybutton:hover,\n    .bb-capture-preview-sendbutton:hover {\n      opacity: 0.9;\n    }\n    \n    .bb-capture-toolbar-item-recording {\n      margin-right: 0px;\n    }\n    \n    .bb-capture-toolbar-item-recording svg {\n      width: 33px;\n      height: 33px;\n    }\n    \n    .bb-capture-toolbar-item-colorpicker {\n      position: fixed;\n      top: 70px;\n      left: 50%;\n      transform: translateX(-50%);\n      z-index: ").concat(2147483618, ';\n      background-color: #fff;\n      display: none;\n      padding: 10px;\n      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 0px 20px rgba(0, 0, 0, 0.1);\n      border-radius: 8px;\n    }\n    \n    .bb-capture-toolbar-item-color {\n      width: 20px;\n      height: 20px;\n      border-radius: 100%;\n      margin-right: 12px;\n      box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.15);\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n    }\n    \n    .bb-capture-toolbar-item-color:hover {\n      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);\n    }\n    \n    .bb-capture-toolbar-item-color:last-of-type {\n      margin-right: 0px;\n    }\n    \n    [dir=rtl].bb-capture-editor .bb-capture-toolbar-item-color {\n      margin-right: auto;\n      margin-left: 12px;\n    }\n    \n    [dir=rtl].bb-capture-editor .bb-capture-toolbar-item-color:last-of-type {\n      margin-right: auto;\n      margin-left: 0px;\n    }\n    \n    .bb-capture-toolbar-item-recording[data-active="true"] svg:first-of-type {\n      display: none;\n    }\n    \n    .bb-capture-toolbar-item-recording[data-active="true"] svg:nth-of-type(2) {\n      display: block;\n    }\n    \n    .bb-capture-toolbar-item-recording[data-active="false"] svg:first-of-type {\n      display: block;\n    }\n    \n    .bb-capture-toolbar-item-recording[data-active="false"] svg:nth-of-type(2) {\n      display: none;\n    }\n    \n    .bb-capture-toolbar-item--active {\n      background-color: #eee;\n    }\n    \n    .bb-capture-toolbar-item:hover svg {\n      opacity: 1;\n    }\n    \n    .bb-capture-toolbar-item--active {\n      background-color: #f8f8f8;\n    }\n    \n    .bb-capture-toolbar-item--active svg {\n      opacity: 1;\n    }\n    \n    .bb-capture-toolbar-item--inactivecross::before {\n      content: "";\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      height: 3px;\n      width: 26px;\n      margin: auto;\n      border-radius: 4px;\n      background-color: #e80000;\n      transform: rotate(45deg);\n    }\n    \n    .bb-capture-toolbar-item--inactivecross svg {\n      fill: #eee;\n    }\n    \n    .bb-capture-toolbar-item-timer {\n      text-align: left;\n      line-height: 32px;\n      font-size: 14px;\n      font-family: sans-serif;\n      margin: 5px;\n      min-width: 40px;\n      display: none;\n    }\n    \n    .bb-capture-toolbar-item .bb-tooltip {\n      background-color: #555;\n      color: #fff;\n      visibility: hidden;\n      font-size: 14px;\n      font-family: sans-serif;\n      text-align: center;\n      padding: 5px 10px;\n      position: absolute;\n      z-index: 1;\n      top: 45px;\n      left: 0px;\n      transform: translateX(calc(-50% + 21px));\n      opacity: 0;\n      transition: opacity 0.3s;\n      white-space: nowrap;\n    }\n    \n    .bb-capture-toolbar-item .bb-tooltip::after {\n      content: "";\n      position: absolute;\n      bottom: 100%;\n      left: 50%;\n      margin-left: -5px;\n      border-width: 5px;\n      border-style: solid;\n      transform: rotate(180deg);\n      border-color: #555 transparent transparent transparent;\n    }\n    \n    .bb-capture-toolbar-item:hover .bb-tooltip {\n      visibility: visible;\n      opacity: 1;\n    }\n    \n    .bb-capture-options {\n      display: none;\n    }\n    \n    .bb-capture-options--active {\n      display: flex;\n    }\n\n    @keyframes bbFadeOutRight {\n      from {\n        opacity: 1;\n      }\n    \n      to {\n        opacity: 0;\n      }\n    }\n    \n    @keyframes bbFadeOutDown {\n      from {\n        opacity: 1;\n      }\n    \n      to {\n        opacity: 0;\n        transform: translate3d(0, 100%, 0);\n      }\n    }\n    \n    @keyframes bbFadeInOpacity {\n      from {\n        opacity: 0;\n      }\n    \n      to {\n        opacity: 1;\n      }\n    }\n    \n    @keyframes bbZoomOut {\n      from {\n        opacity: 1;\n      }\n    \n      50% {\n        opacity: 0;\n        transform: scale3d(0.3, 0.3, 0.3);\n      }\n    \n      to {\n        opacity: 0;\n      }\n    }\n    \n    @keyframes bbZoomIn {\n      from {\n        opacity: 0;\n        transform: scale3d(0.3, 0.3, 0.3);\n      }\n    \n      50% {\n        opacity: 1;\n      }\n    }\n    \n    @keyframes bbRecIconContFade {\n      0% {\n        fill: #b10802;\n      }\n      50% {\n        fill: #ff0000;\n      }\n      100% {\n        fill: #b10802;\n      }\n    }  \n    .bb-capture-preview-retrybutton {\n      color: ').concat(f, ";\n      border-radius: ").concat(w, "px;\n      background-color: ").concat(v, ";\n    }\n    .bb-capture-preview-retrybutton:hover {\n      background-color: ").concat(y, ";\n    }\n    @keyframes bb-suc-fill {\n      100% {\n        box-shadow: inset 0px 0px 0px 30px ").concat(e, ";\n      }\n    }\n    .bb-capture-toolbar-item-spacer {\n      background-color: ").concat(v, ";\n    }\n    .bb-tooltip {\n      border-radius: ").concat(I, "px;\n    }\n    @keyframes bbRecIconFade {\n      0% {\n        fill: transparent;\n      }\n      50% {\n        fill: ").concat(y, ";\n      }\n      100% {\n        fill: transparent;\n      }\n    }\n    .bb-capture-preview-sendbutton {\n      color: ").concat(d, ";\n      background-color: ").concat(e, ";\n      border-radius: ").concat(w, "px;\n    }\n    .bb-capture-button-next {\n      color: ").concat(d, ";\n      background-color: ").concat(e, ";\n      border-radius: ").concat(x, "px;\n    }\n    .bb-capture-preview-inner {\n      background-color: ").concat(o, ";\n      border-radius: ").concat(I, "px;\n    }\n    .bb-capture-toolbar-item-timer {\n      color: ").concat(b, ";\n    }\n    .bb-svg-path {\n      fill: ").concat(f, ";\n    }\n    .bb-capture-toolbar-item {\n      border-radius: ").concat(I, "px;\n    }\n    .bb-capture-toolbar {\n      background-color: ").concat(o, ";\n      border-radius: ").concat(I, "px;\n    }\n    .bb-capture-toolbar-item-colorpicker {\n      background-color: ").concat(o, ";\n    }\n    .bb-capture-toolbar-item--active {\n      background-color: ").concat(v, ";\n    }\n    .bb-feedback-button-classic {\n      border-top-left-radius: ").concat(I, "px;\n      border-top-right-radius: ").concat(I, "px;\n    }\n    .bb-logo-logo--default path {\n      fill: ").concat(p, ";\n    }\n    .bb-logo-arrowdown {\n      fill: ").concat(p, ";\n    }\n    .bb-feedback-button-icon {\n        background-color: ").concat(n, ";\n    }\n    .bb-feedback-button-classic {\n      background-color: ").concat(n, ";\n      color: ").concat(p, ";\n    }\n\n    @media only screen and (max-width: 450px) {\n      .gleap-frame-container {\n        left: 0px;\n        right: 0px;\n        width: 100vw;\n        max-width: 100vw;\n        min-height: 100vh;\n        min-height: -webkit-fill-available;\n        top: 0px;\n        bottom: 0px;\n        border-radius: 0px;\n        animation-name: gleapFadeInUpMobile;\n      }\n\n      .gleap-frame-container-inner {\n        width: 100vw;\n        height: 100%;\n      }\n\n      .gleap-frame-container:not(.gleap-frame-container--survey):not(.gleap-frame-container--survey-full) .gleap-frame-container-inner {\n        max-height: initial !important;\n      }\n\n      .gleap-frame-container--survey {\n        height: auto !important;\n        top: initial !important;\n        bottom: 0px !important;\n        min-height: initial !important;\n      }\n\n      .gleap-frame-container--survey .gleap-frame-container-inner {\n        height: 100vh !important;\n      }\n\n      .bb-tooltip {\n        display: none !important;\n      }\n    \n      .bb-capture-toolbar-item-colorpicker {\n        top: 75px;\n      }\n    \n      .bb-capture-button-next {\n        margin-left: auto;\n      }\n    \n      .bb-capture-dismiss {\n        display: none;\n      }\n    \n      .bb-capture-toolbar {\n        top: 15px;\n        right: 15px;\n        left: 15px;\n        width: auto;\n        transform: none;\n      }\n    \n      .bb-capture-editor-drag-info {\n        display: none;\n      }\n    \n      .bb-capture-editor-borderlayer {\n        border-width: 4px;\n      }\n    }\n    \n    @media print {\n      .bb-feedback-button {\n        display: none !important;\n      }\n      \n      .gleap-frame-container {\n        display: none !important;\n      }\n    }\n    "),
          A = document.querySelector(".gleap-styles");
        A && A.remove();
        var T = document.createElement("style");
        T.innerHTML = L, T.className = "gleap-styles", document.body.appendChild(T);
      },
      u = function u(e, t) {
        return "button" === e ? '<svg class="bb-logo-logo bb-logo-logo--default" width="700px" height="700px" viewBox="0 0 700 700" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g transform="translate(77.000000, 119.000000)" fill="#FFFFFF" fill-rule="nonzero">\n            <path d="M476.856373,0 L68.122339,0 C30.601832,0 0,30.5935323 0,67.1461527 L0,372.655827 C0,410.166158 30.601832,439.80198 68.122339,439.80198 L170.305847,439.80198 L170.305847,528.23059 C170.305847,538.605788 182.280477,544.671288 190.657396,538.552581 L323.602398,438.844269 L476.877661,438.844269 C514.398168,438.844269 545,408.250737 545,371.698116 L545,67.1461527 C544.978712,30.5935323 515.28163,0 476.856373,0 Z"></path>\n        </g>\n    </g>\n</svg>' : "dismiss" === e ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M294.6 166.6L317.3 144 272 98.7l-22.6 22.6L160 210.7 70.6 121.4 48 98.7 2.7 144l22.6 22.6L114.7 256 25.4 345.4 2.7 368 48 413.3l22.6-22.6L160 301.3l89.4 89.4L272 413.3 317.3 368l-22.6-22.6L205.3 256l89.4-89.4z"/></svg>' : "blur" === e ? '<svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">\n <path class="bb-svg-path" d="m602.25 1200c238.2 0 435.95-193.26 435.95-435.95 0-269.66-220.23-615.73-435.95-764.05-220.23 161.8-440.45 485.39-440.45 764.05 0 242.7 197.75 435.95 440.45 435.95zm-260.68-382.02c0 112.36 89.887 206.74 206.74 206.74v62.922c-148.32 0-274.16-121.35-274.16-269.66z" fill="#333"/>\n</svg>' : "pen" === e ? '<svg width="1072px" height="1034px" viewBox="0 0 1072 1034" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g transform="translate(-907.000000, -217.000000)" fill-rule="nonzero">\n            <g transform="translate(907.268457, 217.009827)">\n                <g transform="translate(132.335119, 0.000000)" fill="#000" class="bb-svg-path">\n                    <path d="M20.3764235,730.530173 L10.1884235,720.342173 C-0.791576454,709.362173 -3.16357645,692.432173 4.37592355,678.858173 L83.1809235,537.018173 C71.7589235,502.979173 82.3098335,463.998173 112.254924,440.706173 L655.334924,18.3161733 C689.951924,-8.6058267 739.197924,-5.5388267 770.214924,25.4684733 L913.774924,169.028473 C944.782924,200.040473 947.848924,249.286473 920.927224,283.908473 L498.537224,826.988473 C496.322424,829.836173 493.935624,832.543173 491.384924,835.090073 C467.271924,859.207073 432.513924,866.195073 402.232924,856.063073 L260.382924,934.868073 C246.804924,942.407173 229.874924,940.036073 218.894924,929.055573 L208.706924,918.867573 L20.3764235,730.530173 Z M866.006424,241.190173 C871.393124,234.264373 870.779824,224.417173 864.576724,218.213173 L721.016724,74.6531733 C714.813624,68.4500733 704.965724,67.8367733 698.043724,73.2234733 L154.963724,495.613473 C147.381724,501.507973 146.018424,512.433473 151.912924,520.015473 C152.358234,520.585783 152.834804,521.128773 153.346524,521.636573 L417.586524,785.886573 C424.379524,792.675673 435.391524,792.675673 442.180524,785.886573 C442.692244,785.374853 443.168804,784.831873 443.610224,784.265473 L866.006424,241.190173 Z M342.796424,809.480173 L129.746424,596.430173 L77.9264235,689.707173 L249.516424,861.297173 L342.796424,809.480173 Z"></path>\n                </g>\n                <g transform="translate(-0.000000, 755.530173)" fill="#EB144C">\n                    <path d="M124.711543,0 L313.042043,188.3374 L233.288043,268.0914 C222.003043,279.3764 204.483043,281.5324 190.800043,273.3219 L16.8900429,168.9719 C-2.51595711,157.3309 -5.80895711,130.5499 10.1908429,114.5499 L124.711543,0 Z" class="bb-pen-tip"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>' : "rect" === e ? '<svg width="339px" height="241px" viewBox="0 0 339 241" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g transform="translate(-0.000865, 0.000000)" fill-rule="nonzero">\n            <g transform="translate(0.000865, 0.000000)" fill="#000000" class="bb-svg-path">\n                <path d="M339,0 L339,241 L0,241 L0,0 L339,0 Z M312.826351,26.168387 L26.1855674,26.168387 L26.1855674,214.41156 L312.826351,214.41156 L312.826351,26.168387 Z"></path>\n            </g>\n            <g transform="translate(0.000000, 83.206095)" fill="#EB144C" class="bb-pen-tip">\n                <path d="M0,0 L26.186,26.186 L26.1864325,131.205465 L131.204,131.205 L157.792,157.793 L0.000865118243,157.793905 L0,0 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>' : "pointer" === e ? '<svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">\n    <path d="m1050.7 508.95-225.94 157.5 160.31 160.31c4.4531 4.4531 6.9141 10.43 6.9141 16.758s-2.4609 12.305-6.9141 16.758l-126.09 126.09c-4.4531 4.4531-10.43 6.9141-16.758 6.9141-6.3281 0-12.188-2.4609-16.758-6.9141l-160.2-160.43-157.62 225.94c-3.3984 4.9219-9.0234 7.8516-14.883 7.8516-0.70313 0-1.5234 0-2.2266-0.11719-6.7969-0.82031-12.422-5.2734-14.766-11.719l-333.16-880.55c-2.5781-6.6797-0.9375-14.297 4.2188-19.336 5.0391-5.0391 12.656-6.6797 19.336-4.2188l880.66 333.05c6.3281 2.3438 10.781 8.0859 11.602 14.766 0.82031 6.7969-2.1094 13.359-7.7344 17.344z" fill="#333"/>\n   </svg>' : "clip" === e ? '<svg width="600px" height="1126px" viewBox="0 0 600 1126" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g transform="translate(-0.002000, 0.501000)" fill="#333333" fill-rule="nonzero">\n            <path d="M225.002,1124.999 C165.33,1124.999 108.102,1101.292 65.902,1059.097 C23.707,1016.902 5.68434189e-14,959.671 5.68434189e-14,899.997 L5.68434189e-14,299.997 C5.68434189e-14,220.431 31.605,144.127 87.867,87.867 C144.129,31.605 220.437,-4.26325641e-14 299.997,-4.26325641e-14 C379.557,-4.26325641e-14 455.867,31.605 512.127,87.867 C568.389,144.129 599.994,220.437 599.994,299.997 L599.994,1012.497 C599.994,1025.895 592.8456,1038.274 581.244,1044.974 C569.642,1051.6732 555.346,1051.6732 543.744,1044.974 C532.142,1038.2748 524.994,1025.896 524.994,1012.497 L524.994,299.997 C524.994,240.325 501.287,183.097 459.092,140.897 C416.897,98.702 359.666,74.995 299.992,74.995 C240.318,74.995 183.092,98.702 140.892,140.897 C98.697,183.092 74.99,240.323 74.99,299.997 L74.99,899.997 C74.99,953.587 103.58,1003.107 149.99,1029.897 C196.4,1056.694 253.58,1056.694 299.99,1029.897 C346.4,1003.104 374.99,953.585 374.99,899.997 L374.99,337.497 C374.99,310.704 360.697,285.942 337.49,272.544 C314.283,259.149 285.697,259.149 262.49,272.544 C239.283,285.942 224.99,310.704 224.99,337.497 L224.99,824.997 C224.99,838.395 217.8416,850.774 206.24,857.474 C194.638,864.1732 180.342,864.1732 168.74,857.474 C157.138,850.7748 149.99,838.396 149.99,824.997 L149.99,337.497 C149.99,283.907 178.58,234.387 224.99,207.597 C271.4,180.8 328.58,180.8 374.99,207.597 C421.4,234.39 449.99,283.909 449.99,337.497 L449.99,899.997 C449.99,959.669 426.283,1016.897 384.088,1059.097 C341.893,1101.292 284.662,1124.999 224.988,1124.999 L225.002,1124.999 Z" id="Path"></path>\n        </g>\n    </g>\n</svg>' : "mic" === e ? '<svg\n    width="1200pt"\n    height="1200pt"\n    version="1.1"\n    viewBox="0 0 1200 1200"\n    xmlns="http://www.w3.org/2000/svg"\n  >\n    <g class="bb-svg-path">\n      <path\n        d="m600 862.5c144.75 0 262.5-117.75 262.5-262.5v-300c0-144.75-117.75-262.5-262.5-262.5s-262.5 117.75-262.5 262.5v300c0 144.75 117.75 262.5 262.5 262.5z"\n      />\n      <path\n        d="m1012.5 600c0-20.707-16.793-37.5-37.5-37.5s-37.5 16.793-37.5 37.5c0 186.11-151.41 337.5-337.5 337.5s-337.5-151.39-337.5-337.5c0-20.707-16.793-37.5-37.5-37.5s-37.5 16.793-37.5 37.5c0 214.8 165.08 391.57 375 410.6v114.4c0 20.727 16.793 37.5 37.5 37.5s37.5-16.773 37.5-37.5v-114.4c209.92-19.031 375-195.8 375-410.6z"\n      />\n    </g>\n  </svg>' : "camera" === e ? '<svg width="1155px" height="1004px" viewBox="0 0 1155 1004" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g fill="#333333" fill-rule="nonzero">\n            <g transform="translate(128.324095, 0.000000)">\n                <path d="M42.7803063,0.00413459787 C31.4357421,0.00413459787 20.5549853,4.41399115 12.5336107,12.2572687 C4.51223664,20.1005462 0.00420584816,30.741831 0.00420584816,41.8370305 L0.00420584816,251.00151 C-0.156199045,262.200455 4.27736739,272.989996 12.315738,280.963903 C20.3585574,288.938257 31.3288589,293.431222 42.7803063,293.431222 C54.2317532,293.431222 65.2018267,288.938592 73.2448746,280.963903 C81.2832452,272.989549 85.7172445,262.200455 85.5564062,251.00151 L85.5564062,83.6699265 L256.660808,83.6699265 C268.112255,83.8267939 279.145066,79.4909873 287.298762,71.6298611 C295.452913,63.7643845 300.04718,53.0359758 300.04718,41.8370305 C300.04718,30.6380854 295.453255,19.9098998 287.298762,12.0441998 C279.144611,4.18307356 268.112255,-0.153157091 256.660808,0.00413459787 L42.7803063,0.00413459787 Z"></path>\n                <path d="M983.227131,710.59444 C971.895913,710.764382 961.099907,715.326799 953.20401,723.279287 C945.312674,731.227538 940.964345,741.91668 941.119476,752.99849 L941.119476,920.330075 L770.015075,920.330075 C758.563631,920.173205 747.530815,924.509015 739.377123,932.370139 C731.222968,940.235615 726.628705,950.964028 726.628705,962.16297 C726.628705,973.361918 731.222627,984.090105 739.377123,991.955802 C747.531272,999.816926 758.563631,1004.15316 770.015075,1003.99587 L983.895579,1003.99587 C995.24014,1003.99587 1006.1209,999.586011 1014.14227,991.742733 C1022.16365,983.899455 1026.67168,973.258169 1026.67168,962.16297 L1026.67168,752.99849 C1026.83208,741.690223 1022.30053,730.801401 1014.11489,722.812989 C1005.93394,714.825472 994.790363,710.415949 983.227131,710.59444 L983.227131,710.59444 Z"></path>\n                <path d="M983.227131,375.93127 C971.895913,376.101212 961.099907,380.66363 953.20401,388.61612 C945.312674,396.56437 940.964345,407.253512 941.119476,418.335325 L941.119476,585.66691 C940.959072,596.865853 945.39264,607.655394 953.431008,615.629303 C961.47383,623.603658 972.444131,628.096618 983.895579,628.096618 C995.347023,628.096618 1006.3171,623.603989 1014.36015,615.629303 C1022.39852,607.654947 1026.83251,596.865853 1026.67168,585.66691 L1026.67168,418.335325 C1026.83208,407.027056 1022.30053,396.138232 1014.11489,388.149822 C1005.93394,380.162305 994.790363,375.752783 983.227131,375.93127 L983.227131,375.93127 Z"></path>\n                <path d="M769.974012,0.00413459787 C758.522563,-0.152733184 747.489752,4.18307356 739.336055,12.0441998 C731.181906,19.9096767 726.587637,30.6380854 726.587637,41.8370305 C726.587637,53.0359758 731.181564,63.7641611 739.336055,71.6298611 C747.490209,79.4909873 758.522563,83.8272181 769.974012,83.6699265 L941.078414,83.6699265 L941.078414,251.00151 C940.918009,262.200455 945.351572,272.989996 953.389945,280.963903 C961.432763,288.938257 972.403063,293.431222 983.854512,293.431222 C995.30596,293.431222 1006.27603,288.938592 1014.31908,280.963903 C1022.35745,272.989549 1026.79145,262.200455 1026.63061,251.00151 L1026.63061,41.8370305 C1026.63061,30.7426118 1022.12133,20.1017733 1014.10121,12.2572687 C1006.08109,4.41276405 995.199876,0.00413459787 983.854512,0.00413459787 L769.974012,0.00413459787 Z"></path>\n                <path d="M427.765208,0.00413459787 C416.31376,-0.152733184 405.280949,4.18307356 397.127256,12.0441998 C388.973102,19.9096767 384.378838,30.6380854 384.378838,41.8370305 C384.378838,53.0359758 388.972761,63.7641611 397.127256,71.6298611 C405.281406,79.4909873 416.31376,83.8272181 427.765208,83.6699265 L598.86961,83.6699265 C610.321058,83.8267939 621.35387,79.4909873 629.507562,71.6298611 C637.661716,63.7643845 642.255985,53.0359758 642.255985,41.8370305 C642.255985,30.6380854 637.662058,19.9098998 629.507562,12.0441998 C621.353413,4.18307356 610.321058,-0.153157091 598.86961,0.00413459787 L427.765208,0.00413459787 Z"></path>\n            </g>\n            <g transform="translate(0.000000, 427.000000)">\n                <path d="M768.516184,22.1826583 C752.659627,13.73125 732.573775,13.73125 717.773442,24.29375 L562.379192,124.6375 L562.379192,31.6875 C562.379192,13.7330104 548.635081,0 530.666079,0 L31.7131123,0 C13.7441105,0 0,13.7330104 0,31.6875 L0,475.3125 C0,493.26699 13.7441105,507 31.7131123,507 L530.666079,507 C548.635081,507 562.379192,493.26699 562.379192,475.3125 L562.379192,382.3625 L717.773442,482.70625 C726.231681,487.9875 735.742444,491.157658 745.257258,491.157658 C753.715498,491.157658 761.113815,489.046567 769.572406,484.820862 C786.485185,475.313732 796,458.414612 796,439.400352 L796,68.6566021 C794.943601,48.5869719 785.428963,31.6878521 768.516184,22.1807219 L768.516184,22.1826583 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>' : "recorderon" === e ? '<svg width="1251px" height="1251px" viewBox="0 0 1251 1251" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g>\n            <circle fill="#E31810" cx="625.5" cy="625.5" r="625.5"></circle>\n            <circle fill="#F71008" cx="625" cy="625" r="507"></circle>\n            <g transform="translate(175.000000, 449.000000)" fill="#FFFFFF" fill-rule="nonzero">\n                <path d="M0,347.097493 L0,4.90250696 L135.528311,4.90250696 C161.471024,4.90250696 183.639743,9.49741034 202.034469,18.6872171 C220.429194,27.8770239 234.46286,40.8541449 244.135466,57.6185803 C253.808072,74.3830156 258.644376,94.0714804 258.644376,116.683975 C258.644376,139.40786 253.724206,158.929238 243.883867,175.248107 C234.043527,191.566976 219.814173,204.070682 201.195803,212.759227 C182.577434,221.447772 160.073248,225.792044 133.683247,225.792044 L42.9396629,225.792044 L42.9396629,167.64563 L121.941933,167.64563 C135.807866,167.64563 147.325536,165.751973 156.494943,161.964659 C165.66435,158.177344 172.51345,152.496373 177.042243,144.921744 C181.571035,137.347116 183.835432,127.934526 183.835432,116.683975 C183.835432,105.322032 181.571035,95.7423543 177.042243,87.9449425 C172.51345,80.1475308 165.636395,74.2159282 156.411077,70.1501349 C147.185759,66.0843416 135.584222,64.051445 121.606467,64.051445 L72.6284142,64.051445 L72.6284142,347.097493 L0,347.097493 Z M185.512762,191.37204 L270.888889,347.097493 L190.712487,347.097493 L107.181424,191.37204 L185.512762,191.37204 Z"></path>\n                <polygon points="309.166667 347.097493 309.166667 4.90250696 540.126846 4.90250696 540.126846 64.5527072 381.634607 64.5527072 381.634607 146.091356 528.244113 146.091356 528.244113 205.741556 381.634607 205.741556 381.634607 287.447293 540.796296 287.447293 540.796296 347.097493"></polygon>\n                <path d="M901,124.638783 L827.757943,124.638783 C826.420189,115.158428 823.68894,106.709759 819.564197,99.2927757 C815.439454,91.8757921 810.144176,85.5462611 803.678363,80.3041825 C797.212549,75.0621039 789.77129,71.0468948 781.354585,68.2585551 C772.93788,65.4702155 763.824427,64.0760456 754.014228,64.0760456 C736.288981,64.0760456 720.849065,68.4537389 707.69448,77.2091255 C694.539894,85.964512 684.339516,98.6793409 677.093346,115.353612 C669.847176,132.027883 666.224091,152.243346 666.224091,176 C666.224091,200.425856 669.875046,220.948035 677.176956,237.56654 C684.478866,254.185044 694.707113,266.732573 707.861699,275.209125 C721.016285,283.685678 736.233242,287.923954 753.51257,287.923954 C763.21129,287.923954 772.213263,286.641318 780.518488,284.076046 C788.823714,281.510773 796.209233,277.746515 802.675047,272.78327 C809.14086,267.820025 814.519748,261.769328 818.81171,254.631179 C823.103672,247.493029 826.08575,239.351077 827.757943,230.205323 L901,230.539924 C899.104848,246.26616 894.394837,261.406844 886.869968,275.961977 C879.3451,290.51711 869.256201,303.510773 856.603274,314.942966 C843.950346,326.375158 828.900608,335.409379 811.45406,342.045627 C794.007513,348.681876 774.303504,352 752.342035,352 C721.796641,352 694.512024,345.084918 670.488184,331.254753 C646.464343,317.424588 627.512821,297.404309 613.633619,271.193916 C599.754416,244.983523 592.814815,213.252218 592.814815,176 C592.814815,138.636248 599.838026,106.849176 613.884448,80.6387833 C627.93087,54.4283904 646.993871,34.4359949 671.073451,20.661597 C695.153031,6.88719899 722.242559,0 752.342035,0 C772.185393,0 790.607387,2.78833967 807.608016,8.36501901 C824.608646,13.9416984 839.686254,22.0557668 852.840839,32.7072243 C865.995425,43.3586819 876.72533,56.3802281 885.030556,71.7718631 C893.335782,87.1634981 898.65893,104.785805 901,124.638783 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>' : "recorderoff" === e ? '<svg width="1251px" height="1251px" viewBox="0 0 1251 1251" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n          <g class="bb-rec-on-circle" fill="#EEEEEE" fill-rule="nonzero">\n              <path d="M625.5,0 C970.954111,0 1251,280.045889 1251,625.5 C1251,970.954111 970.954111,1251 625.5,1251 C280.045889,1251 0,970.954111 0,625.5 C0,280.045889 280.045889,0 625.5,0 Z M626,124 C348.753056,124 124,348.753056 124,626 C124,903.246944 348.753056,1128 626,1128 C903.246944,1128 1128,903.246944 1128,626 C1128,348.753056 903.246944,124 626,124 Z"></path>\n          </g>\n          <g class="bb-rec-on-cont" fill="#E31810" transform="translate(86.000000, 86.000000)" fill-rule="nonzero">\n              <path d="M540,0 C241.2,0 0,241.2 0,540 C0,838.8 241.2,1080 540,1080 C838.8,1080 1080,838.8 1080,540 C1080,241.2 838.8,0 540,0 Z M777.6,741.6 C777.6,761.998 761.998,777.6 741.6,777.6 L338.4,777.6 C318.002,777.6 302.4,761.998 302.4,741.6 L302.4,338.4 C302.4,318.002 318.002,302.4 338.4,302.4 L741.6,302.4 C761.998,302.4 777.6,318.002 777.6,338.4 L777.6,741.6 Z"></path>\n          </g>\n      </g>\n  </svg>' : "arrowdown" === e ? '<svg class="bb-logo-arrowdown" fill="'.concat(t, '" width="100pt" height="100pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">\n    <path d="m50 77.637c-1.3477 0-2.6953-0.51562-3.7266-1.543l-44.73-44.73c-2.0586-2.0586-2.0586-5.3945 0-7.4531 2.0586-2.0586 5.3945-2.0586 7.4531 0l41.004 41 41.004-41c2.0586-2.0586 5.3945-2.0586 7.4531 0 2.0586 2.0586 2.0586 5.3945 0 7.4531l-44.73 44.727c-1.0312 1.0312-2.3789 1.5469-3.7266 1.5469z"/>\n   </svg>') : "arrowleft" === e ? '<svg fill="'.concat(t, '" width="100pt" height="100pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">\n    <path d="m70.988 1.6211c2.1875-2.168 5.7344-2.168 7.9297 0 2.1836 2.168 2.1836 5.7227 0 7.8906l-46.016 40.445 46.016 40.5c2.1836 2.168 2.1836 5.668 0 7.8906-2.1953 2.168-5.7383 2.168-7.9297 0l-50.039-44.109c-1.168-1.168-1.668-2.7227-1.5898-4.2773-0.078125-1.5 0.42188-3.0547 1.5898-4.2227l50.039-44.109z" fill-rule="evenodd"/>\n   </svg>') : "close" === e ? '<svg fill="'.concat(t, '" width="100pt" height="100pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">\n    <path d="m72.812 33.02l-5.832-5.832-16.98 16.875-16.98-16.875-5.832 5.832 16.875 16.98-16.875 16.98 5.832 5.832 16.98-16.875 16.98 16.875 5.832-5.832-16.875-16.98z"/>\n   </svg>') : "undo" === e ? '<svg width="62px" height="60px" viewBox="0 0 62 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n      <g class="bb-svg-path" transform="translate(-0.000500, 0.001926)" fill-rule="nonzero">\n        <path d="M28.0005,51.6270739 C24.9653,51.0684839 22.0825,49.8731739 19.5396,48.1192739 L13.8208,53.8380739 C17.9536,57.0060739 22.8403,59.0333739 28.0008,59.7286739 L28.0005,51.6270739 Z" id="Path"></path>\n        <path d="M2.2705,33.9980739 C2.96581,39.1582739 4.9932,44.0450739 8.1611,48.1780739 L13.8799,42.4592739 C12.126,39.9162739 10.9307,37.0334739 10.3721,33.9983739 L2.2705,33.9980739 Z" id="Path"></path>\n        <path d="M61.7305,33.9980739 L53.6289,33.9980739 C53.07031,37.0332739 51.875,39.9160739 50.1211,42.4589739 L55.8399,48.1777739 C59.0079,44.0449739 61.0352,39.1582739 61.7305,33.9977739 L61.7305,33.9980739 Z" id="Path"></path>\n        <path d="M4.0005,24.9980739 L24.0005,24.9980739 L24.0005,16.9980739 L14.27,16.9980739 C17.6762,12.3613739 22.7622,9.24417393 28.442,8.31057393 C34.1178,7.38088393 39.934,8.70901393 44.645,12.0175739 C49.352,15.3222739 52.5786,20.3417739 53.6294,25.9975739 L61.731,25.9975739 C60.6646,18.0834739 56.4888,10.9235739 50.129,6.09957393 C43.7657,1.27147393 35.746,-0.818426068 27.836,0.290973932 C19.9298,1.39647393 12.793,5.61127393 8,11.9979739 L8,0.997973932 L-3.55271368e-15,0.997973932 L-3.55271368e-15,20.9979739 C-3.55271368e-15,22.0604739 0.42188,23.0760739 1.1719,23.8260739 C1.92192,24.5760739 2.9375,24.9979739 4,24.9979739 L4.0005,24.9980739 Z" id="Path"></path>\n        <path d="M36.0005,51.6270739 L36.0005,59.7286739 C41.1607,59.0333639 46.0475,57.0059739 50.1805,53.8380739 L44.4617,48.1192739 C41.9187,49.8731739 39.0359,51.0684739 36.0008,51.6270739 L36.0005,51.6270739 Z" id="Path"></path>\n      </g>\n    </g>\n  </svg>' : "";
      };
    function d(e) {
      return (d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function p(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function f(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var h = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), f(this, "startTimestamp", Date.now()), f(this, "requestId", 0), f(this, "requests", {}), f(this, "externalRequests", []), f(this, "maxRequests", 30), f(this, "filters", []), f(this, "defaultBlacklist", ["gleap.io"]), f(this, "blacklist", []), f(this, "initialized", !1), f(this, "stopped", !1), f(this, "loadAllResources", !1);
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "setLoadAllResources",
        value: function value(e) {
          this.loadAllResources = e;
        }
      }, {
        key: "isContentTypeSupported",
        value: function value(e) {
          if ("string" != typeof e) return !1;
          if ("" === e) return !0;
          e = e.toLocaleLowerCase();
          for (var t = ["text/", "xml", "json"], n = 0; n < t.length; n++) {
            if (e.includes(t[n])) return !0;
          }
          return !1;
        }
      }, {
        key: "getRequests",
        value: function value() {
          var e = JSON.parse(JSON.stringify(Object.values(this.requests)));
          if (this.externalRequests && this.externalRequests.length > 0 && (e = e.concat(this.externalRequests)), this.filters && this.filters.length > 0) for (var t = 0; t < e.length; t++) {
            var n = e[t];
            if (n && n.request && n.request.headers) for (var a = 0; a < this.filters.length; a++) {
              delete n.request.headers[this.filters[a]];
            }
            if (n && n.request && n.request.payload) {
              var r = n.request.payload;
              try {
                r = JSON.parse(n.request.payload);
              } catch (l) {}
              if (r) {
                for (a = 0; a < this.filters.length; a++) {
                  delete r[this.filters[a]];
                }
                n.request.payload = JSON.stringify(r);
              }
            }
            if (n && n.response && n.response.responseText) try {
              var o = JSON.parse(n.response.responseText);
              for (a = 0; a < this.filters.length; a++) {
                delete o[this.filters[a]];
              }
              n.response.responseText = JSON.stringify(o);
            } catch (l) {}
          }
          try {
            if ("undefined" != typeof window && window.performance) {
              var i = window.performance.getEntriesByType("resource");
              for (t = 0; t < i.length; t++) {
                var s = i[t];
                s && s.name && (this.loadAllResources || ["xmlhttprequest", "fetch"].indexOf(s.initiatorType) > -1) && !e.find(function (e) {
                  return e.url === s.name;
                }) && e.push({
                  type: "RESOURCE",
                  date: new Date(this.startTimestamp + s.startTime),
                  url: s.name,
                  duration: Math.round(s.duration),
                  initiatorType: s.initiatorType
                });
              }
            }
          } catch (u) {}
          var c = this.blacklist.concat(this.defaultBlacklist);
          return c && c.length > 0 && (e = e.filter(function (e) {
            for (var t = 0; t < c.length; t++) {
              if (e.url && e.url.includes(c[t])) return !1;
            }
            return !0;
          })), e;
        }
      }, {
        key: "setMaxRequests",
        value: function value(e) {
          e > 70 && (e = 70), this.maxRequests = e;
        }
      }, {
        key: "setStopped",
        value: function value(e) {
          this.stopped = e;
        }
      }, {
        key: "setFilters",
        value: function value(e) {
          this.filters = e || [];
        }
      }, {
        key: "setBlacklist",
        value: function value(e) {
          this.blacklist = e || [];
        }
      }, {
        key: "cleanRequests",
        value: function value() {
          var e = Object.keys(this.requests);
          if (e.length > this.maxRequests) for (var t = e.slice(0, e.length - this.maxRequests), n = 0; n < t.length; n++) {
            delete this.requests[t[n]];
          }
        }
      }, {
        key: "calcRequestTime",
        value: function value(e) {
          if (e && this.requests && this.requests[e]) {
            var t = this.requests[e].date;
            t && (this.requests[e].duration = new Date().getTime() - t.getTime());
          }
        }
      }, {
        key: "getTextContentSize",
        value: function value(e) {
          return new TextEncoder().encode(e).length / 1024 / 1024;
        }
      }, {
        key: "cleanupContentSize",
        value: function value(e) {
          return this.getTextContentSize(e) > .15 ? "<content_too_large>" : e;
        }
      }, {
        key: "cleanupPayload",
        value: function value(e) {
          if (null == e) return "{}";
          try {
            if (void 0 !== ("undefined" == typeof TextDecoder ? "undefined" : d(TextDecoder)) && ArrayBuffer.isView(e)) return new TextDecoder().decode(e);
          } catch (t) {}
          return e;
        }
      }, {
        key: "preparePayload",
        value: function value(e) {
          var t = this.cleanupPayload(e);
          return this.cleanupContentSize(t);
        }
      }, {
        key: "start",
        value: function value() {
          var e = this;
          if (!this.initialized) {
            this.initialized = !0;
            var t = this;
            this.interceptNetworkRequests({
              onFetch: function onFetch(n, a) {
                if (!e.stopped && a && e.requests) {
                  if (n.length > 0 && void 0 !== n[0] && void 0 !== n[0].url) e.requests[a] = {
                    url: n[0].url,
                    date: new Date(),
                    request: {
                      payload: "",
                      headers: void 0 !== n[0].headers ? Object.fromEntries(n[0].headers.entries()) : {}
                    },
                    type: void 0 !== n[0].method ? n[0].method : ""
                  };else if (n.length >= 2 && n[1]) {
                    var r = n[1] && n[1].method ? n[1].method : "GET";
                    e.requests[a] = {
                      request: {
                        payload: t.preparePayload(n[1].body),
                        headers: n[1].headers
                      },
                      type: r,
                      url: n[0],
                      date: new Date()
                    };
                  } else e.requests[a] = {
                    url: n[0],
                    date: new Date()
                  };
                  e.cleanRequests();
                }
              },
              onFetchLoad: function onFetchLoad(n, a) {
                if (!e.stopped && a && e.requests && e.requests[a]) {
                  try {
                    e.requests[a].success = !0, e.requests[a].response = {
                      status: n.status,
                      statusText: "",
                      responseText: "<request_still_open>"
                    }, e.calcRequestTime(a);
                  } catch (o) {}
                  try {
                    var r = "";
                    n.headers && void 0 !== n.headers.get && (r = n.headers.get("content-type")), e.isContentTypeSupported(r) ? n.text().then(function (r) {
                      e.requests[a] && (e.requests[a].success = !0, e.requests[a].response = {
                        status: n.status,
                        statusText: n.statusText,
                        responseText: t.cleanupContentSize(r)
                      }), e.calcRequestTime(a), e.cleanRequests();
                    }).catch(function (t) {
                      e.cleanRequests();
                    }) : (e.requests[a] && (e.requests[a].success = !0, e.requests[a].response = {
                      status: n.status,
                      statusText: n.statusText,
                      responseText: "<content_type_not_supported>"
                    }), e.calcRequestTime(a), e.cleanRequests());
                  } catch (o) {}
                }
              },
              onFetchFailed: function onFetchFailed(t, n) {
                !e.stopped && n && e.requests && e.requests[n] && (e.requests[n].success = !1, e.calcRequestTime(n), e.cleanRequests());
              },
              onOpen: function onOpen(t, n) {
                e.stopped || (t && t.bbRequestId && n.length >= 2 && e.requests && (e.requests[t.bbRequestId] = {
                  type: n[0],
                  url: n[1],
                  date: new Date()
                }), e.cleanRequests());
              },
              onSend: function onSend(t, n) {
                e.stopped || (t && t.bbRequestId && e.requests && e.requests[t.bbRequestId] && (e.requests[t.bbRequestId].request = {
                  payload: e.preparePayload(n.length > 0 ? n[0] : "{}"),
                  headers: t.requestHeaders
                }), e.cleanRequests());
              },
              onError: function onError(t, n) {
                !e.stopped && e.requests && t && t.currentTarget && t.currentTarget.bbRequestId && e.requests[t.currentTarget.bbRequestId] && (e.requests[t.currentTarget.bbRequestId].success = !1, e.calcRequestTime(t.bbRequestId)), e.cleanRequests();
              },
              onLoad: function onLoad(t, n) {
                if (!e.stopped) {
                  if (t && t.currentTarget && t.currentTarget.bbRequestId && e.requests && e.requests[t.currentTarget.bbRequestId]) {
                    var a = t.currentTarget,
                      r = a.responseType,
                      o = "<" + r + ">";
                    "" !== r && "text" !== r || (o = e.cleanupContentSize(a.responseText)), e.requests[a.bbRequestId].success = !0, e.requests[a.bbRequestId].response = {
                      status: a.status,
                      statusText: a.statusText,
                      responseText: o
                    }, e.calcRequestTime(a.bbRequestId);
                  }
                  e.cleanRequests();
                }
              }
            });
          }
        }
      }, {
        key: "interceptNetworkRequests",
        value: function value(e) {
          var t,
            n = this,
            a = XMLHttpRequest.prototype.open,
            r = XMLHttpRequest.prototype.send;
          return void 0 === XMLHttpRequest.prototype.gleapSetRequestHeader && (XMLHttpRequest.prototype.gleapSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader), XMLHttpRequest.prototype.gleapSetRequestHeader && (XMLHttpRequest.prototype.setRequestHeader = function (e, t) {
            this.requestHeaders || (this.requestHeaders = {}), this.requestHeaders && this.requestHeaders.hasOwnProperty(e) || (this.requestHeaders[e] || (this.requestHeaders[e] = []), this.requestHeaders[e].push(t), this.gleapSetRequestHeader(e, t));
          }), XMLHttpRequest.prototype.open = function () {
            return this.bbRequestId = ++n.requestId, e.onOpen && e.onOpen(this, arguments), e.onLoad && this.addEventListener("load", e.onLoad.bind(e)), e.onError && this.addEventListener("error", e.onError.bind(e)), a.apply(this, arguments);
          }, XMLHttpRequest.prototype.send = function () {
            return e.onSend && e.onSend(this, arguments), r.apply(this, arguments);
          }, window.fetch && (t = window.fetch, window.fetch = function () {
            var a = ++n.requestId;
            return e.onFetch(arguments, a), t.apply(this, arguments).then(function (t) {
              if (t && "function" == typeof t.clone) {
                var n = t.clone();
                e.onFetchLoad(n, a);
              }
              return t;
            }).catch(function (t) {
              throw e.onFetchFailed(t, a), t;
            });
          }), e;
        }
      }, {
        key: "blobToTextPromise",
        value: function value(e) {
          return new Promise(function (t, n) {
            var a = new FileReader();
            a.onload = function (e) {
              e && e.target && e.target.result ? t(e.target.result) : n();
            }, a.onerror = function (e) {
              n(e);
            }, a.readAsText(e);
          });
        }
      }]) && p(t.prototype, n), a && p(t, a), e;
    }();
    f(h, "instance", void 0);
    var g = h;
    var m = function m() {
        return !(!/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) && !/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)));
      },
      b = function b(e) {
        if ("string" == typeof e || e instanceof String) try {
          return JSON.parse(e);
        } catch (t) {
          return {};
        }
        return e;
      },
      v = function v(e, t) {
        return e.length > t ? e.slice(0, t) + "..." : e;
      },
      y = function y(e) {
        try {
          var t = e.split("."),
            n = !1,
            a = t[t.length - 2];
          return "co" !== a && "com" !== a && "gv" !== a && "ac" !== a && "edu" !== a && "gov" !== a && "mil" !== a && "net" !== a && "org" !== a || (n = !0), (t = t.slice(n ? -3 : -2)).join(".");
        } catch (r) {}
        return e;
      },
      w = function w(e) {
        try {
          var t = localStorage.getItem("gleap-widget-".concat(e));
          if (t) return JSON.parse(t);
        } catch (n) {}
        return null;
      },
      C = function C(e, t) {
        var n = "gleap-widget-".concat(e);
        if (t) try {
          localStorage.setItem(n, JSON.stringify(t));
        } catch (a) {} else localStorage.removeItem(n);
      },
      k = function k(e) {
        try {
          for (var t = e + "=", n = document.cookie.split(";"), a = 0; a < n.length; a++) {
            for (var r = n[a]; " " == r.charAt(0);) {
              r = r.substring(1, r.length);
            }
            if (0 == r.indexOf(t)) return r.substring(t.length, r.length);
          }
        } catch (o) {}
        return null;
      },
      I = function I(e) {
        try {
          var t = y(window.location.host.split(":")[0]);
          document.cookie = e + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain=" + t;
        } catch (n) {}
      },
      x = function x(e) {
        "complete" === document.readyState || "loaded" === document.readyState || "interactive" === document.readyState ? e() : document.addEventListener("DOMContentLoaded", function () {
          e();
        });
      };
    function S(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        t && (a = a.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, a);
      }
      return n;
    }
    function L(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? S(Object(n), !0).forEach(function (t) {
          T(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function A(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function T(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var M = function () {
      function e() {
        var t = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), T(this, "apiUrl", "https://api.gleap.io"), T(this, "sdkKey", null), T(this, "updatingSession", !1), T(this, "useCookies", !0), T(this, "session", {
          gleapId: null,
          gleapHash: null,
          name: "",
          email: "",
          userId: "",
          phone: "",
          value: 0
        }), T(this, "ready", !1), T(this, "onSessionReadyListener", []), T(this, "setOnSessionReady", function (e) {
          t.ready ? e() : t.onSessionReadyListener.push(e);
        }), T(this, "injectSession", function (e) {
          e && t.session && (e.setRequestHeader("Api-Token", t.sdkKey), e.setRequestHeader("Gleap-Id", t.session.gleapId), e.setRequestHeader("Gleap-Hash", t.session.gleapHash));
        }), T(this, "clearSession", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          t.session && t.session.gleapHash && Ie.notifyEvent("unregister-pushmessage-group", "gleapuser-".concat(t.session.gleapHash));
          try {
            C("session-".concat(t.sdkKey), null);
          } catch (r) {}
          if (t.useCookies) try {
            I("session-".concat(t.sdkKey));
          } catch (r) {}
          if (t.ready = !1, t.session = {
            gleapId: null,
            gleapHash: null,
            name: "",
            email: "",
            userId: "",
            phone: "",
            value: 0
          }, re.getInstance().sendMessage({
            name: "session-cleared"
          }, !0), ct.getInstance().clearAllNotifications(!1), ct.getInstance().setNotificationCount(0), n && !isNaN(e)) {
            var a = 10 * Math.pow(e, 2);
            setTimeout(function () {
              t.startSession(e + 1);
            }, 1e3 * a);
          }
        }), T(this, "validateSession", function (e) {
          e && e.gleapId && (t.session && t.session.gleapHash && Ie.notifyEvent("unregister-pushmessage-group", "gleapuser-".concat(t.session.gleapHash)), C("session-".concat(t.sdkKey), e), t.useCookies && function (e, t, n) {
            try {
              var a = "";
              if (n) {
                var r = new Date();
                r.setTime(r.getTime() + 24 * n * 60 * 60 * 1e3), a = "; expires=" + r.toUTCString();
              }
              var o = y(window.location.host.split(":")[0]);
              document.cookie = e + "=" + (t || "") + a + "; path=/; domain=" + o;
            } catch (i) {}
          }("session-".concat(t.sdkKey), encodeURIComponent(JSON.stringify(e)), 365), t.session = e, t.ready = !0, t.session && t.session.gleapHash && Ie.notifyEvent("register-pushmessage-group", "gleapuser-".concat(t.session.gleapHash)), t.notifySessionReady());
        }), T(this, "startSession", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
          try {
            if (t.useCookies) {
              var n = k("session-".concat(t.sdkKey));
              if (n) {
                var a = JSON.parse(decodeURIComponent(n));
                t.validateSession(a);
              }
            }
          } catch (s) {}
          if (!(t.session && t.session.gleapId && t.session.gleapId.length > 0)) {
            var r = w("session-".concat(t.sdkKey));
            r && t.validateSession(r);
          }
          var o = t,
            i = new XMLHttpRequest();
          i.open("POST", o.apiUrl + "/sessions"), i.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), i.setRequestHeader("Api-Token", o.sdkKey);
          try {
            t.session && t.session.gleapId && t.session.gleapHash && (i.setRequestHeader("Gleap-Id", t.session.gleapId), i.setRequestHeader("Gleap-Hash", t.session.gleapHash));
          } catch (s) {}
          i.onreadystatechange = function (t) {
            if (4 === i.readyState) if (200 === i.status || 201 === i.status) try {
              var n = JSON.parse(i.responseText);
              o.validateSession(n), R.getInstance().restart();
            } catch (s) {} else 429 !== i.status && o.clearSession(e, !0);
          }, i.send(JSON.stringify({
            lang: $e.getInstance().getActiveLanguage()
          }));
        }), T(this, "checkIfSessionNeedsUpdate", function (e, n) {
          if (!t.session || !t.session.userId || !e) return !0;
          try {
            if (t.session.userId.toString() !== e.toString()) return !0;
          } catch (i) {}
          if (n) for (var a = Object.keys(n), r = 0; r < a.length; r++) {
            var o = a[r];
            if (JSON.stringify(t.session[o]) !== JSON.stringify(n[o]) && (!t.session.customData || JSON.stringify(t.session.customData[o]) !== JSON.stringify(n[o]))) return !0;
          }
          return !1;
        }), T(this, "identifySession", function (e, n, a) {
          if (t.checkIfSessionNeedsUpdate(e, n)) {
            var r = t;
            return new Promise(function (o, i) {
              t.setOnSessionReady(function () {
                if (!r.session.gleapId || !r.session.gleapHash) return i("Session not ready yet.");
                var t = new XMLHttpRequest();
                t.open("POST", r.apiUrl + "/sessions/identify"), t.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), t.setRequestHeader("Api-Token", r.sdkKey);
                try {
                  t.setRequestHeader("Gleap-Id", r.session.gleapId), t.setRequestHeader("Gleap-Hash", r.session.gleapHash);
                } catch (c) {}
                t.onerror = function () {
                  i();
                }, t.onreadystatechange = function (e) {
                  if (4 === t.readyState) if (200 === t.status || 201 === t.status) try {
                    var n = JSON.parse(t.responseText);
                    r.validateSession(n), R.getInstance().restart(), o(n);
                  } catch (c) {
                    i(c);
                  } else i();
                };
                var s = L({}, n);
                n.customData && (delete s.customData, s = L(L({}, s), n.customData)), t.send(JSON.stringify(L(L({}, s), {}, {
                  userId: e,
                  userHash: a,
                  lang: $e.getInstance().getActiveLanguage()
                })));
              });
            });
          }
        });
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "getName",
        value: function value() {
          try {
            return this.session.name ? this.session.name.split(" ")[0].split("@")[0].split(".")[0].split("+")[0] : "";
          } catch (e) {
            return this.session.name;
          }
        }
      }, {
        key: "getSession",
        value: function value() {
          return this.session;
        }
      }, {
        key: "getGleapId",
        value: function value() {
          return this.session && this.session.gleapId ? this.session.gleapId : null;
        }
      }, {
        key: "isUser",
        value: function value() {
          return !(!this.session || !this.session.userId);
        }
      }, {
        key: "notifySessionReady",
        value: function value() {
          if (this.onSessionReadyListener.length > 0) for (var e = 0; e < this.onSessionReadyListener.length; e++) {
            this.onSessionReadyListener[e]();
          }
          this.onSessionReadyListener = [], re.getInstance().sendSessionUpdate();
        }
      }]) && A(t.prototype, n), a && A(t, a), e;
    }();
    function O(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function E(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    T(M, "instance", void 0);
    var R = function () {
      function e() {
        var t = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), E(this, "eventArray", []), E(this, "streamedEventArray", []), E(this, "eventMaxLength", 500), E(this, "errorCount", 0), E(this, "streamingEvents", !1), E(this, "lastUrl", void 0), E(this, "stopped", !1), E(this, "mainLoopTimeout", null), E(this, "runEventStreamLoop", function () {
          if (!t.stopped) {
            var e = t;
            t.streamEvents(), t.mainLoopTimeout = setTimeout(function () {
              e.runEventStreamLoop();
            }, 1e4);
          }
        }), E(this, "streamEvents", function () {
          if (!(!M.getInstance().ready || t.streamingEvents || t.errorCount > 2)) {
            var e = t;
            t.streamingEvents = !0;
            var n = M.getInstance().getGleapId(),
              a = new XMLHttpRequest();
            a.open("POST", M.getInstance().apiUrl + "/sessions/ping"), a.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), M.getInstance().injectSession(a), a.onerror = function () {
              e.errorCount++, e.streamingEvents = !1;
            }, a.onreadystatechange = function (t) {
              if (4 === a.readyState) {
                if (200 === a.status || 201 === a.status) {
                  if (e.errorCount = 0, M.getInstance().getGleapId() === n) try {
                    var r = JSON.parse(a.responseText),
                      o = r.a,
                      i = r.u;
                    re.getInstance().isOpened() || (o && Tt.getInstance().performActions(o), null != i && ct.getInstance().setNotificationCount(i));
                  } catch (s) {}
                } else e.errorCount++;
                e.streamingEvents = !1;
              }
            };
            var r = se.getInstance().getSessionDuration();
            a.send(JSON.stringify({
              time: r,
              events: t.streamedEventArray,
              opened: re.getInstance().isOpened(),
              sdkVersion: "11.1.2"
            })), t.streamedEventArray = [];
          }
        });
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "getEventArray",
        value: function value() {
          return this.eventArray;
        }
      }, {
        key: "stop",
        value: function value() {
          this.stopped = !0;
        }
      }, {
        key: "resetErrorCountLoop",
        value: function value() {
          var e = this;
          setInterval(function () {
            e.errorCount = 0;
          }, 6e4);
        }
      }, {
        key: "restart",
        value: function value() {
          this.mainLoopTimeout && (clearInterval(this.mainLoopTimeout), this.mainLoopTimeout = null), this.trackInitialEvents(), this.runEventStreamLoop();
        }
      }, {
        key: "start",
        value: function value() {
          this.stopped = !1, this.startPageListener(), this.resetErrorCountLoop();
        }
      }, {
        key: "trackInitialEvents",
        value: function value() {
          e.getInstance().logEvent("sessionStarted"), e.getInstance().logCurrentPage();
        }
      }, {
        key: "logCurrentPage",
        value: function value() {
          if (!Tt.getInstance().disablePageTracking) {
            var e = window.location.href;
            e && e !== this.lastUrl && (this.lastUrl = e, this.logEvent("pageView", {
              page: e
            }));
          }
        }
      }, {
        key: "startPageListener",
        value: function value() {
          var e = this;
          setInterval(function () {
            e.stopped || e.logCurrentPage();
          }, 1e3);
        }
      }, {
        key: "logEvent",
        value: function value(e, t) {
          var n = {
            name: e,
            date: new Date()
          };
          t && (n.data = b(t)), this.eventArray.push(n), this.streamedEventArray.push(n), this.eventArray.length > this.eventMaxLength && this.eventArray.shift(), this.streamedEventArray.length > this.eventMaxLength && this.streamedEventArray.shift();
        }
      }]) && O(t.prototype, n), a && O(t, a), e;
    }();
    function N(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function F(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    E(R, "instance", void 0);
    var D = function D(e, t) {
        var n = parseInt(e);
        return isNaN(n) ? t : n;
      },
      B = function () {
        function e() {
          var t = this;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), F(this, "flowConfig", null), F(this, "projectActions", null), F(this, "onConfigLoadedListener", []), F(this, "onConfigLoaded", function (e) {
            null !== t.flowConfig ? e() : t.onConfigLoadedListener.push(e);
          }), F(this, "start", function () {
            var e = M.getInstance(),
              n = w("config-".concat(e.sdkKey, "-").concat($e.getInstance().getActiveLanguage()));
            return n ? (t.applyConfig(n), t.loadConfigFromServer().catch(function (e) {}), Promise.resolve()) : t.loadConfigFromServer();
          }), F(this, "loadConfigFromServer", function () {
            var e = t;
            return new Promise(function (t, n) {
              var a = M.getInstance(),
                r = new XMLHttpRequest(),
                o = $e.getInstance().getActiveLanguage();
              r.open("GET", a.apiUrl + "/config/" + a.sdkKey + "?lang=" + o), r.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), a.injectSession(r), r.onerror = function () {
                n();
              }, r.onreadystatechange = function (o) {
                if (4 === r.readyState) {
                  if (200 === r.status || 201 === r.status) try {
                    var i = JSON.parse(r.responseText);
                    try {
                      C("config-".concat(a.sdkKey, "-lang"), i);
                    } catch (s) {}
                    return e.applyConfig(i), t();
                  } catch (o) {}
                  n();
                }
              }, r.send();
            });
          });
        }
        var t, n, a;
        return t = e, a = [{
          key: "getInstance",
          value: function value() {
            return this.instance || (this.instance = new e()), this.instance;
          }
        }], (n = [{
          key: "getFlowConfig",
          value: function value() {
            return this.flowConfig;
          }
        }, {
          key: "getProjectActions",
          value: function value() {
            return this.projectActions;
          }
        }, {
          key: "applyStylesFromConfig",
          value: function value() {
            var e = this.flowConfig;
            Tt.setStyles(e.color ? e.color : "#485BFF", e.headerColor ? e.headerColor : "#485BFF", e.buttonColor ? e.buttonColor : "#485BFF", e.backgroundColor ? e.backgroundColor : "#FFFFFF", D(e.borderRadius, 20), D(e.buttonX, 20), D(e.buttonY, 20), e.feedbackButtonPosition);
          }
        }, {
          key: "notifyConfigLoaded",
          value: function value() {
            if (this.onConfigLoadedListener.length > 0) for (var e = 0; e < this.onConfigLoadedListener.length; e++) {
              this.onConfigLoadedListener[e]();
            }
            this.onConfigLoadedListener = [];
          }
        }, {
          key: "applyConfig",
          value: function value(e) {
            try {
              var t = e.flowConfig,
                n = e.projectActions;
              this.flowConfig = t, this.projectActions = n, this.applyStylesFromConfig(), re.getInstance().sendConfigUpdate(), r.getInstance().updateFeedbackButtonState(), ct.getInstance().updateContainerStyle(), t.enableWebReplays ? _e.getInstance().start() : _e.getInstance().stop(), t.enableNetworkLogs && g.getInstance().start(), g.getInstance().setLoadAllResources(!!t.sendNetworkResources), t.networkLogPropsToIgnore && g.getInstance().setFilters(t.networkLogPropsToIgnore), t.networkLogBlacklist && g.getInstance().setBlacklist(t.networkLogBlacklist), $e.getInstance().updateRTLSupport(), Tt.enableShortcuts(!!t.enableShortcuts), this.notifyConfigLoaded();
            } catch (a) {}
          }
        }, {
          key: "getFeedbackOptions",
          value: function value(e) {
            var t = null;
            e && (t = this.projectActions[e]), t || (t = this.projectActions.bugreporting);
            try {
              t = JSON.parse(JSON.stringify(t));
            } catch (n) {}
            return t;
          }
        }]) && N(t.prototype, n), a && N(t, a), e;
      }();
    F(B, "instance", void 0);
    var P = ["//fonts.googleapis.com", "//cdn.jsdelivr.net", "//cdnjs.cloudflare.com", "//ajax.googleapis.com", "//use.typekit.net", ".amazonaws.com", "//jssdk.gleap.io", ".gstatic.com"],
      j = function j(e, t, n) {
        return a = e, r = /url\((.*?)\)/g, o = function o(e) {
          return new Promise(function (a, r) {
            if (!e) return a(e);
            var o = e.substr(4, e.length - 5).replaceAll("'", "").replaceAll('"', "");
            if (0 === o.indexOf("http") || 0 === o.indexOf("//") || 0 === o.indexOf("data")) return a(e);
            try {
              var i = o;
              return t && (i = t + "/" + o), n ? a("url(" + i + ")") : U(i).then(function (e) {
                return a("url(" + e + ")");
              });
            } catch (s) {
              return a(e);
            }
          });
        }, new Promise(function (e, t) {
          var n = [];
          a.replace(r, function (e) {
            for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              a[r - 1] = arguments[r];
            }
            var i = o.apply(void 0, [e].concat(a));
            n.push(i);
          }), Promise.all(n).then(function (t) {
            e(a.replace(r, function () {
              return t.shift();
            }));
          }).catch(function () {
            t();
          });
        });
        var a, r, o;
      },
      U = function U(e) {
        return new Promise(function (t, n) {
          if (e) {
            var a = new XMLHttpRequest();
            a.onload = function () {
              var e = new FileReader();
              e.onloadend = function () {
                t(e.result);
              }, e.onerror = function () {
                n();
              }, e.readAsDataURL(a.response);
            }, a.onerror = function (e) {
              t();
            }, a.open("GET", e), a.responseType = "blob", a.send();
          } else t();
        });
      },
      q = function q(e, t, n, a) {
        (function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 400,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 400;
          return new Promise(function (a, r) {
            var o = 0 === e.indexOf("data:image/jpeg"),
              i = new Image();
            i.src = e, i.onerror = function () {
              r();
            }, i.onload = function () {
              var e = document.createElement("canvas"),
                r = t,
                s = n;
              t > i.width / 4 && (r = i.width / 4), n > i.height / 4 && (s = i.height / 4);
              var c = i.width,
                l = i.height;
              c > l ? c > r && (l *= r / c, c = r) : l > s && (c *= s / l, l = s), e.width = c, e.height = l, e.getContext("2d").drawImage(i, 0, 0, c, l), a(o ? e.toDataURL("image/jpeg", .7) : e.toDataURL());
            };
          });
        })(e, 500, 500).then(function (e) {
          t.src = e, n();
        }).catch(function () {
          console.warn("BB: Image resize failed."), n();
        });
      },
      _ = function _(e) {
        return new Promise(function (t, n) {
          if (e && e.src) {
            if (function (e) {
              if (!e) return !1;
              for (var t = 0; t < P.length; t++) {
                if (-1 !== e.indexOf(P[t])) return !0;
              }
              return !1;
            }(e.src)) return t();
            var a = new XMLHttpRequest();
            a.onload = function () {
              var n = new FileReader();
              n.onloadend = function () {
                q(n.result, e, t);
              }, n.onerror = function () {
                t();
              }, n.readAsDataURL(a.response);
            }, a.onerror = function (e) {
              t();
            };
            var r = e.src;
            a.open("GET", r), a.responseType = "blob", a.send();
          } else t();
        });
      },
      H = function H(e, t, n, a) {
        var r = null;
        t.ownerNode && (r = e.querySelector('[bb-styleid="' + a + '"]'));
        try {
          if (r) {
            var o = null;
            if ("" != n) {
              var i = e.querySelector("head"),
                s = window.document.createElement("style");
              i.appendChild(s), s.type = "text/css", s.styleSheet ? s.styleSheet.cssText = n : s.appendChild(window.document.createTextNode(n)), o = s;
            } else {
              var c = window.document.createElement("link");
              c.rel = "stylesheet", c.type = t.type, c.href = t.href, c.media = t.media, o = c;
            }
            o && (r.parentNode.insertBefore(o, r), r.remove());
          }
        } catch (l) {}
      },
      W = function W(e) {
        var t = null;
        try {
          e.cssRules ? t = e.cssRules : e.rules && (t = e.rules);
        } catch (r) {}
        var n = "";
        if (t) for (var a in t) {
          t[a].cssText && (n += t[a].cssText);
        }
        return n;
      },
      z = function z(e, t) {
        for (var n = [], a = function a() {
            var e = document.styleSheets[r];
            if (e.media && "print" === e.media.mediaText) return "continue";
            var a = W(e);
            if (e && e.ownerNode) if ("" != a) {
              var i = document.getElementsByTagName("base");
              o = i.length ? i[0].href.substr(location.origin.length, 999) : window.location.href, e.href && (o = e.href);
              var s = o.substring(0, o.lastIndexOf("/"));
              n.push(j(a, s, t).then(function (t) {
                return {
                  styletext: t,
                  stylesheet: e,
                  styleId: e.ownerNode.getAttribute("bb-styleid")
                };
              }));
            } else n.push(Promise.resolve({
              styletext: a,
              stylesheet: e,
              styleId: e.ownerNode.getAttribute("bb-styleid")
            }));
          }, r = 0; r < document.styleSheets.length; r++) {
          var o;
          a();
        }
        return Promise.all(n).then(function (t) {
          if (t) for (var n = 0; n < t.length; n++) {
            H(e, t[n].stylesheet, t[n].styletext, t[n].styleId);
          }
          return !0;
        });
      },
      G = function G(e, t) {
        return new Promise(function (n, a) {
          return t ? z(e, t).then(function () {
            n();
          }).catch(function () {
            n();
          }) : function (e) {
            for (var t = e.querySelectorAll("img"), n = [], a = 0; a < t.length; a++) {
              var r = t[a];
              n.push(_(r));
            }
            return Promise.all(n);
          }(e).then(function () {
            return z(e, t).then(function () {
              n();
            });
          }).catch(function () {
            console.warn("Gleap: Failed with resolving local resources. Please contact the Gleap support team."), n();
          });
        });
      },
      Z = function Z(e, t, n) {
        if (void 0 !== e.adoptedStyleSheets) for (var a = 0; a < e.adoptedStyleSheets.length; a++) {
          var r = e.adoptedStyleSheets[a],
            o = W(r),
            i = window.document.createElement("style");
          i.type = "text/css", i.styleSheet ? i.styleSheet.cssText = o : i.appendChild(window.document.createTextNode(o)), n && i.setAttribute("bb-shadow-child", n), t.insertBefore(i, t.firstElementChild);
        }
      },
      V = function V(e) {
        return new Promise(function (t, n) {
          for (var a = window.document.querySelectorAll("style, link"), r = 0; r < a.length; ++r) {
            a[r].setAttribute("bb-styleid", r);
          }
          var o = function (e) {
              var t = 1,
                n = document.createDocumentFragment();
              !function e(n, a, r) {
                var o = function o(t, n, a) {
                    for (; t;) {
                      e(t, n, a), t = t.nextSibling;
                    }
                  },
                  i = n.cloneNode();
                if (void 0 !== i.setAttribute && (r && i.setAttribute("bb-shadow-child", r), n instanceof HTMLCanvasElement && i.setAttribute("bb-canvas-data", n.toDataURL()), n instanceof HTMLCanvasElement && i.setAttribute("bb-canvas-data", n.toDataURL())), n.nodeType == Node.ELEMENT_NODE) {
                  var s = n.tagName ? n.tagName.toUpperCase() : n.tagName;
                  if ("IFRAME" == s || "VIDEO" == s || "EMBED" == s || "IMG" == s || "SVG" == s) {
                    var c = n.getBoundingClientRect();
                    i.setAttribute("bb-element", !0), i.setAttribute("bb-height", c.height), i.setAttribute("bb-width", c.width);
                  }
                  if ((n.scrollTop > 0 || n.scrollLeft > 0) && (i.setAttribute("bb-scrollpos", !0), i.setAttribute("bb-scrolltop", n.scrollTop), i.setAttribute("bb-scrollleft", n.scrollLeft)), "SELECT" === s || "TEXTAREA" === s || "INPUT" === s) {
                    var l = n.value;
                    ("value" === n.getAttribute("gleap-ignore") || n.classList.contains("gl-mask")) && (l = new Array(l.length + 1).join("*")), i.setAttribute("bb-data-value", l), "checkbox" !== n.type && "radio" !== n.type || !n.checked || i.setAttribute("bb-data-checked", !0);
                  }
                }
                if (a.appendChild(i), n.shadowRoot) {
                  var u = t;
                  t++, o(n.shadowRoot.firstChild, i, u), Z(n.shadowRoot, i, u), void 0 !== i.setAttribute && i.setAttribute("bb-shadow-parent", u);
                }
                o(n.firstChild, i);
              }(e, n);
              var a = n.querySelector("head");
              return a || (a = n), Z(window.document, a), n;
            }(window.document.documentElement),
            i = o.querySelectorAll("link[rel=import]");
          for (r = 0; r < i.length; ++r) {
            var s = i[r];
            if (s && s.childNodes && s.childNodes.length > 0) {
              for (var c = s.childNodes; c.length > 0;) {
                s.parentNode.insertBefore(c[0], s);
              }
              s.remove();
            }
          }
          var l = o.querySelectorAll("script, noscript");
          for (r = 0; r < l.length; ++r) {
            l[r].remove();
          }
          var u = "",
            d = o.querySelectorAll("base");
          for (r = 0; r < d.length; ++r) {
            d[r].href && (u = d[r].href), d[r].remove();
          }
          var p = window.location.href.substring(0, window.location.href.lastIndexOf("/")),
            f = p + "/";
          u && (u.startsWith("http") ? f = u : (f = p + u).endsWith("/") || (f += "/"));
          var h = window.document.createElement("base");
          h.href = f;
          var g = o.querySelector("head");
          g.insertBefore(h, g.firstChild);
          var b = o.querySelectorAll(".bb-feedback-dialog-container, .bb-capture-editor-borderlayer");
          for (r = 0; r < b.length; ++r) {
            b[r].remove();
          }
          var v = o.querySelectorAll("[bb-element=true]");
          for (r = 0; r < v.length; ++r) {
            v[r] && (v[r].style.height = v[r].getAttribute("bb-height") + "px");
          }
          G(o, e).then(function () {
            var e = function (e) {
              var t = "",
                n = window.document.doctype;
              if (n && (t = "<!DOCTYPE " + n.name + (n.publicId ? ' PUBLIC "' + n.publicId + '"' : "") + (!n.publicId && n.systemId ? " SYSTEM" : "") + (n.systemId ? ' "' + n.systemId + '"' : "") + ">"), e && e.childNodes && e.childNodes.length > 0) for (var a = 0; a < e.childNodes.length; a++) {
                e.childNodes[a] && (t += e.childNodes[a].outerHTML);
              }
              return t;
            }(o);
            t({
              html: e,
              baseUrl: p,
              width: window.innerWidth,
              height: window.innerHeight,
              isMobile: m()
            });
          });
        });
      };
    function K(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function X(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var Y = function () {
      function e(t, n) {
        var a = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), X(this, "rerender", void 0), X(this, "stream", void 0), X(this, "mediaRecorder", void 0), X(this, "audioMuted", !1), X(this, "audioAvailable", !0), X(this, "available", !0), X(this, "isRecording", !1), X(this, "file", null), X(this, "maxRecordTime", 120), X(this, "recordTime", 0), X(this, "recordingTimer", null), X(this, "permissionErrorText", ""), X(this, "startScreenRecording", function () {
          var e = this;
          if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia || this.isRecording) return this.available = !1, void this.rerender();
          navigator.mediaDevices.getDisplayMedia({
            video: {
              width: {
                ideal: Math.min(window.screen.width, 3072)
              },
              height: {
                ideal: Math.min(window.screen.height, 1728)
              },
              frameRate: {
                ideal: 10,
                max: 24
              },
              displaySurface: "monitor"
            },
            audio: !0
          }).then(function (t) {
            e.stream = t, e.audioMuted ? (e.audioAvailable = !1, e.handleRecord({
              stream: t
            })) : e.startAudioRecording(), e.rerender();
          }).catch(function (t) {
            window.alert(e.permissionErrorText), e.rerender();
          });
        }), X(this, "stopScreenRecording", function () {
          this.mediaRecorder && this.stream && this.isRecording && (this.recordingTimer && (clearInterval(this.recordingTimer), this.recordingTimer = null), this.mediaRecorder.stop(), this.stream.getTracks().forEach(function (e) {
            e.stop();
          }), this.rerender());
        }), X(this, "startAudioRecording", function () {
          var e = this;
          this.stream && navigator.mediaDevices.getUserMedia({
            audio: !0,
            video: !1
          }).then(function (t) {
            for (var n = 0; n < t.getAudioTracks().length; n++) {
              e.stream.addTrack(t.getAudioTracks()[n]);
            }
            e.audioMuted = !1, e.audioAvailable = !0, e.handleRecord({
              stream: e.stream
            }), e.rerender();
          }).catch(function (t) {
            e.audioAvailable = !1, e.handleRecord({
              stream: e.stream
            }), e.rerender();
          });
        }), X(this, "toggleAudio", function () {
          if (this.audioMuted = !this.audioMuted, this.rerender(), this.stream) for (var e = this.stream.getAudioTracks(), t = 0; t < e.length; t++) {
            e[t].enabled = !this.audioMuted;
          }
        }), X(this, "clearPreview", function () {
          document.querySelector(".bb-capture-preview video").src = null, this.file = null, this.rerender();
        }), X(this, "handleRecord", function (e) {
          var t = e.stream,
            n = this,
            a = [];
          this.mediaRecorder = new MediaRecorder(t, {
            mimeType: this.getSupportedMimeType()
          }), this.isRecording = !0, this.recordTime = 0;
          var r = document.querySelector(".bb-capture-toolbar-item-timer");
          this.recordingTimer = setInterval(function () {
            n.recordTime++;
            var e = n.maxRecordTime - n.recordTime;
            e > 0 ? r.innerHTML = n.formatTime(e) : (r.innerHTML = "2:00", n.stopScreenRecording());
          }, 1e3), this.mediaRecorder.ondataavailable = function (e) {
            e.data.size > 0 && a.push(e.data);
          }, t.getVideoTracks()[0].onended = function () {
            n.prepareRecording(a);
          }, this.mediaRecorder.onstop = function () {
            n.prepareRecording(a);
          }, this.mediaRecorder.start(200), n.rerender();
        }), X(this, "prepareRecording", function (e) {
          var t = new Blob(e, {
            type: this.getSupportedMimeType()
          });
          this.file = new File([t], "screen-recording.".concat("video/mp4" === this.getSupportedMimeType() ? "mp4" : "webm"), {
            type: this.getSupportedMimeType()
          });
          var n = document.querySelector(".bb-capture-preview video");
          n && (n.src = URL.createObjectURL(t), this.audioAvailable = !0, this.isRecording = !1, this.rerender());
        }), this.rerender = t, this.permissionErrorText = n, navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia || (this.available = !1), setTimeout(function () {
          a.rerender();
        }, 100);
      }
      var t, n, a;
      return t = e, (n = [{
        key: "getSupportedMimeType",
        value: function value() {
          return MediaRecorder.isTypeSupported("video/mp4") ? "video/mp4" : MediaRecorder.isTypeSupported("video/webm;codecs=h264") ? "video/webm;codecs=h264" : "video/webm";
        }
      }, {
        key: "formatTime",
        value: function value(e) {
          return (e - (e %= 60)) / 60 + (9 < e ? ":" : ":0") + e;
        }
      }]) && K(t.prototype, n), a && K(t, a), e;
    }();
    function J(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function Q(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    X(Y, "uploadScreenRecording", function (e) {
      return new Promise(function (t, n) {
        null == e && t(null);
        var a = new XMLHttpRequest();
        a.open("POST", M.getInstance().apiUrl + "/uploads/sdk"), M.getInstance().injectSession(a);
        var r = new FormData();
        r.append("file", e), a.send(r), a.onerror = function () {
          n();
        }, a.onreadystatechange = function () {
          4 == a.readyState && (200 == a.status ? t(JSON.parse(a.response).fileUrl) : n());
        };
      });
    });
    var $ = function () {
      function e(t, n, a, r, o, i, s) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Q(this, "excludeData", {}), Q(this, "type", "BUG"), Q(this, "priority", "LOW"), Q(this, "customData", {}), Q(this, "metaData", {}), Q(this, "consoleLog", []), Q(this, "networkLogs", []), Q(this, "customEventLog", []), Q(this, "formData", {}), Q(this, "isSilent", !1), Q(this, "outboundId", void 0), Q(this, "screenshotData", void 0), Q(this, "webReplay", void 0), Q(this, "screenRecordingUrl", void 0), Q(this, "spamToken", void 0), this.type = t, this.priority = n, this.formData = a, this.isSilent = r, this.excludeData = o, this.outboundId = i, this.spamToken = s;
      }
      var t, n, a;
      return t = e, (n = [{
        key: "takeSnapshot",
        value: function value() {
          var e = this,
            t = Tt.getInstance();
          this.customData = we.getInstance().getCustomData(), this.metaData = se.getInstance().getMetaData(), this.consoleLog = pe.getInstance().getLogs(), this.networkLogs = g.getInstance().getRequests(), this.customEventLog = R.getInstance().getEventArray();
          var n = [],
            a = t.getGlobalDataItem("webReplay");
          null !== a && (this.webReplay = a);
          var r,
            o = t.getGlobalDataItem("screenRecordingData");
          if (null != o) {
            var i = Y.uploadScreenRecording(o).then(function (t) {
              t && (e.screenRecordingUrl = t);
            });
            n.push(i);
          }
          if (!this.excludeData || !this.excludeData.screenshot) {
            var s = (r = t.isLiveMode(), V(r)).then(function (n) {
              if (n) {
                var a = t.getGlobalDataItem("snapshotPosition");
                n.x = a.x, n.y = a.y, e.screenshotData = n;
              }
            });
            n.push(s);
          }
          return Promise.all(n);
        }
      }, {
        key: "getData",
        value: function value() {
          var e = {
              type: this.type,
              priority: this.priority,
              customData: this.customData,
              metaData: this.metaData,
              consoleLog: this.consoleLog,
              networkLogs: this.networkLogs,
              customEventLog: this.customEventLog,
              formData: this.formData,
              isSilent: this.isSilent,
              outbound: this.outboundId,
              screenshotData: this.screenshotData,
              webReplay: this.webReplay,
              screenRecordingUrl: this.screenRecordingUrl,
              spamToken: this.spamToken
            },
            t = yt.getInstance().getTags();
          if (t && t.length > 0 && (e.tags = t), this.excludeData) for (var n = Object.keys(this.excludeData), a = 0; a < n.length; a++) {
            var r = n[a];
            !0 === this.excludeData[r] && (e[r] && delete e[r], "screenshot" === r && delete e.screenshotData, "replays" === r && delete e.webReplay);
          }
          return e;
        }
      }, {
        key: "getTicketData",
        value: function value() {
          var e = this;
          return new Promise(function (t, n) {
            e.takeSnapshot().then(function () {
              var n = e.getData();
              t(n);
            }).catch(function (e) {
              n();
            });
          });
        }
      }, {
        key: "sendFeedback",
        value: function value() {
          var e = this;
          return new Promise(function (t, n) {
            e.takeSnapshot().then(function () {
              var a = e.getData(),
                r = new XMLHttpRequest();
              r.open("POST", M.getInstance().apiUrl + "/bugs/v2"), r.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), M.getInstance().injectSession(r), r.onerror = function (e) {
                n();
              }, r.onreadystatechange = function (e) {
                if (4 === r.readyState) if (200 === r.status || 201 === r.status) try {
                  var a = JSON.parse(r.responseText);
                  t(a);
                } catch (o) {
                  n();
                } else n();
              }, r.send(JSON.stringify(a));
            }).catch(function (e) {
              n();
            });
          });
        }
      }]) && J(t.prototype, n), a && J(t, a), e;
    }();
    function ee(e) {
      return function (e) {
        if (Array.isArray(e)) return te(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return te(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return te(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function te(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, a = new Array(t); n < t; n++) {
        a[n] = e[n];
      }
      return a;
    }
    function ne(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function ae(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var re = function () {
      function e() {
        var t = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), ae(this, "frameUrl", "https://messenger-app.gleap.io"), ae(this, "gleapFrameContainer", null), ae(this, "gleapFrame", null), ae(this, "injectedFrame", !1), ae(this, "widgetOpened", !1), ae(this, "listeners", []), ae(this, "appMode", "widget"), ae(this, "markerManager", void 0), ae(this, "escListener", void 0), ae(this, "frameHeight", 0), ae(this, "queue", []), ae(this, "urlHandler", function (e, t) {
          e && e.length > 0 && (t ? window.open(e, "_blank").focus() : window.location.href = e);
        }), ae(this, "autoWhiteListCookieManager", function () {
          window && window.cmp_block_ignoredomains && window.cmp_block_ignoredomains.concat(["messenger-app.gleap.io"]);
        }), ae(this, "injectFrame", function () {
          t.injectedFrame || (t.injectedFrame = !0, t.autoWhiteListCookieManager(), x(function () {
            B.getInstance().onConfigLoaded(function () {
              B.getInstance().applyStylesFromConfig();
              var e = document.createElement("div");
              e.className = "gleap-frame-container gleap-frame-container--hidden gl-block", e.innerHTML = '<div class="gleap-frame-container-inner"><iframe src="'.concat(t.frameUrl, '" class="gleap-frame" scrolling="yes" title="Gleap Widget Window" allow="autoplay; encrypted-media; fullscreen;" frameborder="0"></iframe></div>'), document.body.appendChild(e), t.gleapFrameContainer = e, t.gleapFrame = document.querySelector(".gleap-frame"), t.updateFrameStyle(), "widget" === t.appMode && t.showFrameContainer(!0);
            });
          }));
        }), ae(this, "showImage", function (e) {
          x(function () {
            var t = document.createElement("div");
            t.className = "gleap-image-view", t.innerHTML = '<div class="gleap-image-view-close">\n      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm97.9-320l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z"/></svg>\n      </div><img class="gleap-image-view-image" src="'.concat(e, '" />'), document.body.appendChild(t);
            var n = function n() {
              t.remove();
            };
            t.querySelector(".gleap-image-view-close").addEventListener("click", function () {
              n();
            }), t.addEventListener("click", function (e) {
              e.target === t && n();
            });
          });
        }), ae(this, "updateFrameStyle", function () {
          if (t.gleapFrameContainer) {
            for (var e = "gleap-frame-container--survey", n = "gleap-frame-container--extended", a = "gleap-frame-container--survey-full", o = "gleap-frame-container--classic", i = "gleap-frame-container--classic-left", s = "gleap-frame-container--modern-left", c = "gleap-frame-container--no-button", l = [o, i, n, s, c, e, a], u = 0; u < l.length; u++) {
              t.gleapFrameContainer.classList.remove(l[u]);
            }
            var d = void 0,
              p = B.getInstance().getFlowConfig();
            p.feedbackButtonPosition !== r.FEEDBACK_BUTTON_CLASSIC && p.feedbackButtonPosition !== r.FEEDBACK_BUTTON_CLASSIC_BOTTOM || (d = o), p.feedbackButtonPosition === r.FEEDBACK_BUTTON_CLASSIC_LEFT && (d = i), p.feedbackButtonPosition === r.FEEDBACK_BUTTON_BOTTOM_LEFT && (d = s), null === r.getInstance().buttonHidden ? p.feedbackButtonPosition === r.FEEDBACK_BUTTON_NONE && (d = c) : r.getInstance().buttonHidden && (d = c), d && t.gleapFrameContainer.classList.add(d), "survey" === t.appMode && t.gleapFrameContainer.classList.add(e), "survey_full" === t.appMode && t.gleapFrameContainer.classList.add(a), "extended" === t.appMode && t.gleapFrameContainer.classList.add(n), t.gleapFrameContainer.setAttribute("dir", $e.getInstance().isRTLLayout ? "rtl" : "ltr");
          }
        }), this.startCommunication();
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "setUrlHandler",
        value: function value(e) {
          this.urlHandler = e;
        }
      }, {
        key: "isSurvey",
        value: function value() {
          return "survey" === this.appMode || "survey_full" === this.appMode;
        }
      }, {
        key: "setAppMode",
        value: function value(e) {
          this.appMode = e, this.updateFrameStyle();
          var t = document.querySelector(".gleap-frame-container-inner");
          "widget" !== this.appMode && "survey_full" !== this.appMode || !t || (t.style.maxHeight = "".concat(660, "px"));
        }
      }, {
        key: "registerEscListener",
        value: function value() {
          var e = this;
          this.escListener || (this.escListener = function (t) {
            "Escape" === (t = t || window.event).key && e.hideWidget();
          }, document.addEventListener("keydown", this.escListener));
        }
      }, {
        key: "unregisterEscListener",
        value: function value() {
          this.escListener && (document.removeEventListener("keydown", this.escListener), this.escListener = null);
        }
      }, {
        key: "destroy",
        value: function value() {
          this.gleapFrame && this.gleapFrame.remove(), this.gleapFrameContainer && this.gleapFrameContainer.remove(), this.injectedFrame = !1, this.widgetOpened = !1, this.markerManager = void 0, this.gleapFrameContainer = null, this.gleapFrame = null;
        }
      }, {
        key: "isOpened",
        value: function value() {
          return this.widgetOpened || null != this.markerManager;
        }
      }, {
        key: "showFrameContainer",
        value: function value(e) {
          var t = this;
          if (this.gleapFrameContainer) {
            var n = B.getInstance().getFlowConfig(),
              a = "gleap-frame-container--loading";
            this.gleapFrameContainer.classList && (this.gleapFrameContainer.classList.remove("gleap-frame-container--hidden"), e ? (this.gleapFrameContainer.classList.add(a), n.disableBGFade && this.gleapFrameContainer.classList.add("gleap-frame-container--loading-nofade"), n.disableBGGradient && this.gleapFrameContainer.classList.add("gleap-frame-container--loading-nogradient")) : this.gleapFrameContainer.classList.remove(a), setTimeout(function () {
              t.gleapFrameContainer.classList.add("gleap-frame-container--animate");
            }, 500)), this.widgetOpened = !0, this.updateUI();
          }
        }
      }, {
        key: "runWidgetShouldOpenCallback",
        value: function value() {
          this.gleapFrameContainer && (this.workThroughQueue(), Tt.getInstance().setGlobalDataItem("snapshotPosition", {
            x: window.scrollX,
            y: window.scrollY
          }), this.showFrameContainer(!1), this.updateWidgetStatus(), Ie.notifyEvent("open"), this.registerEscListener());
        }
      }, {
        key: "updateUI",
        value: function value() {
          ct.getInstance().clearAllNotifications(this.isSurvey()), ct.getInstance().setNotificationCount(0), r.getInstance().updateFeedbackButtonState();
        }
      }, {
        key: "showWidget",
        value: function value() {
          var t = this;
          setTimeout(function () {
            t.gleapFrameContainer ? t.runWidgetShouldOpenCallback() : e.getInstance().injectFrame(), t.updateUI();
          }, 0);
        }
      }, {
        key: "updateWidgetStatus",
        value: function value() {
          this.sendMessage({
            name: "widget-status-update",
            data: {
              isWidgetOpen: this.widgetOpened
            }
          });
        }
      }, {
        key: "hideMarkerManager",
        value: function value() {
          this.markerManager && (this.markerManager.clear(), this.markerManager = null);
        }
      }, {
        key: "hideWidget",
        value: function value() {
          this.hideMarkerManager(), this.gleapFrameContainer && (this.gleapFrameContainer.classList.add("gleap-frame-container--hidden"), this.gleapFrameContainer.classList.remove("gleap-frame-container--animate")), this.widgetOpened = !1, this.updateWidgetStatus(), r.getInstance().updateFeedbackButtonState(), Ie.notifyEvent("close"), ct.getInstance().reloadNotificationsFromCache(), this.unregisterEscListener(), "undefined" != typeof window && void 0 !== window.focus && window.focus();
        }
      }, {
        key: "sendMessage",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          try {
            this.gleapFrame = document.querySelector(".gleap-frame"), this.gleapFrame && this.gleapFrame.contentWindow ? this.gleapFrame.contentWindow.postMessage(JSON.stringify(e), "*") : t && this.queue.push(e);
          } catch (n) {}
        }
      }, {
        key: "sendSessionUpdate",
        value: function value() {
          this.sendMessage({
            name: "session-update",
            data: {
              sessionData: M.getInstance().getSession(),
              apiUrl: M.getInstance().apiUrl,
              sdkKey: M.getInstance().sdkKey
            }
          });
        }
      }, {
        key: "sendConfigUpdate",
        value: function value() {
          this.sendMessage({
            name: "config-update",
            data: {
              config: B.getInstance().getFlowConfig(),
              actions: B.getInstance().getProjectActions(),
              overrideLanguage: $e.getInstance().getOverrideLanguage()
            }
          }), this.updateFrameStyle();
        }
      }, {
        key: "showDrawingScreen",
        value: function value(e) {
          var t = this;
          this.hideWidget(), this.markerManager = new Ye(e), this.markerManager.show(function (e) {
            e || t.hideMarkerManager(), t.showWidget();
          });
        }
      }, {
        key: "workThroughQueue",
        value: function value() {
          var e = ee(this.queue);
          this.queue = [];
          for (var t = 0; t < e.length; t++) {
            this.sendMessage(e[t], !0);
          }
        }
      }, {
        key: "startCommunication",
        value: function value() {
          var e = this;
          this.addMessageListener(function (t) {
            if ("ping" === t.name && (e.sendConfigUpdate(), e.sendSessionUpdate(), e.workThroughQueue(), setTimeout(function () {
              e.runWidgetShouldOpenCallback();
            }, 300)), "play-ping" === t.name && mt.ping(), "open-image" === t.name && e.showImage(t.data.url), "page-changed" === t.name && (!t.data || "newsdetails" !== t.data.name && "appextended" !== t.data.name ? "extended" === e.appMode && e.setAppMode("widget") : e.setAppMode("extended")), "collect-ticket-data" === t.name) {
              var n = {
                  customData: we.getInstance().getCustomData(),
                  metaData: se.getInstance().getMetaData(),
                  consoleLog: pe.getInstance().getLogs(),
                  networkLogs: g.getInstance().getRequests(),
                  customEventLog: R.getInstance().getEventArray()
                },
                a = yt.getInstance().getTags();
              a && a.length > 0 && (n.tags = a), e.sendMessage({
                name: "collect-ticket-data",
                data: n
              });
            }
            if ("height-update" === t.name) {
              e.frameHeight = t.data;
              var r = document.querySelector(".gleap-frame-container-inner");
              "survey" !== e.appMode && "survey_full" !== e.appMode || !r || (r.style.maxHeight = "".concat(e.frameHeight, "px"));
            }
            if ("notify-event" === t.name && Ie.notifyEvent(t.data.type, t.data.data), "cleanup-drawings" === t.name && e.hideMarkerManager(), "open-url" === t.name) {
              var o = t.data,
                i = !!t.newTab;
              e.urlHandler(o, i);
            }
            if ("run-custom-action" === t.name && Le.triggerCustomAction(t.data), "close-widget" === t.name && e.hideWidget(), "send-feedback" === t.name) {
              var s = t.data.formData,
                c = t.data.action,
                l = t.data.outboundId,
                u = t.data.spamToken;
              new $(c.feedbackType, "MEDIUM", s, !1, c.excludeData, l, u).sendFeedback().then(function (t) {
                e.sendMessage({
                  name: "feedback-sent",
                  data: t
                }), Ie.notifyEvent("feedback-sent", s);
              }).catch(function (t) {
                e.sendMessage({
                  name: "feedback-sending-failed",
                  data: "Something went wrong, please try again."
                }), Ie.notifyEvent("error-while-sending");
              });
            }
            "start-screen-drawing" === t.name && e.showDrawingScreen(t.data);
          }), window.addEventListener("message", function (t) {
            if (t.origin === e.frameUrl || t.origin === ft.getInstance().bannerUrl) try {
              for (var n = JSON.parse(t.data), a = 0; a < e.listeners.length; a++) {
                e.listeners[a] && e.listeners[a](n);
              }
            } catch (r) {}
          });
        }
      }, {
        key: "addMessageListener",
        value: function value(e) {
          this.listeners.push(e);
        }
      }]) && ne(t.prototype, n), a && ne(t, a), e;
    }();
    function oe(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function ie(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    ae(re, "instance", void 0);
    var se = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), ie(this, "sessionStart", new Date()), ie(this, "appBuildNumber", ""), ie(this, "appVersionCode", ""), ie(this, "environment", "prod");
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }, {
        key: "setAppVersionCode",
        value: function value(e) {
          this.getInstance().appVersionCode = e;
        }
      }, {
        key: "setAppBuildNumber",
        value: function value(e) {
          this.getInstance().appBuildNumber = e;
        }
      }], (n = [{
        key: "getSessionDuration",
        value: function value() {
          var e = new Date();
          return Math.round((e.getTime() - this.sessionStart.getTime()) / 1e3);
        }
      }, {
        key: "getMetaData",
        value: function value() {
          var e,
            t,
            n,
            a = navigator.userAgent,
            r = navigator.appName,
            o = "" + parseFloat(navigator.appVersion),
            i = parseInt(navigator.appVersion, 10);
          -1 !== (t = a.indexOf("Opera")) ? (r = "Opera", o = a.substring(t + 6), -1 !== (t = a.indexOf("Version")) && (o = a.substring(t + 8))) : -1 !== (t = a.indexOf("MSIE")) ? (r = "Microsoft Internet Explorer", o = a.substring(t + 5)) : -1 !== (t = a.indexOf("Chrome")) ? (r = "Chrome", o = a.substring(t + 7)) : -1 !== (t = a.indexOf("Safari")) ? (r = "Safari", o = a.substring(t + 7), -1 !== (t = a.indexOf("Version")) && (o = a.substring(t + 8))) : -1 !== (t = a.indexOf("Firefox")) ? (r = "Firefox", o = a.substring(t + 8)) : (e = a.lastIndexOf(" ") + 1) < (t = a.lastIndexOf("/")) && (r = a.substring(e, t), o = a.substring(t + 1), r.toLowerCase() === r.toUpperCase() && (r = navigator.appName)), -1 !== (n = o.indexOf(";")) && (o = o.substring(0, n)), -1 !== (n = o.indexOf(" ")) && (o = o.substring(0, n)), i = parseInt("" + o, 10), isNaN(i) && (o = "" + parseFloat(navigator.appVersion), i = parseInt(navigator.appVersion, 10));
          var s = "Unknown OS";
          return -1 !== navigator.appVersion.indexOf("Win") && (s = "Windows"), -1 !== navigator.appVersion.indexOf("Mac") && (s = "MacOS"), -1 !== navigator.appVersion.indexOf("X11") && (s = "UNIX"), -1 !== navigator.appVersion.indexOf("Linux") && (s = "Linux"), -1 !== navigator.appVersion.indexOf("iPad") && (s = "iPad"), -1 !== navigator.appVersion.indexOf("iPhone") && (s = "iPhone"), -1 !== navigator.appVersion.indexOf("Android") && (s = "Android"), {
            browserName: r + "(" + o + ")",
            userAgent: a,
            browser: r,
            systemName: s,
            buildVersionNumber: this.appBuildNumber,
            releaseVersionNumber: this.appVersionCode,
            sessionDuration: this.getSessionDuration(),
            devicePixelRatio: window.devicePixelRatio,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
            currentUrl: window.location.href,
            language: navigator.language || navigator.userLanguage,
            mobile: m(),
            sdkVersion: "11.1.2",
            sdkType: "javascript",
            environment: this.environment
          };
        }
      }]) && oe(t.prototype, n), a && oe(t, a), e;
    }();
    function ce(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        t && (a = a.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, a);
      }
      return n;
    }
    function le(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ce(Object(n), !0).forEach(function (t) {
          de(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ce(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function ue(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function de(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    ie(se, "instance", void 0);
    var pe = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), de(this, "logArray", []), de(this, "disabled", !1), de(this, "originalConsoleLog", void 0), de(this, "logMaxLength", 500);
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "getLogs",
        value: function value() {
          return this.logArray;
        }
      }, {
        key: "stop",
        value: function value() {
          this.disabled = !0, this.originalConsoleLog && (window.console = this.originalConsoleLog);
        }
      }, {
        key: "addLog",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "INFO";
          !e || e.length <= 0 || (this.logArray.push({
            log: v(e, 1e3),
            date: new Date(),
            priority: t
          }), this.logArray.length > this.logMaxLength && this.logArray.shift());
        }
      }, {
        key: "addLogWithArgs",
        value: function value(e, t) {
          if (e && !(e.length <= 0)) {
            var n = "";
            try {
              for (var a = 0; a < e.length; a++) {
                n += e[a] + " ";
              }
            } catch (r) {}
            this.addLog(n, t);
          }
        }
      }, {
        key: "start",
        value: function value() {
          if (!this.disabled) {
            var e,
              t = this;
            window.console = (e = window.console, window.console && e || (e = {}), t.originalConsoleLog = e, le(le({}, e), {}, {
              log: function log() {
                t.addLogWithArgs(arguments, "INFO"), e.log && e.log.apply(e, arguments);
              },
              warn: function warn() {
                t.addLogWithArgs(arguments, "WARNING"), e.warn && e.warn.apply(e, arguments);
              },
              error: function error() {
                t.addLogWithArgs(arguments, "ERROR"), e.error && e.error.apply(e, arguments);
              },
              info: function info(n) {
                t.addLogWithArgs(arguments, "INFO"), e.info && e.info.apply(e, arguments);
              }
            }));
          }
        }
      }]) && ue(t.prototype, n), a && ue(t, a), e;
    }();
    function fe(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    de(pe, "instance", void 0);
    var he,
      ge,
      me,
      be = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }
        var t, n, a;
        return t = e, a = [{
          key: "getInstance",
          value: function value() {
            return this.instance || (this.instance = new e()), this.instance;
          }
        }], (n = [{
          key: "start",
          value: function value() {
            document.addEventListener("click", function (e) {
              e.target && (re.getInstance().isOpened() || pe.getInstance().addLog(function (e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                  n = v(e.innerText || "", 40).replace(/(\r\n|\n|\r)/gm, "").replace(/ +(?= )/g, ""),
                  a = "",
                  r = "";
                if (void 0 !== e.getAttribute) {
                  var o = e.getAttribute("id");
                  o && (a = ' id="'.concat(o, '"'));
                  var i = e.getAttribute("class");
                  i && (r = ' class="'.concat(i, '"'));
                }
                var s = (e.tagName || "").toLowerCase(),
                  c = "<",
                  l = ">";
                return t || (c = "[", l = "]"), "".concat(c).concat(s).concat(a).concat(r).concat(l).concat(n).concat(c, "/").concat(s).concat(l);
              }(e.target), "CLICK"));
            });
          }
        }]) && fe(t.prototype, n), a && fe(t, a), e;
      }();
    function ve(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function ye(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    me = void 0, (ge = "instance") in (he = be) ? Object.defineProperty(he, ge, {
      value: me,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : he[ge] = me;
    var we = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), ye(this, "customData", {});
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "getCustomData",
        value: function value() {
          return this.customData;
        }
      }, {
        key: "attachCustomData",
        value: function value(e) {
          this.customData = Object.assign(this.customData, b(e));
        }
      }, {
        key: "setCustomData",
        value: function value(e, t) {
          this.customData[e] = t;
        }
      }, {
        key: "removeCustomData",
        value: function value(e) {
          delete this.customData[e];
        }
      }, {
        key: "clearCustomData",
        value: function value() {
          this.customData = {};
        }
      }]) && ve(t.prototype, n), a && ve(t, a), e;
    }();
    function Ce(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function ke(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    ye(we, "instance", void 0);
    var Ie = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), ke(this, "eventListeners", {});
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }, {
        key: "notifyEvent",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if ("flow-started" === e) {
            var n = Tt.getInstance();
            n.setGlobalDataItem("webReplay", null), n.setGlobalDataItem("screenRecordingData", null), n.takeCurrentReplay();
          }
          var a = this.getInstance().eventListeners[e];
          if (a) for (var r = 0; r < a.length; r++) {
            var o = a[r];
            o && o(t);
          }
        }
      }, {
        key: "on",
        value: function value(e, t) {
          var n = this.getInstance();
          n.eventListeners[e] || (n.eventListeners[e] = []), n.eventListeners[e].push(t);
        }
      }], (n = null) && Ce(t.prototype, n), a && Ce(t, a), e;
    }();
    function xe(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function Se(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    ke(Ie, "instance", void 0);
    var Le = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Se(this, "customActionCallbacks", []);
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }, {
        key: "registerCustomAction",
        value: function value(e) {
          var t = this.getInstance();
          t.customActionCallbacks && t.customActionCallbacks.push(e);
        }
      }, {
        key: "triggerCustomAction",
        value: function value(e) {
          var t = this.getInstance();
          if (t.customActionCallbacks) for (var n = 0; n < t.customActionCallbacks.length; n++) {
            var a = t.customActionCallbacks[n];
            a && a({
              name: e
            });
          }
        }
      }], (n = null) && xe(t.prototype, n), a && xe(t, a), e;
    }();
    function Ae(e) {
      return (Ae = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function Te(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
        if (null == n) return;
        var a,
          r,
          o = [],
          i = !0,
          s = !1;
        try {
          for (n = n.call(e); !(i = (a = n.next()).done) && (o.push(a.value), !t || o.length !== t); i = !0) {
            ;
          }
        } catch (c) {
          s = !0, r = c;
        } finally {
          try {
            i || null == n.return || n.return();
          } finally {
            if (s) throw r;
          }
        }
        return o;
      }(e, t) || Ee(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function Me(e) {
      return function (e) {
        if (Array.isArray(e)) return Re(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || Ee(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function Oe(e, t) {
      var _n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (!_n) {
        if (Array.isArray(e) || (_n = Ee(e)) || t && e && "number" == typeof e.length) {
          _n && (e = _n);
          var a = 0,
            r = function r() {};
          return {
            s: r,
            n: function n() {
              return a >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[a++]
              };
            },
            e: function e(_e2) {
              throw _e2;
            },
            f: r
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var o,
        i = !0,
        s = !1;
      return {
        s: function s() {
          _n = _n.call(e);
        },
        n: function n() {
          var e = _n.next();
          return i = e.done, e;
        },
        e: function e(_e3) {
          s = !0, o = _e3;
        },
        f: function f() {
          try {
            i || null == _n.return || _n.return();
          } finally {
            if (s) throw o;
          }
        }
      };
    }
    function Ee(e, t) {
      if (e) {
        if ("string" == typeof e) return Re(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Re(e, t) : void 0;
      }
    }
    function Re(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, a = new Array(t); n < t; n++) {
        a[n] = e[n];
      }
      return a;
    }
    function Ne(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Fe(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function De(e, t, n) {
      return t && Fe(e.prototype, t), n && Fe(e, n), e;
    }
    Se(Le, "instance", void 0);
    var Be = function () {
      var e, t;
      function n(e) {
        var t = null == e ? void 0 : e.host;
        return Boolean((null == t ? void 0 : t.shadowRoot) === e);
      }
      function a(e) {
        return "[object ShadowRoot]" === Object.prototype.toString.call(e);
      }
      function r(e) {
        try {
          var t = e.rules || e.cssRules;
          return t ? ((n = Array.from(t).map(o).join("")).includes(" background-clip: text;") && !n.includes(" -webkit-background-clip: text;") && (n = n.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;")), n) : null;
        } catch (a) {
          return null;
        }
        var n;
      }
      function o(e) {
        var t = e.cssText;
        if (function (e) {
          return "styleSheet" in e;
        }(e)) try {
          t = r(e.styleSheet) || t;
        } catch (n) {}
        return t;
      }
      (t = e || (e = {}))[t.Document = 0] = "Document", t[t.DocumentType = 1] = "DocumentType", t[t.Element = 2] = "Element", t[t.Text = 3] = "Text", t[t.CDATA = 4] = "CDATA", t[t.Comment = 5] = "Comment";
      var i = function () {
        function e() {
          this.idNodeMap = new Map(), this.nodeMetaMap = new WeakMap();
        }
        return e.prototype.getId = function (e) {
          var t;
          if (!e) return -1;
          var n = null === (t = this.getMeta(e)) || void 0 === t ? void 0 : t.id;
          return null != n ? n : -1;
        }, e.prototype.getNode = function (e) {
          return this.idNodeMap.get(e) || null;
        }, e.prototype.getIds = function () {
          return Array.from(this.idNodeMap.keys());
        }, e.prototype.getMeta = function (e) {
          return this.nodeMetaMap.get(e) || null;
        }, e.prototype.removeNodeFromMap = function (e) {
          var t = this,
            n = this.getId(e);
          this.idNodeMap.delete(n), e.childNodes && e.childNodes.forEach(function (e) {
            return t.removeNodeFromMap(e);
          });
        }, e.prototype.has = function (e) {
          return this.idNodeMap.has(e);
        }, e.prototype.hasNode = function (e) {
          return this.nodeMetaMap.has(e);
        }, e.prototype.add = function (e, t) {
          var n = t.id;
          this.idNodeMap.set(n, e), this.nodeMetaMap.set(e, t);
        }, e.prototype.replace = function (e, t) {
          var n = this.getNode(e);
          if (n) {
            var a = this.nodeMetaMap.get(n);
            a && this.nodeMetaMap.set(t, a);
          }
          this.idNodeMap.set(e, t);
        }, e.prototype.reset = function () {
          this.idNodeMap = new Map(), this.nodeMetaMap = new WeakMap();
        }, e;
      }();
      function s(e) {
        var t = e.maskInputOptions,
          n = e.tagName,
          a = e.type,
          r = e.value,
          o = e.maskInputFn,
          i = r || "";
        return (t[n.toLowerCase()] || t[a]) && (i = o ? o(i) : "*".repeat(i.length)), i;
      }
      var c = "__rrweb_original__";
      var l,
        u,
        d = 1,
        p = new RegExp("[^a-z0-9-_:]");
      function f() {
        return d++;
      }
      var h = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm,
        g = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/,
        m = /^(data:)([^,]*),(.*)/i;
      function b(e, t) {
        return (e || "").replace(h, function (e, n, a, r, o, i) {
          var s,
            c = a || o || i,
            l = n || r || "";
          if (!c) return e;
          if (!g.test(c)) return "url(".concat(l).concat(c).concat(l, ")");
          if (m.test(c)) return "url(".concat(l).concat(c).concat(l, ")");
          if ("/" === c[0]) return "url(".concat(l).concat((s = t, (s.indexOf("//") > -1 ? s.split("/").slice(0, 3).join("/") : s.split("/")[0]).split("?")[0] + c)).concat(l, ")");
          var u = t.split("/"),
            d = c.split("/");
          u.pop();
          for (var p = 0, f = d; p < f.length; p++) {
            var h = f[p];
            "." !== h && (".." === h ? u.pop() : u.push(h));
          }
          return "url(".concat(l).concat(u.join("/")).concat(l, ")");
        });
      }
      var v = /^[^ \t\n\r\u000c]+/,
        y = /^[, \t\n\r\u000c]+/;
      function w(e, t) {
        if (!t || "" === t.trim()) return t;
        var n = e.createElement("a");
        return n.href = t, n.href;
      }
      function C(e) {
        return Boolean("svg" === e.tagName || e.ownerSVGElement);
      }
      function k() {
        var e = document.createElement("a");
        return e.href = "", e.href;
      }
      function I(e, t, n, a) {
        return "src" === n || "href" === n && a && ("use" !== t || "#" !== a[0]) || "xlink:href" === n && a && "#" !== a[0] ? w(e, a) : "background" !== n || !a || "table" !== t && "td" !== t && "th" !== t ? "srcset" === n && a ? function (e, t) {
          if ("" === t.trim()) return t;
          var n = 0;
          function a(e) {
            var a,
              r = e.exec(t.substring(n));
            return r ? (a = r[0], n += a.length, a) : "";
          }
          for (var r = []; a(y), !(n >= t.length);) {
            var o = a(v);
            if ("," === o.slice(-1)) o = w(e, o.substring(0, o.length - 1)), r.push(o);else {
              var i = "";
              o = w(e, o);
              for (var s = !1;;) {
                var c = t.charAt(n);
                if ("" === c) {
                  r.push((o + i).trim());
                  break;
                }
                if (s) ")" === c && (s = !1);else {
                  if ("," === c) {
                    n += 1, r.push((o + i).trim());
                    break;
                  }
                  "(" === c && (s = !0);
                }
                i += c, n += 1;
              }
            }
          }
          return r.join(", ");
        }(e, a) : "style" === n && a ? b(a, k()) : "object" === t && "data" === n && a ? w(e, a) : a : w(e, a);
      }
      function x(e, t, n) {
        if (!e) return !1;
        if (e.nodeType !== e.ELEMENT_NODE) return !!n && x(e.parentNode, t, n);
        for (var a = e.classList.length; a--;) {
          var r = e.classList[a];
          if (t.test(r)) return !0;
        }
        return !!n && x(e.parentNode, t, n);
      }
      function S(e, t, n) {
        var a = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
        if (null === a) return !1;
        if ("string" == typeof t) {
          if (a.classList.contains(t)) return !0;
          if (a.closest(".".concat(t))) return !0;
        } else if (x(a, t, !0)) return !0;
        if (n) {
          if (a.matches(n)) return !0;
          if (a.closest(n)) return !0;
        }
        return !1;
      }
      function L(t, n) {
        var a = n.doc,
          o = n.mirror,
          i = n.blockClass,
          d = n.blockSelector,
          f = n.maskTextClass,
          h = n.maskTextSelector,
          g = n.inlineStylesheet,
          m = n.maskInputOptions,
          v = void 0 === m ? {} : m,
          y = n.maskTextFn,
          w = n.maskInputFn,
          x = n.dataURLOptions,
          L = void 0 === x ? {} : x,
          A = n.inlineImages,
          T = n.recordCanvas,
          M = n.keepIframeSrcFn,
          O = n.newlyAddedElement,
          E = void 0 !== O && O,
          R = function (e, t) {
            if (!t.hasNode(e)) return;
            var n = t.getId(e);
            return 1 === n ? void 0 : n;
          }(a, o);
        switch (t.nodeType) {
          case t.DOCUMENT_NODE:
            return "CSS1Compat" !== t.compatMode ? {
              type: e.Document,
              childNodes: [],
              compatMode: t.compatMode
            } : {
              type: e.Document,
              childNodes: []
            };
          case t.DOCUMENT_TYPE_NODE:
            return {
              type: e.DocumentType,
              name: t.name,
              publicId: t.publicId,
              systemId: t.systemId,
              rootId: R
            };
          case t.ELEMENT_NODE:
            return function (t, n) {
              for (var a = n.doc, o = n.blockClass, i = n.blockSelector, d = n.inlineStylesheet, f = n.maskInputOptions, h = void 0 === f ? {} : f, g = n.maskInputFn, m = n.dataURLOptions, v = void 0 === m ? {} : m, y = n.inlineImages, w = n.recordCanvas, x = n.keepIframeSrcFn, S = n.newlyAddedElement, L = void 0 !== S && S, A = n.rootId, T = function (e, t, n) {
                  if ("string" == typeof t) {
                    if (e.classList.contains(t)) return !0;
                  } else for (var a = e.classList.length; a--;) {
                    var r = e.classList[a];
                    if (t.test(r)) return !0;
                  }
                  return !!n && e.matches(n);
                }(t, o, i), M = function (e) {
                  if (e instanceof HTMLFormElement) return "form";
                  var t = e.tagName.toLowerCase().trim();
                  return p.test(t) ? "div" : t;
                }(t), O = {}, E = t.attributes.length, R = 0; R < E; R++) {
                var N = t.attributes[R];
                O[N.name] = I(a, M, N.name, N.value);
              }
              if ("link" === M && d) {
                var F = Array.from(a.styleSheets).find(function (e) {
                    return e.href === t.href;
                  }),
                  D = null;
                F && (D = r(F)), D && (delete O.rel, delete O.href, O._cssText = b(D, F.href));
              }
              if ("style" === M && t.sheet && !(t.innerText || t.textContent || "").trim().length) {
                (D = r(t.sheet)) && (O._cssText = b(D, k()));
              }
              if ("input" === M || "textarea" === M || "select" === M) {
                var B = t.value,
                  P = t.checked;
                "radio" !== O.type && "checkbox" !== O.type && "submit" !== O.type && "button" !== O.type && B ? O.value = s({
                  type: O.type,
                  tagName: M,
                  value: B,
                  maskInputOptions: h,
                  maskInputFn: g
                }) : P && (O.checked = P);
              }
              "option" === M && (t.selected && !h.select ? O.selected = !0 : delete O.selected);
              if ("canvas" === M && w) if ("2d" === t.__context) (function (e) {
                var t = e.getContext("2d");
                if (!t) return !0;
                for (var n = 0; n < e.width; n += 50) {
                  for (var a = 0; a < e.height; a += 50) {
                    var r = t.getImageData,
                      o = c in r ? r.__rrweb_original__ : r;
                    if (new Uint32Array(o.call(t, n, a, Math.min(50, e.width - n), Math.min(50, e.height - a)).data.buffer).some(function (e) {
                      return 0 !== e;
                    })) return !1;
                  }
                }
                return !0;
              })(t) || (O.rr_dataURL = t.toDataURL(v.type, v.quality));else if (!("__context" in t)) {
                var j = t.toDataURL(v.type, v.quality),
                  U = document.createElement("canvas");
                U.width = t.width, U.height = t.height, j !== U.toDataURL(v.type, v.quality) && (O.rr_dataURL = j);
              }
              if ("img" === M && y) {
                l || (l = a.createElement("canvas"), u = l.getContext("2d"));
                var q = t,
                  _ = q.crossOrigin;
                q.crossOrigin = "anonymous";
                var H = function H() {
                  try {
                    l.width = q.naturalWidth, l.height = q.naturalHeight, u.drawImage(q, 0, 0), O.rr_dataURL = l.toDataURL(v.type, v.quality);
                  } catch (e) {
                    console.warn("Cannot inline img src=".concat(q.currentSrc, "! Error: ").concat(e));
                  }
                  _ ? O.crossOrigin = _ : q.removeAttribute("crossorigin");
                };
                q.complete && 0 !== q.naturalWidth ? H() : q.onload = H;
              }
              "audio" !== M && "video" !== M || (O.rr_mediaState = t.paused ? "paused" : "played", O.rr_mediaCurrentTime = t.currentTime);
              L || (t.scrollLeft && (O.rr_scrollLeft = t.scrollLeft), t.scrollTop && (O.rr_scrollTop = t.scrollTop));
              if (T) {
                var W = t.getBoundingClientRect(),
                  z = W.width,
                  G = W.height;
                O = {
                  class: O.class,
                  rr_width: "".concat(z, "px"),
                  rr_height: "".concat(G, "px")
                };
              }
              "iframe" !== M || x(O.src) || (t.contentDocument || (O.rr_src = O.src), delete O.src);
              return {
                type: e.Element,
                tagName: M,
                attributes: O,
                childNodes: [],
                isSVG: C(t) || void 0,
                needBlock: T,
                rootId: A
              };
            }(t, {
              doc: a,
              blockClass: i,
              blockSelector: d,
              inlineStylesheet: g,
              maskInputOptions: v,
              maskInputFn: w,
              dataURLOptions: L,
              inlineImages: A,
              recordCanvas: T,
              keepIframeSrcFn: M,
              newlyAddedElement: E,
              rootId: R
            });
          case t.TEXT_NODE:
            return function (t, n) {
              var a,
                r = n.maskTextClass,
                o = n.maskTextSelector,
                i = n.maskTextFn,
                s = n.rootId,
                c = t.parentNode && t.parentNode.tagName,
                l = t.textContent,
                u = "STYLE" === c || void 0,
                d = "SCRIPT" === c || void 0;
              if (u && l) {
                try {
                  t.nextSibling || t.previousSibling || (null === (a = t.parentNode.sheet) || void 0 === a ? void 0 : a.cssRules) && (l = (p = t.parentNode.sheet).cssRules ? Array.from(p.cssRules).map(function (e) {
                    return e.cssText || "";
                  }).join("") : "");
                } catch (f) {
                  console.warn("Cannot get CSS styles from text's parentNode. Error: ".concat(f), t);
                }
                l = b(l, k());
              }
              var p;
              d && (l = "SCRIPT_PLACEHOLDER");
              !u && !d && l && S(t, r, o) && (l = i ? i(l) : l.replace(/[\S]/g, "*"));
              return {
                type: e.Text,
                textContent: l || "",
                isStyle: u,
                rootId: s
              };
            }(t, {
              maskTextClass: f,
              maskTextSelector: h,
              maskTextFn: y,
              rootId: R
            });
          case t.CDATA_SECTION_NODE:
            return {
              type: e.CDATA,
              textContent: "",
              rootId: R
            };
          case t.COMMENT_NODE:
            return {
              type: e.Comment,
              textContent: t.textContent || "",
              rootId: R
            };
          default:
            return !1;
        }
      }
      function A(e) {
        return void 0 === e ? "" : e.toLowerCase();
      }
      function T(t, r) {
        var o,
          i = r.doc,
          s = r.mirror,
          c = r.blockClass,
          l = r.blockSelector,
          u = r.maskTextClass,
          d = r.maskTextSelector,
          p = r.skipChild,
          h = void 0 !== p && p,
          g = r.inlineStylesheet,
          m = void 0 === g || g,
          b = r.maskInputOptions,
          v = void 0 === b ? {} : b,
          y = r.maskTextFn,
          w = r.maskInputFn,
          C = r.slimDOMOptions,
          k = r.dataURLOptions,
          I = void 0 === k ? {} : k,
          x = r.inlineImages,
          S = void 0 !== x && x,
          M = r.recordCanvas,
          O = void 0 !== M && M,
          E = r.onSerialize,
          R = r.onIframeLoad,
          N = r.iframeLoadTimeout,
          F = void 0 === N ? 5e3 : N,
          D = r.onStylesheetLoad,
          B = r.stylesheetLoadTimeout,
          P = void 0 === B ? 5e3 : B,
          j = r.keepIframeSrcFn,
          U = void 0 === j ? function () {
            return !1;
          } : j,
          q = r.newlyAddedElement,
          _ = void 0 !== q && q,
          H = r.preserveWhiteSpace,
          W = void 0 === H || H,
          z = L(t, {
            doc: i,
            mirror: s,
            blockClass: c,
            blockSelector: l,
            maskTextClass: u,
            maskTextSelector: d,
            inlineStylesheet: m,
            maskInputOptions: v,
            maskTextFn: y,
            maskInputFn: w,
            dataURLOptions: I,
            inlineImages: S,
            recordCanvas: O,
            keepIframeSrcFn: U,
            newlyAddedElement: _
          });
        if (!z) return console.warn(t, "not serialized"), null;
        o = s.hasNode(t) ? s.getId(t) : !function (t, n) {
          if (n.comment && t.type === e.Comment) return !0;
          if (t.type === e.Element) {
            if (n.script && ("script" === t.tagName || "link" === t.tagName && "preload" === t.attributes.rel && "script" === t.attributes.as || "link" === t.tagName && "prefetch" === t.attributes.rel && "string" == typeof t.attributes.href && t.attributes.href.endsWith(".js"))) return !0;
            if (n.headFavicon && ("link" === t.tagName && "shortcut icon" === t.attributes.rel || "meta" === t.tagName && (A(t.attributes.name).match(/^msapplication-tile(image|color)$/) || "application-name" === A(t.attributes.name) || "icon" === A(t.attributes.rel) || "apple-touch-icon" === A(t.attributes.rel) || "shortcut icon" === A(t.attributes.rel)))) return !0;
            if ("meta" === t.tagName) {
              if (n.headMetaDescKeywords && A(t.attributes.name).match(/^description|keywords$/)) return !0;
              if (n.headMetaSocial && (A(t.attributes.property).match(/^(og|twitter|fb):/) || A(t.attributes.name).match(/^(og|twitter):/) || "pinterest" === A(t.attributes.name))) return !0;
              if (n.headMetaRobots && ("robots" === A(t.attributes.name) || "googlebot" === A(t.attributes.name) || "bingbot" === A(t.attributes.name))) return !0;
              if (n.headMetaHttpEquiv && void 0 !== t.attributes["http-equiv"]) return !0;
              if (n.headMetaAuthorship && ("author" === A(t.attributes.name) || "generator" === A(t.attributes.name) || "framework" === A(t.attributes.name) || "publisher" === A(t.attributes.name) || "progid" === A(t.attributes.name) || A(t.attributes.property).match(/^article:/) || A(t.attributes.property).match(/^product:/))) return !0;
              if (n.headMetaVerification && ("google-site-verification" === A(t.attributes.name) || "yandex-verification" === A(t.attributes.name) || "csrf-token" === A(t.attributes.name) || "p:domain_verify" === A(t.attributes.name) || "verify-v1" === A(t.attributes.name) || "verification" === A(t.attributes.name) || "shopify-checkout-api-token" === A(t.attributes.name))) return !0;
            }
          }
          return !1;
        }(z, C) && (W || z.type !== e.Text || z.isStyle || z.textContent.replace(/^\s+|\s+$/gm, "").length) ? f() : -2;
        var G = Object.assign(z, {
          id: o
        });
        if (s.add(t, G), -2 === o) return null;
        E && E(t);
        var Z = !h;
        if (G.type === e.Element) {
          Z = Z && !G.needBlock, delete G.needBlock;
          var V = t.shadowRoot;
          V && a(V) && (G.isShadowHost = !0);
        }
        if ((G.type === e.Document || G.type === e.Element) && Z) {
          C.headWhitespace && G.type === e.Element && "head" === G.tagName && (W = !1);
          for (var K = {
              doc: i,
              mirror: s,
              blockClass: c,
              blockSelector: l,
              maskTextClass: u,
              maskTextSelector: d,
              skipChild: h,
              inlineStylesheet: m,
              maskInputOptions: v,
              maskTextFn: y,
              maskInputFn: w,
              slimDOMOptions: C,
              dataURLOptions: I,
              inlineImages: S,
              recordCanvas: O,
              preserveWhiteSpace: W,
              onSerialize: E,
              onIframeLoad: R,
              iframeLoadTimeout: F,
              onStylesheetLoad: D,
              stylesheetLoadTimeout: P,
              keepIframeSrcFn: U
            }, X = 0, Y = Array.from(t.childNodes); X < Y.length; X++) {
            ($ = T(Y[X], K)) && G.childNodes.push($);
          }
          if (function (e) {
            return e.nodeType === e.ELEMENT_NODE;
          }(t) && t.shadowRoot) for (var J = 0, Q = Array.from(t.shadowRoot.childNodes); J < Q.length; J++) {
            var $;
            ($ = T(Q[J], K)) && (a(t.shadowRoot) && ($.isShadow = !0), G.childNodes.push($));
          }
        }
        return t.parentNode && n(t.parentNode) && a(t.parentNode) && (G.isShadow = !0), G.type === e.Element && "iframe" === G.tagName && function (e, t, n) {
          var a = e.contentWindow;
          if (a) {
            var r,
              o = !1;
            try {
              r = a.document.readyState;
            } catch (c) {
              return;
            }
            if ("complete" === r) {
              var i = "about:blank";
              if (a.location.href !== i || e.src === i || "" === e.src) return setTimeout(t, 0), e.addEventListener("load", t);
              e.addEventListener("load", t);
            } else {
              var s = setTimeout(function () {
                o || (t(), o = !0);
              }, n);
              e.addEventListener("load", function () {
                clearTimeout(s), o = !0, t();
              });
            }
          }
        }(t, function () {
          var e = t.contentDocument;
          if (e && R) {
            var n = T(e, {
              doc: e,
              mirror: s,
              blockClass: c,
              blockSelector: l,
              maskTextClass: u,
              maskTextSelector: d,
              skipChild: !1,
              inlineStylesheet: m,
              maskInputOptions: v,
              maskTextFn: y,
              maskInputFn: w,
              slimDOMOptions: C,
              dataURLOptions: I,
              inlineImages: S,
              recordCanvas: O,
              preserveWhiteSpace: W,
              onSerialize: E,
              onIframeLoad: R,
              iframeLoadTimeout: F,
              onStylesheetLoad: D,
              stylesheetLoadTimeout: P,
              keepIframeSrcFn: U
            });
            n && R(t, n);
          }
        }, F), G.type === e.Element && "link" === G.tagName && "stylesheet" === G.attributes.rel && function (e, t, n) {
          var a,
            r = !1;
          try {
            a = e.sheet;
          } catch (i) {
            return;
          }
          if (!a) {
            var o = setTimeout(function () {
              r || (t(), r = !0);
            }, n);
            e.addEventListener("load", function () {
              clearTimeout(o), r = !0, t();
            });
          }
        }(t, function () {
          if (D) {
            var e = T(t, {
              doc: i,
              mirror: s,
              blockClass: c,
              blockSelector: l,
              maskTextClass: u,
              maskTextSelector: d,
              skipChild: !1,
              inlineStylesheet: m,
              maskInputOptions: v,
              maskTextFn: y,
              maskInputFn: w,
              slimDOMOptions: C,
              dataURLOptions: I,
              inlineImages: S,
              recordCanvas: O,
              preserveWhiteSpace: W,
              onSerialize: E,
              onIframeLoad: R,
              iframeLoadTimeout: F,
              onStylesheetLoad: D,
              stylesheetLoadTimeout: P,
              keepIframeSrcFn: U
            });
            e && D(t, e);
          }
        }, P), G;
      }
      function M(e, t) {
        var n = t || {},
          a = n.mirror,
          r = void 0 === a ? new i() : a,
          o = n.blockClass,
          s = void 0 === o ? "rr-block" : o,
          c = n.blockSelector,
          l = void 0 === c ? null : c,
          u = n.maskTextClass,
          d = void 0 === u ? "rr-mask" : u,
          p = n.maskTextSelector,
          f = void 0 === p ? null : p,
          h = n.inlineStylesheet,
          g = void 0 === h || h,
          m = n.inlineImages,
          b = void 0 !== m && m,
          v = n.recordCanvas,
          y = void 0 !== v && v,
          w = n.maskAllInputs,
          C = void 0 !== w && w,
          k = n.maskTextFn,
          I = n.maskInputFn,
          x = n.slimDOM,
          S = void 0 !== x && x,
          L = n.dataURLOptions,
          A = n.preserveWhiteSpace,
          M = n.onSerialize,
          O = n.onIframeLoad,
          E = n.iframeLoadTimeout,
          R = n.onStylesheetLoad,
          N = n.stylesheetLoadTimeout,
          F = n.keepIframeSrcFn;
        return T(e, {
          doc: e,
          mirror: r,
          blockClass: s,
          blockSelector: l,
          maskTextClass: d,
          maskTextSelector: f,
          skipChild: !1,
          inlineStylesheet: g,
          maskInputOptions: !0 === C ? {
            color: !0,
            date: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
            textarea: !0,
            select: !0,
            password: !0
          } : !1 === C ? {
            password: !0
          } : C,
          maskTextFn: k,
          maskInputFn: I,
          slimDOMOptions: !0 === S || "all" === S ? {
            script: !0,
            comment: !0,
            headFavicon: !0,
            headWhitespace: !0,
            headMetaDescKeywords: "all" === S,
            headMetaSocial: !0,
            headMetaRobots: !0,
            headMetaHttpEquiv: !0,
            headMetaAuthorship: !0,
            headMetaVerification: !0
          } : !1 === S ? {} : S,
          dataURLOptions: L,
          inlineImages: b,
          recordCanvas: y,
          preserveWhiteSpace: A,
          onSerialize: M,
          onIframeLoad: O,
          iframeLoadTimeout: E,
          onStylesheetLoad: R,
          stylesheetLoadTimeout: N,
          keepIframeSrcFn: void 0 === F ? function () {
            return !1;
          } : F,
          newlyAddedElement: !1
        });
      }
      function O(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : document,
          a = {
            capture: !0,
            passive: !0
          };
        return n.addEventListener(e, t, a), function () {
          return n.removeEventListener(e, t, a);
        };
      }
      var E = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.",
        R = {
          map: {},
          getId: function getId() {
            return console.error(E), -1;
          },
          getNode: function getNode() {
            return console.error(E), null;
          },
          removeNodeFromMap: function removeNodeFromMap() {
            console.error(E);
          },
          has: function has() {
            return console.error(E), !1;
          },
          reset: function reset() {
            console.error(E);
          }
        };
      function N(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          a = null,
          r = 0;
        return function () {
          for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
            i[s] = arguments[s];
          }
          var c = Date.now();
          r || !1 !== n.leading || (r = c);
          var l = t - (c - r),
            u = this;
          l <= 0 || l > t ? (a && (clearTimeout(a), a = null), r = c, e.apply(u, i)) : a || !1 === n.trailing || (a = setTimeout(function () {
            r = !1 === n.leading ? 0 : Date.now(), a = null, e.apply(u, i);
          }, l));
        };
      }
      function F(e, t, n, a) {
        var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : window,
          o = r.Object.getOwnPropertyDescriptor(e, t);
        return r.Object.defineProperty(e, t, a ? n : {
          set: function set(e) {
            var t = this;
            setTimeout(function () {
              n.set.call(t, e);
            }, 0), o && o.set && o.set.call(this, e);
          }
        }), function () {
          return F(e, t, o || {}, !0);
        };
      }
      function D(e, t, n) {
        try {
          if (!(t in e)) return function () {};
          var a = e[t],
            r = n(a);
          return "function" == typeof r && (r.prototype = r.prototype || {}, Object.defineProperties(r, {
            __rrweb_original__: {
              enumerable: !1,
              value: a
            }
          })), e[t] = r, function () {
            e[t] = a;
          };
        } catch (o) {
          return function () {};
        }
      }
      function B() {
        return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
      }
      function P() {
        return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
      }
      function j(e, t, n, a) {
        if (!e) return !1;
        var r = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
        if (!r) return !1;
        if ("string" == typeof t) {
          if (r.classList.contains(t)) return !0;
          if (a && null !== r.closest("." + t)) return !0;
        } else if (x(r, t, a)) return !0;
        if (n) {
          if (e.matches(n)) return !0;
          if (a && null !== r.closest(n)) return !0;
        }
        return !1;
      }
      function U(e, t) {
        return -2 === t.getId(e);
      }
      function q(e, t) {
        if (n(e)) return !1;
        var a = t.getId(e);
        return !t.has(a) || (!e.parentNode || e.parentNode.nodeType !== e.DOCUMENT_NODE) && (!e.parentNode || q(e.parentNode, t));
      }
      function _(e) {
        return Boolean(e.changedTouches);
      }
      function H() {
        var e = this,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window;
        "NodeList" in t && !t.NodeList.prototype.forEach && (t.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in t && !t.DOMTokenList.prototype.forEach && (t.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = function () {
          for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++) {
            n[a] = arguments[a];
          }
          var r = n[0];
          if (!(0 in n)) throw new TypeError("1 argument is required");
          do {
            if (e === r) return !0;
          } while (r = r && r.parentNode);
          return !1;
        });
      }
      function W(e, t) {
        return Boolean("IFRAME" === e.nodeName && t.getMeta(e));
      }
      function z(e, t) {
        return Boolean("LINK" === e.nodeName && e.nodeType === e.ELEMENT_NODE && e.getAttribute && "stylesheet" === e.getAttribute("rel") && t.getMeta(e));
      }
      function G(e) {
        return Boolean(null == e ? void 0 : e.shadowRoot);
      }
      "undefined" != typeof window && window.Proxy && window.Reflect && (R = new Proxy(R, {
        get: function get(e, t, n) {
          return "map" === t && console.error(E), Reflect.get(e, t, n);
        }
      }));
      var Z = function () {
          function e() {
            Ne(this, e), this.id = 1, this.styleIDMap = new WeakMap(), this.idStyleMap = new Map();
          }
          return De(e, [{
            key: "getId",
            value: function value(e) {
              var t;
              return null != (t = this.styleIDMap.get(e)) ? t : -1;
            }
          }, {
            key: "has",
            value: function value(e) {
              return this.styleIDMap.has(e);
            }
          }, {
            key: "add",
            value: function value(e, t) {
              return this.has(e) ? this.getId(e) : (n = void 0 === t ? this.id++ : t, this.styleIDMap.set(e, n), this.idStyleMap.set(n, e), n);
              var n;
            }
          }, {
            key: "getStyle",
            value: function value(e) {
              return this.idStyleMap.get(e) || null;
            }
          }, {
            key: "reset",
            value: function value() {
              this.styleIDMap = new WeakMap(), this.idStyleMap = new Map(), this.id = 1;
            }
          }, {
            key: "generateId",
            value: function value() {
              return this.id++;
            }
          }]), e;
        }(),
        V = function (e) {
          return e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e;
        }(V || {}),
        K = function (e) {
          return e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e;
        }(K || {}),
        X = function (e) {
          return e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e;
        }(X || {}),
        Y = function (e) {
          return e[e["2D"] = 0] = "2D", e[e.WebGL = 1] = "WebGL", e[e.WebGL2 = 2] = "WebGL2", e;
        }(Y || {}),
        J = function (e) {
          return e[e.Play = 0] = "Play", e[e.Pause = 1] = "Pause", e[e.Seeked = 2] = "Seeked", e[e.VolumeChange = 3] = "VolumeChange", e[e.RateChange = 4] = "RateChange", e;
        }(J || {});
      function Q(e) {
        return "__ln" in e;
      }
      var $ = function () {
          function e() {
            Ne(this, e), this.length = 0, this.head = null;
          }
          return De(e, [{
            key: "get",
            value: function value(e) {
              if (e >= this.length) throw new Error("Position outside of list range");
              for (var t = this.head, n = 0; n < e; n++) {
                t = (null == t ? void 0 : t.next) || null;
              }
              return t;
            }
          }, {
            key: "addNode",
            value: function value(e) {
              var t = {
                value: e,
                previous: null,
                next: null
              };
              if (e.__ln = t, e.previousSibling && Q(e.previousSibling)) {
                var n = e.previousSibling.__ln.next;
                t.next = n, t.previous = e.previousSibling.__ln, e.previousSibling.__ln.next = t, n && (n.previous = t);
              } else if (e.nextSibling && Q(e.nextSibling) && e.nextSibling.__ln.previous) {
                var a = e.nextSibling.__ln.previous;
                t.previous = a, t.next = e.nextSibling.__ln, e.nextSibling.__ln.previous = t, a && (a.next = t);
              } else this.head && (this.head.previous = t), t.next = this.head, this.head = t;
              this.length++;
            }
          }, {
            key: "removeNode",
            value: function value(e) {
              var t = e.__ln;
              this.head && (t.previous ? (t.previous.next = t.next, t.next && (t.next.previous = t.previous)) : (this.head = t.next, this.head && (this.head.previous = null)), e.__ln && delete e.__ln, this.length--);
            }
          }]), e;
        }(),
        ee = function ee(e, t) {
          return "".concat(e, "@").concat(t);
        },
        te = function () {
          function e() {
            var t = this;
            Ne(this, e), this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = new Set(), this.movedSet = new Set(), this.droppedSet = new Set(), this.processMutations = function (e) {
              e.forEach(t.processMutation), t.emit();
            }, this.emit = function () {
              if (!t.frozen && !t.locked) {
                for (var e = [], a = new $(), r = function r(e) {
                    for (var n = e, a = -2; -2 === a;) {
                      a = (n = n && n.nextSibling) && t.mirror.getId(n);
                    }
                    return a;
                  }, o = function o(_o) {
                    var i,
                      s,
                      c,
                      l,
                      u = null;
                    (null == (s = null == (i = _o.getRootNode) ? void 0 : i.call(_o)) ? void 0 : s.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && _o.getRootNode().host && (u = _o.getRootNode().host);
                    for (var d = u; (null == (l = null == (c = null == d ? void 0 : d.getRootNode) ? void 0 : c.call(d)) ? void 0 : l.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && d.getRootNode().host;) {
                      d = d.getRootNode().host;
                    }
                    var p = !(t.doc.contains(_o) || d && t.doc.contains(d));
                    if (_o.parentNode && !p) {
                      var f = n(_o.parentNode) ? t.mirror.getId(u) : t.mirror.getId(_o.parentNode),
                        h = r(_o);
                      if (-1 === f || -1 === h) return a.addNode(_o);
                      var g = T(_o, {
                        doc: t.doc,
                        mirror: t.mirror,
                        blockClass: t.blockClass,
                        blockSelector: t.blockSelector,
                        maskTextClass: t.maskTextClass,
                        maskTextSelector: t.maskTextSelector,
                        skipChild: !0,
                        newlyAddedElement: !0,
                        inlineStylesheet: t.inlineStylesheet,
                        maskInputOptions: t.maskInputOptions,
                        maskTextFn: t.maskTextFn,
                        maskInputFn: t.maskInputFn,
                        slimDOMOptions: t.slimDOMOptions,
                        dataURLOptions: t.dataURLOptions,
                        recordCanvas: t.recordCanvas,
                        inlineImages: t.inlineImages,
                        onSerialize: function onSerialize(e) {
                          W(e, t.mirror) && t.iframeManager.addIframe(e), z(e, t.mirror) && t.stylesheetManager.trackLinkElement(e), G(_o) && t.shadowDomManager.addShadowRoot(_o.shadowRoot, t.doc);
                        },
                        onIframeLoad: function onIframeLoad(e, n) {
                          t.iframeManager.attachIframe(e, n), t.shadowDomManager.observeAttachShadow(e);
                        },
                        onStylesheetLoad: function onStylesheetLoad(e, n) {
                          t.stylesheetManager.attachLinkElement(e, n);
                        }
                      });
                      g && e.push({
                        parentId: f,
                        nextId: h,
                        node: g
                      });
                    }
                  }; t.mapRemoves.length;) {
                  t.mirror.removeNodeFromMap(t.mapRemoves.shift());
                }
                for (var i = 0, s = Array.from(t.movedSet.values()); i < s.length; i++) {
                  var c = s[i];
                  ae(t.removes, c, t.mirror) && !t.movedSet.has(c.parentNode) || o(c);
                }
                for (var l = 0, u = Array.from(t.addedSet.values()); l < u.length; l++) {
                  var d = u[l];
                  oe(t.droppedSet, d) || ae(t.removes, d, t.mirror) ? oe(t.movedSet, d) ? o(d) : t.droppedSet.add(d) : o(d);
                }
                for (var p = null; a.length;) {
                  var f = null;
                  if (p) {
                    var h = t.mirror.getId(p.value.parentNode),
                      g = r(p.value);
                    -1 !== h && -1 !== g && (f = p);
                  }
                  if (!f) for (var m = a.length - 1; m >= 0; m--) {
                    var b = a.get(m);
                    if (b) {
                      var v = t.mirror.getId(b.value.parentNode);
                      if (-1 === r(b.value)) continue;
                      if (-1 !== v) {
                        f = b;
                        break;
                      }
                      var y = b.value;
                      if (y.parentNode && y.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                        var w = y.parentNode.host;
                        if (-1 !== t.mirror.getId(w)) {
                          f = b;
                          break;
                        }
                      }
                    }
                  }
                  if (!f) {
                    for (; a.head;) {
                      a.removeNode(a.head.value);
                    }
                    break;
                  }
                  p = f.previous, a.removeNode(f.value), o(f.value);
                }
                var C = {
                  texts: t.texts.map(function (e) {
                    return {
                      id: t.mirror.getId(e.node),
                      value: e.value
                    };
                  }).filter(function (e) {
                    return t.mirror.has(e.id);
                  }),
                  attributes: t.attributes.map(function (e) {
                    return {
                      id: t.mirror.getId(e.node),
                      attributes: e.attributes
                    };
                  }).filter(function (e) {
                    return t.mirror.has(e.id);
                  }),
                  removes: t.removes,
                  adds: e
                };
                (C.texts.length || C.attributes.length || C.removes.length || C.adds.length) && (t.texts = [], t.attributes = [], t.removes = [], t.addedSet = new Set(), t.movedSet = new Set(), t.droppedSet = new Set(), t.movedMap = {}, t.mutationCb(C));
              }
            }, this.processMutation = function (e) {
              if (!U(e.target, t.mirror)) switch (e.type) {
                case "characterData":
                  var r = e.target.textContent;
                  j(e.target, t.blockClass, t.blockSelector, !1) || r === e.oldValue || t.texts.push({
                    value: S(e.target, t.maskTextClass, t.maskTextSelector) && r ? t.maskTextFn ? t.maskTextFn(r) : r.replace(/[\S]/g, "*") : r,
                    node: e.target
                  });
                  break;
                case "attributes":
                  var o = e.target,
                    i = e.target.getAttribute(e.attributeName);
                  if ("value" === e.attributeName && (i = s({
                    maskInputOptions: t.maskInputOptions,
                    tagName: e.target.tagName,
                    type: e.target.getAttribute("type"),
                    value: i,
                    maskInputFn: t.maskInputFn
                  })), j(e.target, t.blockClass, t.blockSelector, !1) || i === e.oldValue) return;
                  var c = t.attributes.find(function (t) {
                    return t.node === e.target;
                  });
                  if ("IFRAME" === o.tagName && "src" === e.attributeName && !t.keepIframeSrcFn(i)) {
                    if (o.contentDocument) return;
                    e.attributeName = "rr_src";
                  }
                  if (c || (c = {
                    node: e.target,
                    attributes: {}
                  }, t.attributes.push(c)), "style" === e.attributeName) {
                    var l = t.doc.createElement("span");
                    e.oldValue && l.setAttribute("style", e.oldValue), void 0 !== c.attributes.style && null !== c.attributes.style || (c.attributes.style = {});
                    for (var u = c.attributes.style, d = 0, p = Array.from(o.style); d < p.length; d++) {
                      var f = p[d],
                        h = o.style.getPropertyValue(f),
                        g = o.style.getPropertyPriority(f);
                      h === l.style.getPropertyValue(f) && g === l.style.getPropertyPriority(f) || (u[f] = "" === g ? h : [h, g]);
                    }
                    for (var m = 0, b = Array.from(l.style); m < b.length; m++) {
                      var v = b[m];
                      "" === o.style.getPropertyValue(v) && (u[v] = !1);
                    }
                  } else c.attributes[e.attributeName] = I(t.doc, o.tagName, e.attributeName, i);
                  break;
                case "childList":
                  if (j(e.target, t.blockClass, t.blockSelector, !0)) return;
                  e.addedNodes.forEach(function (n) {
                    return t.genAdds(n, e.target);
                  }), e.removedNodes.forEach(function (r) {
                    var o = t.mirror.getId(r),
                      i = n(e.target) ? t.mirror.getId(e.target.host) : t.mirror.getId(e.target);
                    j(e.target, t.blockClass, t.blockSelector, !1) || U(r, t.mirror) || !function (e, t) {
                      return -1 !== t.getId(e);
                    }(r, t.mirror) || (t.addedSet.has(r) ? (ne(t.addedSet, r), t.droppedSet.add(r)) : t.addedSet.has(e.target) && -1 === o || q(e.target, t.mirror) || (t.movedSet.has(r) && t.movedMap[ee(o, i)] ? ne(t.movedSet, r) : t.removes.push({
                      parentId: i,
                      id: o,
                      isShadow: !(!n(e.target) || !a(e.target)) || void 0
                    })), t.mapRemoves.push(r));
                  });
              }
            }, this.genAdds = function (e, n) {
              if (t.mirror.hasNode(e)) {
                if (U(e, t.mirror)) return;
                t.movedSet.add(e);
                var a = null;
                n && t.mirror.hasNode(n) && (a = t.mirror.getId(n)), a && -1 !== a && (t.movedMap[ee(t.mirror.getId(e), a)] = !0);
              } else t.addedSet.add(e), t.droppedSet.delete(e);
              j(e, t.blockClass, t.blockSelector, !1) || e.childNodes.forEach(function (e) {
                return t.genAdds(e);
              });
            };
          }
          return De(e, [{
            key: "init",
            value: function value(e) {
              var t = this;
              ["mutationCb", "blockClass", "blockSelector", "maskTextClass", "maskTextSelector", "inlineStylesheet", "maskInputOptions", "maskTextFn", "maskInputFn", "keepIframeSrcFn", "recordCanvas", "inlineImages", "slimDOMOptions", "dataURLOptions", "doc", "mirror", "iframeManager", "stylesheetManager", "shadowDomManager", "canvasManager"].forEach(function (n) {
                t[n] = e[n];
              });
            }
          }, {
            key: "freeze",
            value: function value() {
              this.frozen = !0, this.canvasManager.freeze();
            }
          }, {
            key: "unfreeze",
            value: function value() {
              this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
            }
          }, {
            key: "isFrozen",
            value: function value() {
              return this.frozen;
            }
          }, {
            key: "lock",
            value: function value() {
              this.locked = !0, this.canvasManager.lock();
            }
          }, {
            key: "unlock",
            value: function value() {
              this.locked = !1, this.canvasManager.unlock(), this.emit();
            }
          }, {
            key: "reset",
            value: function value() {
              this.shadowDomManager.reset(), this.canvasManager.reset();
            }
          }]), e;
        }();
      function ne(e, t) {
        e.delete(t), t.childNodes.forEach(function (t) {
          return ne(e, t);
        });
      }
      function ae(e, t, n) {
        return 0 !== e.length && re(e, t, n);
      }
      function re(e, t, n) {
        var a = t.parentNode;
        if (!a) return !1;
        var r = n.getId(a);
        return !!e.some(function (e) {
          return e.id === r;
        }) || re(e, a, n);
      }
      function oe(e, t) {
        return 0 !== e.size && ie(e, t);
      }
      function ie(e, t) {
        var n = t.parentNode;
        return !!n && (!!e.has(n) || ie(e, n));
      }
      var se = Object.defineProperty,
        ce = Object.defineProperties,
        le = Object.getOwnPropertyDescriptors,
        ue = Object.getOwnPropertySymbols,
        de = Object.prototype.hasOwnProperty,
        pe = Object.prototype.propertyIsEnumerable,
        fe = function fe(e, t, n) {
          return t in e ? se(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
          }) : e[t] = n;
        },
        he = function he(e, t) {
          for (var n in t || (t = {})) {
            de.call(t, n) && fe(e, n, t[n]);
          }
          if (ue) {
            var a,
              r = Oe(ue(t));
            try {
              for (r.s(); !(a = r.n()).done;) {
                n = a.value;
                pe.call(t, n) && fe(e, n, t[n]);
              }
            } catch (o) {
              r.e(o);
            } finally {
              r.f();
            }
          }
          return e;
        },
        ge = [],
        me = "undefined" != typeof CSSGroupingRule,
        be = "undefined" != typeof CSSMediaRule,
        ve = "undefined" != typeof CSSSupportsRule,
        ye = "undefined" != typeof CSSConditionRule;
      function we(e) {
        try {
          if ("composedPath" in e) {
            var t = e.composedPath();
            if (t.length) return t[0];
          } else if ("path" in e && e.path.length) return e.path[0];
          return e.target;
        } catch (n) {
          return e.target;
        }
      }
      function Ce(e, t) {
        var n,
          a,
          r = new te();
        ge.push(r), r.init(e);
        var o = window.MutationObserver || window.__rrMutationObserver,
          i = null == (a = null == (n = null == window ? void 0 : window.Zone) ? void 0 : n.__symbol__) ? void 0 : a.call(n, "MutationObserver");
        i && window[i] && (o = window[i]);
        var s = new o(r.processMutations.bind(r));
        return s.observe(t, {
          attributes: !0,
          attributeOldValue: !0,
          characterData: !0,
          characterDataOldValue: !0,
          childList: !0,
          subtree: !0
        }), s;
      }
      function ke(e) {
        var t = e.mousemoveCb,
          n = e.sampling,
          a = e.doc,
          r = e.mirror;
        if (!1 === n.mousemove) return function () {};
        var o,
          i = "number" == typeof n.mousemove ? n.mousemove : 50,
          s = "number" == typeof n.mousemoveCallback ? n.mousemoveCallback : 500,
          c = [],
          l = N(function (e) {
            var n = Date.now() - o;
            t(c.map(function (e) {
              return e.timeOffset -= n, e;
            }), e), c = [], o = null;
          }, s),
          u = N(function (e) {
            var t = we(e),
              n = _(e) ? e.changedTouches[0] : e,
              a = n.clientX,
              i = n.clientY;
            o || (o = Date.now()), c.push({
              x: a,
              y: i,
              id: r.getId(t),
              timeOffset: Date.now() - o
            }), l("undefined" != typeof DragEvent && e instanceof DragEvent ? K.Drag : e instanceof MouseEvent ? K.MouseMove : K.TouchMove);
          }, i, {
            trailing: !1
          }),
          d = [O("mousemove", u, a), O("touchmove", u, a), O("drag", u, a)];
        return function () {
          d.forEach(function (e) {
            return e();
          });
        };
      }
      function Ie(e) {
        var t = e.mouseInteractionCb,
          n = e.doc,
          a = e.mirror,
          r = e.blockClass,
          o = e.blockSelector,
          i = e.sampling;
        if (!1 === i.mouseInteraction) return function () {};
        var s = !0 === i.mouseInteraction || void 0 === i.mouseInteraction ? {} : i.mouseInteraction,
          c = [];
        return Object.keys(X).filter(function (e) {
          return Number.isNaN(Number(e)) && !e.endsWith("_Departed") && !1 !== s[e];
        }).forEach(function (e) {
          var i = e.toLowerCase(),
            s = function (e) {
              return function (n) {
                var i = we(n);
                if (!j(i, r, o, !0)) {
                  var s = _(n) ? n.changedTouches[0] : n;
                  if (s) {
                    var c = a.getId(i),
                      l = s.clientX,
                      u = s.clientY;
                    t({
                      type: X[e],
                      id: c,
                      x: l,
                      y: u
                    });
                  }
                }
              };
            }(e);
          c.push(O(i, s, n));
        }), function () {
          c.forEach(function (e) {
            return e();
          });
        };
      }
      function xe(e) {
        var t = e.scrollCb,
          n = e.doc,
          a = e.mirror,
          r = e.blockClass,
          o = e.blockSelector;
        return O("scroll", N(function (e) {
          var i = we(e);
          if (i && !j(i, r, o, !0)) {
            var s = a.getId(i);
            if (i === n) {
              var c = n.scrollingElement || n.documentElement;
              t({
                id: s,
                x: c.scrollLeft,
                y: c.scrollTop
              });
            } else t({
              id: s,
              x: i.scrollLeft,
              y: i.scrollTop
            });
          }
        }, e.sampling.scroll || 100), n);
      }
      function Se(e) {
        var t = e.viewportResizeCb,
          n = -1,
          a = -1;
        return O("resize", N(function () {
          var e = B(),
            r = P();
          n === e && a === r || (t({
            width: Number(r),
            height: Number(e)
          }), n = e, a = r);
        }, 200), window);
      }
      function Le(e, t) {
        var n = he({}, e);
        return t || delete n.userTriggered, n;
      }
      var Ee = ["INPUT", "TEXTAREA", "SELECT"],
        Re = new WeakMap();
      function Fe(e) {
        var t = e.inputCb,
          n = e.doc,
          a = e.mirror,
          r = e.blockClass,
          o = e.blockSelector,
          i = e.ignoreClass,
          c = e.maskInputOptions,
          l = e.maskInputFn,
          u = e.sampling,
          d = e.userTriggeredOnInput;
        function p(e) {
          var t = we(e),
            a = e.isTrusted;
          if (t && "OPTION" === t.tagName && (t = t.parentElement), t && t.tagName && !(Ee.indexOf(t.tagName) < 0) && !j(t, r, o, !0)) {
            var u = t.type;
            if (!t.classList.contains(i)) {
              var p = t.value,
                h = !1;
              "radio" === u || "checkbox" === u ? h = t.checked : (c[t.tagName.toLowerCase()] || c[u]) && (p = s({
                maskInputOptions: c,
                tagName: t.tagName,
                type: u,
                value: p,
                maskInputFn: l
              })), f(t, Le({
                text: p,
                isChecked: h,
                userTriggered: a
              }, d));
              var g = t.name;
              "radio" === u && g && h && n.querySelectorAll('input[type="radio"][name="'.concat(g, '"]')).forEach(function (e) {
                e !== t && f(e, Le({
                  text: e.value,
                  isChecked: !h,
                  userTriggered: !1
                }, d));
              });
            }
          }
        }
        function f(e, n) {
          var r,
            o = Re.get(e);
          if (!o || o.text !== n.text || o.isChecked !== n.isChecked) {
            Re.set(e, n);
            var i = a.getId(e);
            t((r = he({}, n), ce(r, le({
              id: i
            }))));
          }
        }
        var h = ("last" === u.input ? ["change"] : ["input", "change"]).map(function (e) {
            return O(e, p, n);
          }),
          g = n.defaultView;
        if (!g) return function () {
          h.forEach(function (e) {
            return e();
          });
        };
        var m = g.Object.getOwnPropertyDescriptor(g.HTMLInputElement.prototype, "value"),
          b = [[g.HTMLInputElement.prototype, "value"], [g.HTMLInputElement.prototype, "checked"], [g.HTMLSelectElement.prototype, "value"], [g.HTMLTextAreaElement.prototype, "value"], [g.HTMLSelectElement.prototype, "selectedIndex"], [g.HTMLOptionElement.prototype, "selected"]];
        return m && m.set && h.push.apply(h, Me(b.map(function (e) {
          return F(e[0], e[1], {
            set: function set() {
              p({
                target: this
              });
            }
          }, !1, g);
        }))), function () {
          h.forEach(function (e) {
            return e();
          });
        };
      }
      function Be(e) {
        return function (e, t) {
          if (me && e.parentRule instanceof CSSGroupingRule || be && e.parentRule instanceof CSSMediaRule || ve && e.parentRule instanceof CSSSupportsRule || ye && e.parentRule instanceof CSSConditionRule) {
            var n = Array.from(e.parentRule.cssRules).indexOf(e);
            t.unshift(n);
          } else if (e.parentStyleSheet) {
            var a = Array.from(e.parentStyleSheet.cssRules).indexOf(e);
            t.unshift(a);
          }
          return t;
        }(e, []);
      }
      function Pe(e, t, n) {
        var a, r;
        return e ? (e.ownerNode ? a = t.getId(e.ownerNode) : r = n.getId(e), {
          styleId: r,
          id: a
        }) : {};
      }
      function je(e, t) {
        var n = e.styleSheetRuleCb,
          a = e.mirror,
          r = e.stylesheetManager,
          o = t.win,
          i = o.CSSStyleSheet.prototype.insertRule;
        o.CSSStyleSheet.prototype.insertRule = function (e, t) {
          var o = Pe(this, a, r.styleMirror),
            s = o.id,
            c = o.styleId;
          return (s && -1 !== s || c && -1 !== c) && n({
            id: s,
            styleId: c,
            adds: [{
              rule: e,
              index: t
            }]
          }), i.apply(this, [e, t]);
        };
        var s,
          c,
          l = o.CSSStyleSheet.prototype.deleteRule;
        o.CSSStyleSheet.prototype.deleteRule = function (e) {
          var t = Pe(this, a, r.styleMirror),
            o = t.id,
            i = t.styleId;
          return (o && -1 !== o || i && -1 !== i) && n({
            id: o,
            styleId: i,
            removes: [{
              index: e
            }]
          }), l.apply(this, [e]);
        }, o.CSSStyleSheet.prototype.replace && (s = o.CSSStyleSheet.prototype.replace, o.CSSStyleSheet.prototype.replace = function (e) {
          var t = Pe(this, a, r.styleMirror),
            o = t.id,
            i = t.styleId;
          return (o && -1 !== o || i && -1 !== i) && n({
            id: o,
            styleId: i,
            replace: e
          }), s.apply(this, [e]);
        }), o.CSSStyleSheet.prototype.replaceSync && (c = o.CSSStyleSheet.prototype.replaceSync, o.CSSStyleSheet.prototype.replaceSync = function (e) {
          var t = Pe(this, a, r.styleMirror),
            o = t.id,
            i = t.styleId;
          return (o && -1 !== o || i && -1 !== i) && n({
            id: o,
            styleId: i,
            replaceSync: e
          }), c.apply(this, [e]);
        });
        var u = {};
        me ? u.CSSGroupingRule = o.CSSGroupingRule : (be && (u.CSSMediaRule = o.CSSMediaRule), ye && (u.CSSConditionRule = o.CSSConditionRule), ve && (u.CSSSupportsRule = o.CSSSupportsRule));
        var d = {};
        return Object.entries(u).forEach(function (e) {
          var t = Te(e, 2),
            o = t[0],
            i = t[1];
          d[o] = {
            insertRule: i.prototype.insertRule,
            deleteRule: i.prototype.deleteRule
          }, i.prototype.insertRule = function (e, t) {
            var i = Pe(this.parentStyleSheet, a, r.styleMirror),
              s = i.id,
              c = i.styleId;
            return (s && -1 !== s || c && -1 !== c) && n({
              id: s,
              styleId: c,
              adds: [{
                rule: e,
                index: [].concat(Me(Be(this)), [t || 0])
              }]
            }), d[o].insertRule.apply(this, [e, t]);
          }, i.prototype.deleteRule = function (e) {
            var t = Pe(this.parentStyleSheet, a, r.styleMirror),
              i = t.id,
              s = t.styleId;
            return (i && -1 !== i || s && -1 !== s) && n({
              id: i,
              styleId: s,
              removes: [{
                index: [].concat(Me(Be(this)), [e])
              }]
            }), d[o].deleteRule.apply(this, [e]);
          };
        }), function () {
          o.CSSStyleSheet.prototype.insertRule = i, o.CSSStyleSheet.prototype.deleteRule = l, s && (o.CSSStyleSheet.prototype.replace = s), c && (o.CSSStyleSheet.prototype.replaceSync = c), Object.entries(u).forEach(function (e) {
            var t = Te(e, 2),
              n = t[0],
              a = t[1];
            a.prototype.insertRule = d[n].insertRule, a.prototype.deleteRule = d[n].deleteRule;
          });
        };
      }
      function Ue(e, t) {
        var n,
          a,
          r,
          o = e.mirror,
          i = e.stylesheetManager,
          s = null;
        s = "#document" === t.nodeName ? o.getId(t) : o.getId(t.host);
        var c = "#document" === t.nodeName ? null == (n = t.defaultView) ? void 0 : n.Document : null == (r = null == (a = t.ownerDocument) ? void 0 : a.defaultView) ? void 0 : r.ShadowRoot,
          l = Object.getOwnPropertyDescriptor(null == c ? void 0 : c.prototype, "adoptedStyleSheets");
        return null !== s && -1 !== s && c && l ? (Object.defineProperty(t, "adoptedStyleSheets", {
          configurable: l.configurable,
          enumerable: l.enumerable,
          get: function get() {
            var e;
            return null == (e = l.get) ? void 0 : e.call(this);
          },
          set: function set(e) {
            var t,
              n = null == (t = l.set) ? void 0 : t.call(this, e);
            if (null !== s && -1 !== s) try {
              i.adoptStyleSheets(e, s);
            } catch (a) {}
            return n;
          }
        }), function () {
          Object.defineProperty(t, "adoptedStyleSheets", {
            configurable: l.configurable,
            enumerable: l.enumerable,
            get: l.get,
            set: l.set
          });
        }) : function () {};
      }
      function qe(e, t) {
        var n = e.styleDeclarationCb,
          a = e.mirror,
          r = e.ignoreCSSAttributes,
          o = e.stylesheetManager,
          i = t.win,
          s = i.CSSStyleDeclaration.prototype.setProperty;
        i.CSSStyleDeclaration.prototype.setProperty = function (e, t, i) {
          var c;
          if (r.has(e)) return s.apply(this, [e, t, i]);
          var l = Pe(null == (c = this.parentRule) ? void 0 : c.parentStyleSheet, a, o.styleMirror),
            u = l.id,
            d = l.styleId;
          return (u && -1 !== u || d && -1 !== d) && n({
            id: u,
            styleId: d,
            set: {
              property: e,
              value: t,
              priority: i
            },
            index: Be(this.parentRule)
          }), s.apply(this, [e, t, i]);
        };
        var c = i.CSSStyleDeclaration.prototype.removeProperty;
        return i.CSSStyleDeclaration.prototype.removeProperty = function (e) {
          var t;
          if (r.has(e)) return c.apply(this, [e]);
          var i = Pe(null == (t = this.parentRule) ? void 0 : t.parentStyleSheet, a, o.styleMirror),
            s = i.id,
            l = i.styleId;
          return (s && -1 !== s || l && -1 !== l) && n({
            id: s,
            styleId: l,
            remove: {
              property: e
            },
            index: Be(this.parentRule)
          }), c.apply(this, [e]);
        }, function () {
          i.CSSStyleDeclaration.prototype.setProperty = s, i.CSSStyleDeclaration.prototype.removeProperty = c;
        };
      }
      function _e(e) {
        var t = e.mediaInteractionCb,
          n = e.blockClass,
          a = e.blockSelector,
          r = e.mirror,
          o = e.sampling,
          i = function i(e) {
            return N(function (o) {
              var i = we(o);
              if (i && !j(i, n, a, !0)) {
                var s = i.currentTime,
                  c = i.volume,
                  l = i.muted,
                  u = i.playbackRate;
                t({
                  type: e,
                  id: r.getId(i),
                  currentTime: s,
                  volume: c,
                  muted: l,
                  playbackRate: u
                });
              }
            }, o.media || 500);
          },
          s = [O("play", i(J.Play)), O("pause", i(J.Pause)), O("seeked", i(J.Seeked)), O("volumechange", i(J.VolumeChange)), O("ratechange", i(J.RateChange))];
        return function () {
          s.forEach(function (e) {
            return e();
          });
        };
      }
      function He(e) {
        var t = e.fontCb,
          n = e.doc,
          a = n.defaultView;
        if (!a) return function () {};
        var r = [],
          o = new WeakMap(),
          i = a.FontFace;
        a.FontFace = function (e, t, n) {
          var a = new i(e, t, n);
          return o.set(a, {
            family: e,
            buffer: "string" != typeof t,
            descriptors: n,
            fontSource: "string" == typeof t ? t : JSON.stringify(Array.from(new Uint8Array(t)))
          }), a;
        };
        var s = D(n.fonts, "add", function (e) {
          return function (n) {
            return setTimeout(function () {
              var e = o.get(n);
              e && (t(e), o.delete(n));
            }, 0), e.apply(this, [n]);
          };
        });
        return r.push(function () {
          a.FontFace = i;
        }), r.push(s), function () {
          r.forEach(function (e) {
            return e();
          });
        };
      }
      function We(e) {
        var t = e.doc,
          n = e.mirror,
          a = e.blockClass,
          r = e.blockSelector,
          o = e.selectionCb,
          i = !0,
          s = function s() {
            var e = t.getSelection();
            if (!(!e || i && (null == e ? void 0 : e.isCollapsed))) {
              i = e.isCollapsed || !1;
              for (var s = [], c = e.rangeCount || 0, l = 0; l < c; l++) {
                var u = e.getRangeAt(l),
                  d = u.startContainer,
                  p = u.startOffset,
                  f = u.endContainer,
                  h = u.endOffset;
                j(d, a, r, !0) || j(f, a, r, !0) || s.push({
                  start: n.getId(d),
                  startOffset: p,
                  end: n.getId(f),
                  endOffset: h
                });
              }
              o({
                ranges: s
              });
            }
          };
        return s(), O("selectionchange", s);
      }
      function ze(e, t) {
        var n = e.mutationCb,
          a = e.mousemoveCb,
          r = e.mouseInteractionCb,
          o = e.scrollCb,
          i = e.viewportResizeCb,
          s = e.inputCb,
          c = e.mediaInteractionCb,
          l = e.styleSheetRuleCb,
          u = e.styleDeclarationCb,
          d = e.canvasMutationCb,
          p = e.fontCb,
          f = e.selectionCb;
        e.mutationCb = function () {
          t.mutation && t.mutation.apply(t, arguments), n.apply(void 0, arguments);
        }, e.mousemoveCb = function () {
          t.mousemove && t.mousemove.apply(t, arguments), a.apply(void 0, arguments);
        }, e.mouseInteractionCb = function () {
          t.mouseInteraction && t.mouseInteraction.apply(t, arguments), r.apply(void 0, arguments);
        }, e.scrollCb = function () {
          t.scroll && t.scroll.apply(t, arguments), o.apply(void 0, arguments);
        }, e.viewportResizeCb = function () {
          t.viewportResize && t.viewportResize.apply(t, arguments), i.apply(void 0, arguments);
        }, e.inputCb = function () {
          t.input && t.input.apply(t, arguments), s.apply(void 0, arguments);
        }, e.mediaInteractionCb = function () {
          t.mediaInteaction && t.mediaInteaction.apply(t, arguments), c.apply(void 0, arguments);
        }, e.styleSheetRuleCb = function () {
          t.styleSheetRule && t.styleSheetRule.apply(t, arguments), l.apply(void 0, arguments);
        }, e.styleDeclarationCb = function () {
          t.styleDeclaration && t.styleDeclaration.apply(t, arguments), u.apply(void 0, arguments);
        }, e.canvasMutationCb = function () {
          t.canvasMutation && t.canvasMutation.apply(t, arguments), d.apply(void 0, arguments);
        }, e.fontCb = function () {
          t.font && t.font.apply(t, arguments), p.apply(void 0, arguments);
        }, e.selectionCb = function () {
          t.selection && t.selection.apply(t, arguments), f.apply(void 0, arguments);
        };
      }
      function Ge(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = e.doc.defaultView;
        if (!n) return function () {};
        ze(e, t);
        var a,
          r = Ce(e, e.doc),
          o = ke(e),
          i = Ie(e),
          s = xe(e),
          c = Se(e),
          l = Fe(e),
          u = _e(e),
          d = je(e, {
            win: n
          }),
          p = Ue(e, e.doc),
          f = qe(e, {
            win: n
          }),
          h = e.collectFonts ? He(e) : function () {},
          g = We(e),
          m = [],
          b = Oe(e.plugins);
        try {
          for (b.s(); !(a = b.n()).done;) {
            var v = a.value;
            m.push(v.observer(v.callback, n, v.options));
          }
        } catch (y) {
          b.e(y);
        } finally {
          b.f();
        }
        return function () {
          ge.forEach(function (e) {
            return e.reset();
          }), r.disconnect(), o(), i(), s(), c(), l(), u(), d(), p(), f(), h(), g(), m.forEach(function (e) {
            return e();
          });
        };
      }
      for (var Ze = function () {
          function e(t) {
            Ne(this, e), this.generateIdFn = t, this.iframeIdToRemoteIdMap = new WeakMap(), this.iframeRemoteIdToIdMap = new WeakMap();
          }
          return De(e, [{
            key: "getId",
            value: function value(e, t, n, a) {
              var r = n || this.getIdToRemoteIdMap(e),
                o = a || this.getRemoteIdToIdMap(e),
                i = r.get(t);
              return i || (i = this.generateIdFn(), r.set(t, i), o.set(i, t)), i;
            }
          }, {
            key: "getIds",
            value: function value(e, t) {
              var n = this,
                a = this.getIdToRemoteIdMap(e),
                r = this.getRemoteIdToIdMap(e);
              return t.map(function (t) {
                return n.getId(e, t, a, r);
              });
            }
          }, {
            key: "getRemoteId",
            value: function value(e, t, n) {
              var a = n || this.getRemoteIdToIdMap(e);
              if ("number" != typeof t) return t;
              var r = a.get(t);
              return r || -1;
            }
          }, {
            key: "getRemoteIds",
            value: function value(e, t) {
              var n = this,
                a = this.getRemoteIdToIdMap(e);
              return t.map(function (t) {
                return n.getRemoteId(e, t, a);
              });
            }
          }, {
            key: "reset",
            value: function value(e) {
              if (!e) return this.iframeIdToRemoteIdMap = new WeakMap(), void (this.iframeRemoteIdToIdMap = new WeakMap());
              this.iframeIdToRemoteIdMap.delete(e), this.iframeRemoteIdToIdMap.delete(e);
            }
          }, {
            key: "getIdToRemoteIdMap",
            value: function value(e) {
              var t = this.iframeIdToRemoteIdMap.get(e);
              return t || (t = new Map(), this.iframeIdToRemoteIdMap.set(e, t)), t;
            }
          }, {
            key: "getRemoteIdToIdMap",
            value: function value(e) {
              var t = this.iframeRemoteIdToIdMap.get(e);
              return t || (t = new Map(), this.iframeRemoteIdToIdMap.set(e, t)), t;
            }
          }]), e;
        }(), Ve = function () {
          function e(t) {
            Ne(this, e), this.iframes = new WeakMap(), this.crossOriginIframeMap = new WeakMap(), this.crossOriginIframeMirror = new Ze(f), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Ze(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
          }
          return De(e, [{
            key: "addIframe",
            value: function value(e) {
              this.iframes.set(e, !0), e.contentWindow && this.crossOriginIframeMap.set(e.contentWindow, e);
            }
          }, {
            key: "addLoadListener",
            value: function value(e) {
              this.loadListener = e;
            }
          }, {
            key: "attachIframe",
            value: function value(e, t) {
              var n;
              this.mutationCb({
                adds: [{
                  parentId: this.mirror.getId(e),
                  nextId: null,
                  node: t
                }],
                removes: [],
                texts: [],
                attributes: [],
                isAttachIframe: !0
              }), null == (n = this.loadListener) || n.call(this, e), e.contentDocument && e.contentDocument.adoptedStyleSheets && e.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(e.contentDocument.adoptedStyleSheets, this.mirror.getId(e.contentDocument));
            }
          }, {
            key: "handleMessage",
            value: function value(e) {
              if ("rrweb" === e.data.type) {
                if (!e.source) return;
                var t = this.crossOriginIframeMap.get(e.source);
                if (!t) return;
                var n = this.transformCrossOriginEvent(t, e.data.event);
                n && this.wrappedEmit(n, e.data.isCheckout);
              }
            }
          }, {
            key: "transformCrossOriginEvent",
            value: function value(e, t) {
              var n,
                a = this;
              switch (t.type) {
                case V.FullSnapshot:
                  return this.crossOriginIframeMirror.reset(e), this.crossOriginIframeStyleMirror.reset(e), this.replaceIdOnNode(t.data.node, e), {
                    timestamp: t.timestamp,
                    type: V.IncrementalSnapshot,
                    data: {
                      source: K.Mutation,
                      adds: [{
                        parentId: this.mirror.getId(e),
                        nextId: null,
                        node: t.data.node
                      }],
                      removes: [],
                      texts: [],
                      attributes: [],
                      isAttachIframe: !0
                    }
                  };
                case V.Meta:
                case V.Load:
                case V.DomContentLoaded:
                  return !1;
                case V.Plugin:
                  return t;
                case V.Custom:
                  return this.replaceIds(t.data.payload, e, ["id", "parentId", "previousId", "nextId"]), t;
                case V.IncrementalSnapshot:
                  switch (t.data.source) {
                    case K.Mutation:
                      return t.data.adds.forEach(function (t) {
                        a.replaceIds(t, e, ["parentId", "nextId", "previousId"]), a.replaceIdOnNode(t.node, e);
                      }), t.data.removes.forEach(function (t) {
                        a.replaceIds(t, e, ["parentId", "id"]);
                      }), t.data.attributes.forEach(function (t) {
                        a.replaceIds(t, e, ["id"]);
                      }), t.data.texts.forEach(function (t) {
                        a.replaceIds(t, e, ["id"]);
                      }), t;
                    case K.Drag:
                    case K.TouchMove:
                    case K.MouseMove:
                      return t.data.positions.forEach(function (t) {
                        a.replaceIds(t, e, ["id"]);
                      }), t;
                    case K.ViewportResize:
                      return !1;
                    case K.MediaInteraction:
                    case K.MouseInteraction:
                    case K.Scroll:
                    case K.CanvasMutation:
                    case K.Input:
                      return this.replaceIds(t.data, e, ["id"]), t;
                    case K.StyleSheetRule:
                    case K.StyleDeclaration:
                      return this.replaceIds(t.data, e, ["id"]), this.replaceStyleIds(t.data, e, ["styleId"]), t;
                    case K.Font:
                      return t;
                    case K.Selection:
                      return t.data.ranges.forEach(function (t) {
                        a.replaceIds(t, e, ["start", "end"]);
                      }), t;
                    case K.AdoptedStyleSheet:
                      return this.replaceIds(t.data, e, ["id"]), this.replaceStyleIds(t.data, e, ["styleIds"]), null == (n = t.data.styles) || n.forEach(function (t) {
                        a.replaceStyleIds(t, e, ["styleId"]);
                      }), t;
                  }
              }
            }
          }, {
            key: "replace",
            value: function value(e, t, n, a) {
              var r,
                o = Oe(a);
              try {
                for (o.s(); !(r = o.n()).done;) {
                  var i = r.value;
                  (Array.isArray(t[i]) || "number" == typeof t[i]) && (Array.isArray(t[i]) ? t[i] = e.getIds(n, t[i]) : t[i] = e.getId(n, t[i]));
                }
              } catch (s) {
                o.e(s);
              } finally {
                o.f();
              }
              return t;
            }
          }, {
            key: "replaceIds",
            value: function value(e, t, n) {
              return this.replace(this.crossOriginIframeMirror, e, t, n);
            }
          }, {
            key: "replaceStyleIds",
            value: function value(e, t, n) {
              return this.replace(this.crossOriginIframeStyleMirror, e, t, n);
            }
          }, {
            key: "replaceIdOnNode",
            value: function value(e, t) {
              var n = this;
              this.replaceIds(e, t, ["id"]), ("childNodes" in e) && e.childNodes.forEach(function (e) {
                n.replaceIdOnNode(e, t);
              });
            }
          }]), e;
        }(), Ke = Object.defineProperty, Xe = Object.defineProperties, Ye = Object.getOwnPropertyDescriptors, Je = Object.getOwnPropertySymbols, Qe = Object.prototype.hasOwnProperty, $e = Object.prototype.propertyIsEnumerable, et = function et(e, t, n) {
          return (t in e) ? Ke(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
          }) : e[t] = n;
        }, tt = function tt(e, t) {
          for (var n in t || (t = {})) {
            Qe.call(t, n) && et(e, n, t[n]);
          }
          if (Je) {
            var a,
              r = Oe(Je(t));
            try {
              for (r.s(); !(a = r.n()).done;) {
                n = a.value;
                $e.call(t, n) && et(e, n, t[n]);
              }
            } catch (o) {
              r.e(o);
            } finally {
              r.f();
            }
          }
          return e;
        }, nt = function nt(e, t) {
          return Xe(e, Ye(t));
        }, at = function () {
          function e(t) {
            Ne(this, e), this.shadowDoms = new WeakSet(), this.restorePatches = [], this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror;
            var n = this;
            this.restorePatches.push(D(Element.prototype, "attachShadow", function (e) {
              return function (t) {
                var a = e.call(this, t);
                return this.shadowRoot && n.addShadowRoot(this.shadowRoot, this.ownerDocument), a;
              };
            }));
          }
          return De(e, [{
            key: "addShadowRoot",
            value: function value(e, t) {
              var n = this;
              a(e) && (this.shadowDoms.has(e) || (this.shadowDoms.add(e), Ce(nt(tt({}, this.bypassOptions), {
                doc: t,
                mutationCb: this.mutationCb,
                mirror: this.mirror,
                shadowDomManager: this
              }), e), xe(nt(tt({}, this.bypassOptions), {
                scrollCb: this.scrollCb,
                doc: e,
                mirror: this.mirror
              })), setTimeout(function () {
                e.adoptedStyleSheets && e.adoptedStyleSheets.length > 0 && n.bypassOptions.stylesheetManager.adoptStyleSheets(e.adoptedStyleSheets, n.mirror.getId(e.host)), Ue({
                  mirror: n.mirror,
                  stylesheetManager: n.bypassOptions.stylesheetManager
                }, e);
              }, 0)));
            }
          }, {
            key: "observeAttachShadow",
            value: function value(e) {
              if (e.contentWindow) {
                var t = this;
                this.restorePatches.push(D(e.contentWindow.HTMLElement.prototype, "attachShadow", function (n) {
                  return function (a) {
                    var r = n.call(this, a);
                    return this.shadowRoot && t.addShadowRoot(this.shadowRoot, e.contentDocument), r;
                  };
                }));
              }
            }
          }, {
            key: "reset",
            value: function value() {
              this.restorePatches.forEach(function (e) {
                return e();
              }), this.shadowDoms = new WeakSet();
            }
          }]), e;
        }(), rt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ot = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), it = 0; it < rt.length; it++) {
        ot[rt.charCodeAt(it)] = it;
      }
      var st = new Map();
      var ct = function ct(e, t, n) {
        if (e && (dt(e, t) || "object" === Ae(e))) {
          var a = function (e, t) {
              var n = st.get(e);
              return n || (n = new Map(), st.set(e, n)), n.has(t) || n.set(t, []), n.get(t);
            }(n, e.constructor.name),
            r = a.indexOf(e);
          return -1 === r && (r = a.length, a.push(e)), r;
        }
      };
      function lt(e, t, n) {
        if (e instanceof Array) return e.map(function (e) {
          return lt(e, t, n);
        });
        if (null === e) return e;
        if (e instanceof Float32Array || e instanceof Float64Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Int8Array || e instanceof Uint8ClampedArray) return {
          rr_type: e.constructor.name,
          args: [Object.values(e)]
        };
        if (e instanceof ArrayBuffer) return {
          rr_type: e.constructor.name,
          base64: function (e) {
            var t,
              n = new Uint8Array(e),
              a = n.length,
              r = "";
            for (t = 0; t < a; t += 3) {
              r += rt[n[t] >> 2], r += rt[(3 & n[t]) << 4 | n[t + 1] >> 4], r += rt[(15 & n[t + 1]) << 2 | n[t + 2] >> 6], r += rt[63 & n[t + 2]];
            }
            return a % 3 == 2 ? r = r.substring(0, r.length - 1) + "=" : a % 3 == 1 && (r = r.substring(0, r.length - 2) + "=="), r;
          }(e)
        };
        if (e instanceof DataView) return {
          rr_type: e.constructor.name,
          args: [lt(e.buffer, t, n), e.byteOffset, e.byteLength]
        };
        if (e instanceof HTMLImageElement) return {
          rr_type: e.constructor.name,
          src: e.src
        };
        if (e instanceof HTMLCanvasElement) {
          return {
            rr_type: "HTMLImageElement",
            src: e.toDataURL()
          };
        }
        return e instanceof ImageData ? {
          rr_type: e.constructor.name,
          args: [lt(e.data, t, n), e.width, e.height]
        } : dt(e, t) || "object" === Ae(e) ? {
          rr_type: e.constructor.name,
          index: ct(e, t, n)
        } : e;
      }
      var ut = function ut(e, t, n) {
          return Me(e).map(function (e) {
            return lt(e, t, n);
          });
        },
        dt = function dt(e, t) {
          var n = ["WebGLActiveInfo", "WebGLBuffer", "WebGLFramebuffer", "WebGLProgram", "WebGLRenderbuffer", "WebGLShader", "WebGLShaderPrecisionFormat", "WebGLTexture", "WebGLUniformLocation", "WebGLVertexArrayObject", "WebGLVertexArrayObjectOES"].filter(function (e) {
            return "function" == typeof t[e];
          });
          return Boolean(n.find(function (n) {
            return e instanceof t[n];
          }));
        };
      function pt(e, t, n) {
        var a = [];
        try {
          var r = D(e.HTMLCanvasElement.prototype, "getContext", function (e) {
            return function (a) {
              j(this, t, n, !0) || "__context" in this || (this.__context = a);
              for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
                o[i - 1] = arguments[i];
              }
              return e.apply(this, [a].concat(o));
            };
          });
          a.push(r);
        } catch (o) {
          console.error("failed to patch HTMLCanvasElement.prototype.getContext");
        }
        return function () {
          a.forEach(function (e) {
            return e();
          });
        };
      }
      function ft(e, t, n, a, r, o, i) {
        var s,
          c = [],
          l = Oe(Object.getOwnPropertyNames(e));
        try {
          var u = function u() {
            var o = s.value;
            if (["isContextLost", "canvas", "drawingBufferWidth", "drawingBufferHeight"].includes(o)) return "continue";
            try {
              if ("function" != typeof e[o]) return "continue";
              var l = D(e, o, function (e) {
                return function () {
                  for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++) {
                    c[l] = arguments[l];
                  }
                  var u = e.apply(this, c);
                  if (ct(u, i, this), !j(this.canvas, a, r, !0)) {
                    var d = ut([].concat(c), i, this),
                      p = {
                        type: t,
                        property: o,
                        args: d
                      };
                    n(this.canvas, p);
                  }
                  return u;
                };
              });
              c.push(l);
            } catch (d) {
              var u = F(e, o, {
                set: function set(e) {
                  n(this.canvas, {
                    type: t,
                    property: o,
                    args: [e],
                    setter: !0
                  });
                }
              });
              c.push(u);
            }
          };
          for (l.s(); !(s = l.n()).done;) {
            u();
          }
        } catch (d) {
          l.e(d);
        } finally {
          l.f();
        }
        return c;
      }
      function ht(e, t, n) {
        var a = void 0 === t ? null : t,
          r = function (e, t) {
            var n = atob(e);
            if (t) {
              for (var a = new Uint8Array(n.length), r = 0, o = n.length; r < o; ++r) {
                a[r] = n.charCodeAt(r);
              }
              return String.fromCharCode.apply(null, new Uint16Array(a.buffer));
            }
            return n;
          }(e, void 0 !== n && n),
          o = r.indexOf("\n", 10) + 1,
          i = r.substring(o) + (a ? "//# sourceMappingURL=" + a : ""),
          s = new Blob([i], {
            type: "application/javascript"
          });
        return URL.createObjectURL(s);
      }
      var gt,
        mt,
        bt,
        vt,
        yt,
        wt,
        Ct,
        kt = (gt = "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", mt = null, bt = !1, function (e) {
          return vt = vt || ht(gt, mt, bt), new Worker(vt, e);
        }),
        It = Object.getOwnPropertySymbols,
        xt = Object.prototype.hasOwnProperty,
        St = Object.prototype.propertyIsEnumerable,
        Lt = function () {
          function e(t) {
            var n = this;
            Ne(this, e), this.pendingCanvasMutations = new Map(), this.rafStamps = {
              latestId: 0,
              invokeId: null
            }, this.frozen = !1, this.locked = !1, this.processMutation = function (e, t) {
              !(n.rafStamps.invokeId && n.rafStamps.latestId !== n.rafStamps.invokeId) && n.rafStamps.invokeId || (n.rafStamps.invokeId = n.rafStamps.latestId), n.pendingCanvasMutations.has(e) || n.pendingCanvasMutations.set(e, []), n.pendingCanvasMutations.get(e).push(t);
            };
            var a = t.sampling,
              r = void 0 === a ? "all" : a,
              o = t.win,
              i = t.blockClass,
              s = t.blockSelector,
              c = t.recordCanvas,
              l = t.dataURLOptions;
            this.mutationCb = t.mutationCb, this.mirror = t.mirror, c && "all" === r && this.initCanvasMutationObserver(o, i, s), c && "number" == typeof r && this.initCanvasFPSObserver(r, o, i, s, {
              dataURLOptions: l
            });
          }
          return De(e, [{
            key: "reset",
            value: function value() {
              this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
            }
          }, {
            key: "freeze",
            value: function value() {
              this.frozen = !0;
            }
          }, {
            key: "unfreeze",
            value: function value() {
              this.frozen = !1;
            }
          }, {
            key: "lock",
            value: function value() {
              this.locked = !0;
            }
          }, {
            key: "unlock",
            value: function value() {
              this.locked = !1;
            }
          }, {
            key: "initCanvasFPSObserver",
            value: function value(e, t, n, a, r) {
              var o = this,
                i = pt(t, n, a),
                s = new Map(),
                c = new kt();
              c.onmessage = function (e) {
                var t = e.data.id;
                if (s.set(t, !1), "base64" in e.data) {
                  var n = e.data,
                    a = n.base64,
                    r = n.type,
                    i = n.width,
                    c = n.height;
                  o.mutationCb({
                    id: t,
                    type: Y["2D"],
                    commands: [{
                      property: "clearRect",
                      args: [0, 0, i, c]
                    }, {
                      property: "drawImage",
                      args: [{
                        rr_type: "ImageBitmap",
                        args: [{
                          rr_type: "Blob",
                          data: [{
                            rr_type: "ArrayBuffer",
                            base64: a
                          }],
                          type: r
                        }]
                      }, 0, 0]
                    }]
                  });
                }
              };
              var l,
                u = 1e3 / e,
                d = 0;
              l = requestAnimationFrame(function e(i) {
                var p;
                d && i - d < u ? l = requestAnimationFrame(e) : (d = i, (p = [], t.document.querySelectorAll("canvas").forEach(function (e) {
                  j(e, n, a, !0) || p.push(e);
                }), p).forEach(function (e) {
                  return t = o, n = null, a = _regeneratorRuntime.mark(function t() {
                    var n, a, o, i;
                    return _regeneratorRuntime.wrap(function (t) {
                      for (;;) {
                        switch (t.prev = t.next) {
                          case 0:
                            if (a = this.mirror.getId(e), !s.get(a)) {
                              t.next = 3;
                              break;
                            }
                            return t.abrupt("return");
                          case 3:
                            return s.set(a, !0), ["webgl", "webgl2"].includes(e.__context) && (o = e.getContext(e.__context), !1 === (null == (n = null == o ? void 0 : o.getContextAttributes()) ? void 0 : n.preserveDrawingBuffer) && (null == o || o.clear(o.COLOR_BUFFER_BIT))), t.next = 7, createImageBitmap(e);
                          case 7:
                            i = t.sent, c.postMessage({
                              id: a,
                              bitmap: i,
                              width: e.width,
                              height: e.height,
                              dataURLOptions: r.dataURLOptions
                            }, [i]);
                          case 9:
                          case "end":
                            return t.stop();
                        }
                      }
                    }, t, this);
                  }), new Promise(function (e, r) {
                    var o = function o(e) {
                        try {
                          s(a.next(e));
                        } catch (t) {
                          r(t);
                        }
                      },
                      i = function i(e) {
                        try {
                          s(a.throw(e));
                        } catch (t) {
                          r(t);
                        }
                      },
                      s = function s(t) {
                        return t.done ? e(t.value) : Promise.resolve(t.value).then(o, i);
                      };
                    s((a = a.apply(t, n)).next());
                  });
                  var t, n, a;
                }), l = requestAnimationFrame(e));
              }), this.resetObservers = function () {
                i(), cancelAnimationFrame(l);
              };
            }
          }, {
            key: "initCanvasMutationObserver",
            value: function value(e, t, n) {
              this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
              var a = pt(e, t, n),
                r = function (e, t, n, a) {
                  var r,
                    o = [],
                    i = Oe(Object.getOwnPropertyNames(t.CanvasRenderingContext2D.prototype));
                  try {
                    var s = function s() {
                      var i = r.value;
                      try {
                        if ("function" != typeof t.CanvasRenderingContext2D.prototype[i]) return "continue";
                        var s = D(t.CanvasRenderingContext2D.prototype, i, function (r) {
                          return function () {
                            for (var o = this, s = arguments.length, c = new Array(s), l = 0; l < s; l++) {
                              c[l] = arguments[l];
                            }
                            return j(this.canvas, n, a, !0) || setTimeout(function () {
                              var n = ut([].concat(c), t, o);
                              e(o.canvas, {
                                type: Y["2D"],
                                property: i,
                                args: n
                              });
                            }, 0), r.apply(this, c);
                          };
                        });
                        o.push(s);
                      } catch (l) {
                        var c = F(t.CanvasRenderingContext2D.prototype, i, {
                          set: function set(t) {
                            e(this.canvas, {
                              type: Y["2D"],
                              property: i,
                              args: [t],
                              setter: !0
                            });
                          }
                        });
                        o.push(c);
                      }
                    };
                    for (i.s(); !(r = i.n()).done;) {
                      s();
                    }
                  } catch (c) {
                    i.e(c);
                  } finally {
                    i.f();
                  }
                  return function () {
                    o.forEach(function (e) {
                      return e();
                    });
                  };
                }(this.processMutation.bind(this), e, t, n),
                o = function (e, t, n, a, r) {
                  var o = [];
                  return o.push.apply(o, Me(ft(t.WebGLRenderingContext.prototype, Y.WebGL, e, n, a, 0, t))), void 0 !== t.WebGL2RenderingContext && o.push.apply(o, Me(ft(t.WebGL2RenderingContext.prototype, Y.WebGL2, e, n, a, 0, t))), function () {
                    o.forEach(function (e) {
                      return e();
                    });
                  };
                }(this.processMutation.bind(this), e, t, n, this.mirror);
              this.resetObservers = function () {
                a(), r(), o();
              };
            }
          }, {
            key: "startPendingCanvasMutationFlusher",
            value: function value() {
              var e = this;
              requestAnimationFrame(function () {
                return e.flushPendingCanvasMutations();
              });
            }
          }, {
            key: "startRAFTimestamping",
            value: function value() {
              var e = this;
              requestAnimationFrame(function t(n) {
                e.rafStamps.latestId = n, requestAnimationFrame(t);
              });
            }
          }, {
            key: "flushPendingCanvasMutations",
            value: function value() {
              var e = this;
              this.pendingCanvasMutations.forEach(function (t, n) {
                var a = e.mirror.getId(n);
                e.flushPendingCanvasMutationFor(n, a);
              }), requestAnimationFrame(function () {
                return e.flushPendingCanvasMutations();
              });
            }
          }, {
            key: "flushPendingCanvasMutationFor",
            value: function value(e, t) {
              if (!this.frozen && !this.locked) {
                var n = this.pendingCanvasMutations.get(e);
                if (n && -1 !== t) {
                  var a = n.map(function (e) {
                      return function (e, t) {
                        var n = {};
                        for (var a in e) {
                          xt.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
                        }
                        if (null != e && It) {
                          var r,
                            o = Oe(It(e));
                          try {
                            for (o.s(); !(r = o.n()).done;) {
                              a = r.value, t.indexOf(a) < 0 && St.call(e, a) && (n[a] = e[a]);
                            }
                          } catch (i) {
                            o.e(i);
                          } finally {
                            o.f();
                          }
                        }
                        return n;
                      }(e, ["type"]);
                    }),
                    r = n[0].type;
                  this.mutationCb({
                    id: t,
                    type: r,
                    commands: a
                  }), this.pendingCanvasMutations.delete(e);
                }
              }
            }
          }]), e;
        }(),
        At = function () {
          function e(t) {
            Ne(this, e), this.trackedLinkElements = new WeakSet(), this.styleMirror = new Z(), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
          }
          return De(e, [{
            key: "attachLinkElement",
            value: function value(e, t) {
              "_cssText" in t.attributes && this.mutationCb({
                adds: [],
                removes: [],
                texts: [],
                attributes: [{
                  id: t.id,
                  attributes: t.attributes
                }]
              }), this.trackLinkElement(e);
            }
          }, {
            key: "trackLinkElement",
            value: function value(e) {
              this.trackedLinkElements.has(e) || (this.trackedLinkElements.add(e), this.trackStylesheetInLinkElement(e));
            }
          }, {
            key: "adoptStyleSheets",
            value: function value(e, t) {
              if (0 !== e.length) {
                var n,
                  a = {
                    id: t,
                    styleIds: []
                  },
                  r = [],
                  i = Oe(e);
                try {
                  for (i.s(); !(n = i.n()).done;) {
                    var s = n.value,
                      c = void 0;
                    if (this.styleMirror.has(s)) c = this.styleMirror.getId(s);else {
                      c = this.styleMirror.add(s);
                      var l = Array.from(s.rules || CSSRule);
                      r.push({
                        styleId: c,
                        rules: l.map(function (e, t) {
                          return {
                            rule: o(e),
                            index: t
                          };
                        })
                      });
                    }
                    a.styleIds.push(c);
                  }
                } catch (u) {
                  i.e(u);
                } finally {
                  i.f();
                }
                r.length > 0 && (a.styles = r), this.adoptedStyleSheetCb(a);
              }
            }
          }, {
            key: "reset",
            value: function value() {
              this.styleMirror.reset(), this.trackedLinkElements = new WeakSet();
            }
          }, {
            key: "trackStylesheetInLinkElement",
            value: function value(e) {}
          }]), e;
        }(),
        Tt = Object.defineProperty,
        Mt = Object.defineProperties,
        Ot = Object.getOwnPropertyDescriptors,
        Et = Object.getOwnPropertySymbols,
        Rt = Object.prototype.hasOwnProperty,
        Nt = Object.prototype.propertyIsEnumerable,
        Ft = function Ft(e, t, n) {
          return t in e ? Tt(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
          }) : e[t] = n;
        },
        Dt = function Dt(e, t) {
          for (var n in t || (t = {})) {
            Rt.call(t, n) && Ft(e, n, t[n]);
          }
          if (Et) {
            var a,
              r = Oe(Et(t));
            try {
              for (r.s(); !(a = r.n()).done;) {
                n = a.value;
                Nt.call(t, n) && Ft(e, n, t[n]);
              }
            } catch (o) {
              r.e(o);
            } finally {
              r.f();
            }
          }
          return e;
        };
      function Bt(e) {
        return t = Dt({}, e), n = {
          timestamp: Date.now()
        }, Mt(t, Ot(n));
        var t, n;
      }
      var Pt = !1,
        jt = new i();
      function Ut() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.emit,
          n = e.checkoutEveryNms,
          a = e.checkoutEveryNth,
          r = e.blockClass,
          o = void 0 === r ? "rr-block" : r,
          i = e.blockSelector,
          s = void 0 === i ? null : i,
          c = e.ignoreClass,
          l = void 0 === c ? "rr-ignore" : c,
          u = e.maskTextClass,
          d = void 0 === u ? "rr-mask" : u,
          p = e.maskTextSelector,
          f = void 0 === p ? null : p,
          h = e.inlineStylesheet,
          g = void 0 === h || h,
          m = e.maskAllInputs,
          b = e.maskInputOptions,
          v = e.slimDOMOptions,
          y = e.maskInputFn,
          w = e.maskTextFn,
          C = e.hooks,
          k = e.packFn,
          I = e.sampling,
          x = void 0 === I ? {} : I,
          S = e.dataURLOptions,
          L = void 0 === S ? {} : S,
          A = e.mousemoveWait,
          T = e.recordCanvas,
          E = void 0 !== T && T,
          R = e.recordCrossOriginIframes,
          N = void 0 !== R && R,
          F = e.userTriggeredOnInput,
          D = void 0 !== F && F,
          j = e.collectFonts,
          U = void 0 !== j && j,
          q = e.inlineImages,
          _ = void 0 !== q && q,
          Z = e.plugins,
          X = e.keepIframeSrcFn,
          Y = void 0 === X ? function () {
            return !1;
          } : X,
          J = e.ignoreCSSAttributes,
          Q = void 0 === J ? new Set([]) : J,
          $ = !N || window.parent === window,
          ee = !1;
        if (!$) try {
          window.parent.document, ee = !1;
        } catch (we) {
          ee = !0;
        }
        if ($ && !t) throw new Error("emit function is required");
        void 0 !== A && void 0 === x.mousemove && (x.mousemove = A), jt.reset();
        var te,
          ne = !0 === m ? {
            color: !0,
            date: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
            textarea: !0,
            select: !0,
            password: !0
          } : void 0 !== b ? b : {
            password: !0
          },
          ae = !0 === v || "all" === v ? {
            script: !0,
            comment: !0,
            headFavicon: !0,
            headWhitespace: !0,
            headMetaSocial: !0,
            headMetaRobots: !0,
            headMetaHttpEquiv: !0,
            headMetaVerification: !0,
            headMetaAuthorship: "all" === v,
            headMetaDescKeywords: "all" === v
          } : v || {};
        H();
        var re = 0,
          oe = function oe(e) {
            var t,
              n = Oe(Z || []);
            try {
              for (n.s(); !(t = n.n()).done;) {
                var a = t.value;
                a.eventProcessor && (e = a.eventProcessor(e));
              }
            } catch (r) {
              n.e(r);
            } finally {
              n.f();
            }
            return k && (e = k(e)), e;
          };
        yt = function yt(e, r) {
          var o;
          if (!(null == (o = ge[0]) ? void 0 : o.isFrozen()) || e.type === V.FullSnapshot || e.type === V.IncrementalSnapshot && e.data.source === K.Mutation || ge.forEach(function (e) {
            return e.unfreeze();
          }), $) null == t || t(oe(e), r);else if (ee) {
            var i = {
              type: "rrweb",
              event: oe(e),
              isCheckout: r
            };
            window.parent.postMessage(i, "*");
          }
          if (e.type === V.FullSnapshot) te = e, re = 0;else if (e.type === V.IncrementalSnapshot) {
            if (e.data.source === K.Mutation && e.data.isAttachIframe) return;
            re++;
            var s = a && re >= a,
              c = n && e.timestamp - te.timestamp > n;
            (s || c) && wt(!0);
          }
        };
        var ie,
          se = function se(e) {
            yt(Bt({
              type: V.IncrementalSnapshot,
              data: Dt({
                source: K.Mutation
              }, e)
            }));
          },
          ce = function ce(e) {
            return yt(Bt({
              type: V.IncrementalSnapshot,
              data: Dt({
                source: K.Scroll
              }, e)
            }));
          },
          le = function le(e) {
            return yt(Bt({
              type: V.IncrementalSnapshot,
              data: Dt({
                source: K.CanvasMutation
              }, e)
            }));
          },
          ue = function ue(e) {
            return yt(Bt({
              type: V.IncrementalSnapshot,
              data: Dt({
                source: K.AdoptedStyleSheet
              }, e)
            }));
          },
          de = new At({
            mutationCb: se,
            adoptedStyleSheetCb: ue
          }),
          pe = new Ve({
            mirror: jt,
            mutationCb: se,
            stylesheetManager: de,
            recordCrossOriginIframes: N,
            wrappedEmit: yt
          }),
          fe = Oe(Z || []);
        try {
          for (fe.s(); !(ie = fe.n()).done;) {
            var he = ie.value;
            he.getMirror && he.getMirror({
              nodeMirror: jt,
              crossOriginIframeMirror: pe.crossOriginIframeMirror,
              crossOriginIframeStyleMirror: pe.crossOriginIframeStyleMirror
            });
          }
        } catch (Ce) {
          fe.e(Ce);
        } finally {
          fe.f();
        }
        Ct = new Lt({
          recordCanvas: E,
          mutationCb: le,
          win: window,
          blockClass: o,
          blockSelector: s,
          mirror: jt,
          sampling: x.canvas,
          dataURLOptions: L
        });
        var me = new at({
          mutationCb: se,
          scrollCb: ce,
          bypassOptions: {
            blockClass: o,
            blockSelector: s,
            maskTextClass: d,
            maskTextSelector: f,
            inlineStylesheet: g,
            maskInputOptions: ne,
            dataURLOptions: L,
            maskTextFn: w,
            maskInputFn: y,
            recordCanvas: E,
            inlineImages: _,
            sampling: x,
            slimDOMOptions: ae,
            iframeManager: pe,
            stylesheetManager: de,
            canvasManager: Ct,
            keepIframeSrcFn: Y
          },
          mirror: jt
        });
        wt = function wt() {
          var e,
            t,
            n,
            a,
            r,
            i,
            c = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          yt(Bt({
            type: V.Meta,
            data: {
              href: window.location.href,
              width: P(),
              height: B()
            }
          }), c), de.reset(), ge.forEach(function (e) {
            return e.lock();
          });
          var l = M(document, {
            mirror: jt,
            blockClass: o,
            blockSelector: s,
            maskTextClass: d,
            maskTextSelector: f,
            inlineStylesheet: g,
            maskAllInputs: ne,
            maskTextFn: w,
            slimDOM: ae,
            dataURLOptions: L,
            recordCanvas: E,
            inlineImages: _,
            onSerialize: function onSerialize(e) {
              W(e, jt) && pe.addIframe(e), z(e, jt) && de.trackLinkElement(e), G(e) && me.addShadowRoot(e.shadowRoot, document);
            },
            onIframeLoad: function onIframeLoad(e, t) {
              pe.attachIframe(e, t), me.observeAttachShadow(e);
            },
            onStylesheetLoad: function onStylesheetLoad(e, t) {
              de.attachLinkElement(e, t);
            },
            keepIframeSrcFn: Y
          });
          if (!l) return console.warn("Failed to snapshot the document");
          yt(Bt({
            type: V.FullSnapshot,
            data: {
              node: l,
              initialOffset: {
                left: void 0 !== window.pageXOffset ? window.pageXOffset : (null == document ? void 0 : document.documentElement.scrollLeft) || (null == (t = null == (e = null == document ? void 0 : document.body) ? void 0 : e.parentElement) ? void 0 : t.scrollLeft) || (null == (n = null == document ? void 0 : document.body) ? void 0 : n.scrollLeft) || 0,
                top: void 0 !== window.pageYOffset ? window.pageYOffset : (null == document ? void 0 : document.documentElement.scrollTop) || (null == (r = null == (a = null == document ? void 0 : document.body) ? void 0 : a.parentElement) ? void 0 : r.scrollTop) || (null == (i = null == document ? void 0 : document.body) ? void 0 : i.scrollTop) || 0
              }
            }
          })), ge.forEach(function (e) {
            return e.unlock();
          }), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && de.adoptStyleSheets(document.adoptedStyleSheets, jt.getId(document));
        };
        try {
          var be = [];
          be.push(O("DOMContentLoaded", function () {
            yt(Bt({
              type: V.DomContentLoaded,
              data: {}
            }));
          }));
          var ve = function ve(e) {
            var t;
            return Ge({
              mutationCb: se,
              mousemoveCb: function mousemoveCb(e, t) {
                return yt(Bt({
                  type: V.IncrementalSnapshot,
                  data: {
                    source: t,
                    positions: e
                  }
                }));
              },
              mouseInteractionCb: function mouseInteractionCb(e) {
                return yt(Bt({
                  type: V.IncrementalSnapshot,
                  data: Dt({
                    source: K.MouseInteraction
                  }, e)
                }));
              },
              scrollCb: ce,
              viewportResizeCb: function viewportResizeCb(e) {
                return yt(Bt({
                  type: V.IncrementalSnapshot,
                  data: Dt({
                    source: K.ViewportResize
                  }, e)
                }));
              },
              inputCb: function inputCb(e) {
                return yt(Bt({
                  type: V.IncrementalSnapshot,
                  data: Dt({
                    source: K.Input
                  }, e)
                }));
              },
              mediaInteractionCb: function mediaInteractionCb(e) {
                return yt(Bt({
                  type: V.IncrementalSnapshot,
                  data: Dt({
                    source: K.MediaInteraction
                  }, e)
                }));
              },
              styleSheetRuleCb: function styleSheetRuleCb(e) {
                return yt(Bt({
                  type: V.IncrementalSnapshot,
                  data: Dt({
                    source: K.StyleSheetRule
                  }, e)
                }));
              },
              styleDeclarationCb: function styleDeclarationCb(e) {
                return yt(Bt({
                  type: V.IncrementalSnapshot,
                  data: Dt({
                    source: K.StyleDeclaration
                  }, e)
                }));
              },
              canvasMutationCb: le,
              fontCb: function fontCb(e) {
                return yt(Bt({
                  type: V.IncrementalSnapshot,
                  data: Dt({
                    source: K.Font
                  }, e)
                }));
              },
              selectionCb: function selectionCb(e) {
                yt(Bt({
                  type: V.IncrementalSnapshot,
                  data: Dt({
                    source: K.Selection
                  }, e)
                }));
              },
              blockClass: o,
              ignoreClass: l,
              maskTextClass: d,
              maskTextSelector: f,
              maskInputOptions: ne,
              inlineStylesheet: g,
              sampling: x,
              recordCanvas: E,
              inlineImages: _,
              userTriggeredOnInput: D,
              collectFonts: U,
              doc: e,
              maskInputFn: y,
              maskTextFn: w,
              keepIframeSrcFn: Y,
              blockSelector: s,
              slimDOMOptions: ae,
              dataURLOptions: L,
              mirror: jt,
              iframeManager: pe,
              stylesheetManager: de,
              shadowDomManager: me,
              canvasManager: Ct,
              ignoreCSSAttributes: Q,
              plugins: (null == (t = null == Z ? void 0 : Z.filter(function (e) {
                return e.observer;
              })) ? void 0 : t.map(function (e) {
                return {
                  observer: e.observer,
                  options: e.options,
                  callback: function callback(t) {
                    return yt(Bt({
                      type: V.Plugin,
                      data: {
                        plugin: e.name,
                        payload: t
                      }
                    }));
                  }
                };
              })) || []
            }, C);
          };
          pe.addLoadListener(function (e) {
            be.push(ve(e.contentDocument));
          });
          var ye = function ye() {
            wt(), be.push(ve(document)), Pt = !0;
          };
          return "interactive" === document.readyState || "complete" === document.readyState ? ye() : be.push(O("load", function () {
            yt(Bt({
              type: V.Load,
              data: {}
            })), ye();
          }, window)), function () {
            be.forEach(function (e) {
              return e();
            }), Pt = !1;
          };
        } catch (ke) {
          console.warn(ke);
        }
      }
      return Ut.addCustomEvent = function (e, t) {
        if (!Pt) throw new Error("please add custom event after start recording");
        yt(Bt({
          type: V.Custom,
          data: {
            tag: e,
            payload: t
          }
        }));
      }, Ut.freezePage = function () {
        ge.forEach(function (e) {
          return e.freeze();
        });
      }, Ut.takeFullSnapshot = function (e) {
        if (!Pt) throw new Error("please take full snapshot after start recording");
        wt(e);
      }, Ut.mirror = jt, Ut;
    }();
    function Pe(e, t) {
      var _n2 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (!_n2) {
        if (Array.isArray(e) || (_n2 = function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return je(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === n && e.constructor && (n = e.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(e);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return je(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          _n2 && (e = _n2);
          var a = 0,
            r = function r() {};
          return {
            s: r,
            n: function n() {
              return a >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[a++]
              };
            },
            e: function e(_e4) {
              throw _e4;
            },
            f: r
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var o,
        i = !0,
        s = !1;
      return {
        s: function s() {
          _n2 = _n2.call(e);
        },
        n: function n() {
          var e = _n2.next();
          return i = e.done, e;
        },
        e: function e(_e5) {
          s = !0, o = _e5;
        },
        f: function f() {
          try {
            i || null == _n2.return || _n2.return();
          } finally {
            if (s) throw o;
          }
        }
      };
    }
    function je(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, a = new Array(t); n < t; n++) {
        a[n] = e[n];
      }
      return a;
    }
    function Ue(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function qe(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var _e = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), qe(this, "startDate", void 0), qe(this, "events", []), qe(this, "bufferSize", 0), qe(this, "stopFunction", void 0);
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "start",
        value: function value() {
          this.stop(), this.startDate = Date.now();
          var e = this.events;
          try {
            this.stopFunction = Be({
              emit: function emit(t) {
                var n = function (e) {
                  var t = JSON.stringify(e);
                  if (t.length > 5e6) {
                    var n,
                      a = /data:([\w\/\-\.]+);(\w+),([^)"]*)/gim,
                      r = Pe(t.matchAll(a));
                    try {
                      for (r.s(); !(n = r.n()).done;) {
                        var o = n.value;
                        t = "image/" === o[1].toLocaleLowerCase().slice(0, 6) ? t.replace(o[0], "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8ABRg5/wHSAVZN1mnaAAAAAElFTkSuQmCC") : t.replace(o[0], "");
                      }
                    } catch (i) {
                      r.e(i);
                    } finally {
                      r.f();
                    }
                  }
                  return {
                    event: JSON.parse(t),
                    size: t.length
                  };
                }(t).event;
                e.push(n);
              },
              recordCanvas: !1,
              dataURLOptions: {
                quality: .7
              },
              sampling: {
                scroll: 150,
                mouseInteraction: {
                  MouseUp: !1,
                  MouseDown: !1,
                  Click: !0,
                  ContextMenu: !0,
                  DblClick: !0,
                  Focus: !0,
                  Blur: !0,
                  TouchStart: !0,
                  TouchEnd: !1
                }
              },
              collectFonts: !1,
              inlineStylesheet: !0,
              recordCrossOriginIframes: !1,
              blockClass: "gl-block",
              ignoreClass: "gl-ignore",
              maskTextClass: "gl-mask"
            });
          } catch (t) {}
        }
      }, {
        key: "stop",
        value: function value() {
          this.stopFunction && this.stopFunction(), this.startDate = void 0, this.events = [], this.bufferSize = 0;
        }
      }, {
        key: "getReplayData",
        value: function value() {
          return {
            startDate: this.startDate,
            events: this.events,
            baseUrl: window.location.origin,
            width: window.innerWidth,
            height: window.innerHeight,
            isMobile: m(),
            type: "rrweb"
          };
        }
      }]) && Ue(t.prototype, n), a && Ue(t, a), e;
    }();
    function He(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function We(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    qe(_e, "instance", void 0);
    var ze = function () {
      function e(t) {
        var n = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), We(this, "rerender", void 0), We(this, "svgElement", null), We(this, "path", null), We(this, "strPath", void 0), We(this, "strokeWidth", 12), We(this, "strokeWidthRect", 6), We(this, "bufferSize", 4), We(this, "buffer", []), We(this, "startPoint", null), We(this, "tool", "rect"), We(this, "color", "#EB144C"), We(this, "mouseDown", null), We(this, "mouseMove", null), We(this, "mouseUp", null), We(this, "resizeListener", null), We(this, "pathBuffer", []);
        var a = this;
        this.rerender = t, this.svgElement = document.querySelector(".bb-capture-svg"), this.svgElement.style.minHeight = "".concat(document.documentElement.scrollHeight, "px"), this.resizeListener = function (e) {
          a.svgElement.style.minHeight = "".concat(document.documentElement.scrollHeight, "px");
        }, window.addEventListener("resize", this.resizeListener, !0), this.mouseDown = function (e) {
          e.preventDefault();
          var t = document.querySelector(".bb-capture-toolbar-item-colorpicker");
          t && (t.style.display = "none"), a.fadeOutToolbar(), "pen" !== a.tool && "blur" !== a.tool || a.mouseDownPen(e), "rect" === a.tool && a.mouseDownRect(e);
        }, this.mouseMove = function (e) {
          e.preventDefault(), "pen" !== a.tool && "blur" !== a.tool || a.mouseMovePen(e), "rect" === a.tool && a.mouseMoveRect(e);
        }, this.mouseUp = function (e) {
          e.preventDefault(), a.fadeInToolbar(), "pen" !== a.tool && "blur" !== a.tool || a.mouseUpPen(e), "rect" === a.tool && a.mouseUpRect(e);
        }, this.svgElement.addEventListener("mousedown", this.mouseDown), this.svgElement.addEventListener("mousemove", this.mouseMove), this.svgElement.addEventListener("mouseup", this.mouseUp), this.svgElement.addEventListener("touchstart", this.mouseDown, !1), this.svgElement.addEventListener("touchmove", this.mouseMove, !1), this.svgElement.addEventListener("touchend", this.mouseUp, !1), setTimeout(function () {
          n.rerender();
        }, 100);
      }
      var t, n, a;
      return t = e, (n = [{
        key: "clear",
        value: function value() {
          if (this.svgElement) for (; this.svgElement.firstChild;) {
            this.svgElement.firstChild.remove();
          }
        }
      }, {
        key: "destroy",
        value: function value() {
          this.svgElement.removeEventListener("mousedown", this.mouseDown), this.svgElement.removeEventListener("mousemove", this.mouseMove), this.svgElement.removeEventListener("mouseup", this.mouseUp), this.svgElement.removeEventListener("touchstart", this.mouseDown), this.svgElement.removeEventListener("touchmove", this.mouseMove), this.svgElement.removeEventListener("touchend", this.mouseUp), window.removeEventListener("resize", this.resizeListener);
        }
      }, {
        key: "mouseUpPen",
        value: function value() {
          this.path && (this.path = null);
        }
      }, {
        key: "mouseUpRect",
        value: function value() {
          this.path && (this.path = null);
        }
      }, {
        key: "mouseMovePen",
        value: function value(e) {
          this.path && (this.appendToBuffer(this.getMousePosition(e)), this.updateSvgPath());
        }
      }, {
        key: "mouseMoveRect",
        value: function value(e) {
          if (this.path) {
            var t = this.getMousePosition(e),
              n = Math.abs(t.x - this.startPoint.x),
              a = Math.abs(t.y - this.startPoint.y),
              r = t.x,
              o = t.y;
            t.x > this.startPoint.x && (r = this.startPoint.x), t.y > this.startPoint.y && (o = this.startPoint.y), this.path.setAttributeNS(null, "x", r), this.path.setAttributeNS(null, "y", o), this.path.setAttributeNS(null, "width", n), this.path.setAttributeNS(null, "height", a);
          }
        }
      }, {
        key: "mouseDownRect",
        value: function value(e) {
          this.path = document.createElementNS("http://www.w3.org/2000/svg", "rect"), this.path.setAttribute("fill", "none"), this.path.setAttribute("stroke", this.color), this.path.setAttribute("stroke-linecap", "round"), this.path.setAttribute("stroke-width", this.strokeWidthRect), this.startPoint = this.getMousePosition(e), this.appendPathToSvg(this.path);
        }
      }, {
        key: "mouseDownPen",
        value: function value(e) {
          var t = this.color + "AA",
            n = this.strokeWidth;
          "blur" === this.tool && (t = "#000000", n = 40), this.path = document.createElementNS("http://www.w3.org/2000/svg", "path"), this.path.setAttribute("fill", "none"), this.path.setAttribute("stroke", t), this.path.setAttribute("stroke-linecap", "round"), this.path.setAttribute("stroke-width", n), this.buffer = [];
          var a = this.getMousePosition(e);
          this.appendToBuffer(a), this.strPath = "M" + a.x + " " + a.y, this.path.setAttribute("d", this.strPath), this.appendPathToSvg(this.path);
        }
      }, {
        key: "setTool",
        value: function value(e) {
          this.tool = e;
        }
      }, {
        key: "setColor",
        value: function value(e) {
          this.color = e;
        }
      }, {
        key: "getMousePosition",
        value: function value(e) {
          return e.touches && e.touches.length > 0 ? {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY
          } : {
            x: e.clientX,
            y: e.clientY
          };
        }
      }, {
        key: "getAveragePoint",
        value: function value(e) {
          var t = this.buffer.length;
          if (t % 2 == 1 || t >= this.bufferSize) {
            var n,
              a,
              r = 0,
              o = 0,
              i = 0;
            for (a = e; a < t; a++) {
              i++, r += (n = this.buffer[a]).x, o += n.y;
            }
            return {
              x: r / i,
              y: o / i
            };
          }
          return null;
        }
      }, {
        key: "updateSvgPath",
        value: function value() {
          var e = this.getAveragePoint(0);
          if (e) {
            this.strPath += " L" + e.x + " " + e.y;
            for (var t = "", n = 2; n < this.buffer.length; n += 2) {
              t += " L" + (e = this.getAveragePoint(n)).x + " " + e.y;
            }
            this.path.setAttribute("d", this.strPath + t);
          }
        }
      }, {
        key: "appendToBuffer",
        value: function value(e) {
          for (this.buffer.push(e); this.buffer.length > this.bufferSize;) {
            this.buffer.shift();
          }
        }
      }, {
        key: "appendPathToSvg",
        value: function value(e) {
          this.svgElement.appendChild(e), this.pathBuffer.push(e), this.rerender();
        }
      }, {
        key: "removeLastAddedPathFromSvg",
        value: function value() {
          this.pathBuffer.length <= 0 || !this.svgElement || (this.svgElement.removeChild(this.pathBuffer[this.pathBuffer.length - 1]), this.pathBuffer.pop(), this.rerender());
        }
      }, {
        key: "fadeOutToolbar",
        value: function value() {
          var e = document.querySelector(".bb-capture-toolbar");
          e && (e.style.opacity = 0, e.style.pointerEvents = "none");
        }
      }, {
        key: "fadeInToolbar",
        value: function value() {
          var e = document.querySelector(".bb-capture-toolbar");
          e && (e.style.opacity = 1, e.style.pointerEvents = "auto");
        }
      }]) && He(t.prototype, n), a && He(t, a), e;
    }();
    function Ge(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function Ze(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var Ve = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Ze(this, "keys", {
          37: 1,
          38: 1,
          39: 1,
          40: 1
        }), Ze(this, "supportsPassive", !1), Ze(this, "wheelOpt", !!this.supportsPassive && {
          passive: !1
        }), Ze(this, "wheelEvent", "onwheel" in document.createElement("div") ? "wheel" : "mousewheel"), Ze(this, "scrollDisabled", !1);
        var t = this;
        try {
          window.addEventListener("test", null, Object.defineProperty({}, "passive", {
            get: function get() {
              t.supportsPassive = !0, t.wheelOpt = !!t.supportsPassive && {
                passive: !1
              };
            }
          }));
        } catch (n) {}
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }, {
        key: "disableScroll",
        value: function value() {
          var e = this.getInstance();
          e.scrollDisabled || (e.scrollDisabled = !0, window.addEventListener("DOMMouseScroll", e.preventDefault, !1), window.addEventListener(e.wheelEvent, e.preventDefault, e.wheelOpt), window.addEventListener("touchmove", e.preventDefault, e.wheelOpt), window.addEventListener("keydown", e.preventDefaultForScrollKeys, !1));
        }
      }, {
        key: "enableScroll",
        value: function value() {
          var e = this.getInstance();
          e.scrollDisabled && (e.scrollDisabled = !1, window.removeEventListener("DOMMouseScroll", e.preventDefault, !1), window.removeEventListener(e.wheelEvent, e.preventDefault, e.wheelOpt), window.removeEventListener("touchmove", e.preventDefault, e.wheelOpt), window.removeEventListener("keydown", e.preventDefaultForScrollKeys, !1));
        }
      }], (n = [{
        key: "preventDefault",
        value: function value(e) {
          e.preventDefault();
        }
      }, {
        key: "preventDefaultForScrollKeys",
        value: function value(e) {
          if (this.keys && this.keys[e.keyCode]) return this.preventDefault(e), !1;
        }
      }]) && Ge(t.prototype, n), a && Ge(t, a), e;
    }();
    function Ke(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function Xe(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    Ze(Ve, "instance", void 0);
    var Ye = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Xe(this, "type", "screenshot"), Xe(this, "dragCursor", null), Xe(this, "screenRecorder", null), Xe(this, "callback", null), Xe(this, "screenDrawer", null), Xe(this, "escListener", null), Xe(this, "pageLeaveListener", null), Xe(this, "overrideLanguage", Tt.getInstance().overrideLanguage), Xe(this, "showNextStep", function () {
          this.showWidgetUI(), this.callback && (re.getInstance().sendMessage({
            name: "set-form-data",
            data: {
              formKey: "capture",
              data: {
                value: this.type,
                dirty: !0
              }
            }
          }), this.callback(!0));
        }), this.type = t;
      }
      var t, n, a;
      return t = e, a = [{
        key: "setPenColor",
        value: function value(e) {
          for (var t = document.querySelectorAll(".bb-pen-tip"), n = 0; n < t.length; n++) {
            t[n].style.fill = e;
          }
        }
      }], (n = [{
        key: "hideWidgetUI",
        value: function value() {
          var e = document.querySelector(".bb-feedback-button");
          e && (e.style.display = "none");
          var t = document.querySelector(".bb-feedback-dialog-container");
          t && (t.style.display = "none");
        }
      }, {
        key: "showWidgetUI",
        value: function value() {
          "screenshot" === this.type && Ve.enableScroll(), this.screenRecorder && this.screenRecorder.stopScreenRecording(), this.unregisterListeners(), this.cleanupMousePointer(), this.screenDrawer && this.screenDrawer.destroy();
          var e = document.querySelector(".bb-capture-toolbar");
          e && e.remove();
          var t = document.querySelector(".bb-capture-svg");
          t && t.classList.add("bb-capture-svg--preview");
          var n = document.querySelector(".bb-capture-preview");
          n && n.remove();
          var a = document.querySelector(".bb-feedback-button");
          a && (a.style.display = "flex");
          var r = document.querySelector(".bb-feedback-dialog-container");
          r && (r.style.display = "block");
          var o = document.querySelector(".bb-capture-dismiss");
          o && (o.style.display = "none");
          var i = document.querySelector(".bb-capture-toolbar-item-colorpicker");
          i && (i.style.display = "none");
          var s = document.querySelector(".bb-capture-editor-borderlayer");
          s && (s.style.display = "none");
        }
      }, {
        key: "clear",
        value: function value() {
          var e = document.querySelector(".bb-capture-editor");
          e && e.remove();
        }
      }, {
        key: "setMouseMove",
        value: function value(e, t) {
          this.dragCursor && (this.dragCursor.style.left = "".concat(e + 6, "px"), this.dragCursor.style.top = "".concat(t - 26, "px"), this.dragCursor.style.right = null);
        }
      }, {
        key: "mouseMoveEventHandler",
        value: function value(e) {
          var t = e.clientX,
            n = e.clientY;
          this.setMouseMove(t, n);
        }
      }, {
        key: "touchMoveEventHandler",
        value: function value(e) {
          var t = e.touches[0].clientX,
            n = e.touches[0].clientY;
          this.setMouseMove(t, n);
        }
      }, {
        key: "setupMousePointer",
        value: function value() {
          var e = this;
          this.dragCursor = document.querySelector(".bb-capture-editor-drag-info");
          var t = document.querySelector(".bb-capture-svg");
          t.addEventListener("mouseenter", function (t) {
            e.dragCursor.style.opacity = 1;
          }), t.addEventListener("mouseleave", function (t) {
            e.dragCursor.style.opacity = 0;
          }), document.documentElement.addEventListener("mousemove", this.mouseMoveEventHandler.bind(this)), document.documentElement.addEventListener("touchmove", this.touchMoveEventHandler.bind(this));
        }
      }, {
        key: "cleanupMousePointer",
        value: function value() {
          document.documentElement.removeEventListener("mousemove", this.mouseMoveEventHandler), document.documentElement.removeEventListener("touchmove", this.touchMoveEventHandler), this.dragCursor && this.dragCursor.remove();
        }
      }, {
        key: "createEditorUI",
        value: function value() {
          var e = document.createElement("div");
          e.className = "bb-capture-editor", e.innerHTML = '\n          <div class="bb-capture-editor-borderlayer"></div>\n          <svg class="bb-capture-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" xml:space="preserve"></svg>\n          <div class="bb-capture-dismiss">'.concat(u("dismiss"), "</div>\n          <div class='bb-capture-editor-drag-info'>").concat(u("rect"), '</div>\n          <div class="bb-capture-toolbar">\n            ').concat("capture" === this.type ? '<div class="bb-capture-toolbar-item bb-capture-item-rec bb-capture-toolbar-item-recording" data-type="recording">\n                  '.concat(u("recorderon"), "\n                  ").concat(u("recorderoff"), '\n                  <span class="bb-tooltip bb-tooltip-screen-recording"></span>\n                </div>\n                <div class="bb-capture-toolbar-item bb-capture-item-rec" data-type="mic">\n                  ').concat(u("mic"), '\n                  <span class="bb-tooltip bb-tooltip-audio-recording"></span>\n                </div>\n                <div class="bb-capture-toolbar-item-timer bb-capture-item-rec">2:00</div>\n                <div class="bb-capture-toolbar-item-spacer"></div>\n                <div class="bb-capture-toolbar-item bb-capture-toolbar-drawingitem bb-capture-toolbar-item-tool" data-type="pointer">\n                  ').concat(u("pointer"), "\n                </div>") : "", '\n            <div class="bb-capture-toolbar-item bb-capture-toolbar-drawingitem bb-capture-toolbar-item-tool bb-capture-toolbar-item--active" data-type="rect">\n              ').concat(u("rect"), '\n            </div>\n            <div class="bb-capture-toolbar-item bb-capture-toolbar-drawingitem bb-capture-toolbar-item-tool" data-type="pen">\n              ').concat(u("pen"), '\n            </div>\n            <div class="bb-capture-toolbar-item bb-capture-toolbar-drawingitem bb-capture-toolbar-item-tool" data-type="blur">\n              ').concat(u("blur"), '\n            </div>\n            <div class="bb-capture-toolbar-item bb-capture-toolbar-drawingitem" data-type="colorpicker">\n              <div class="bb-capture-toolbar-item-selectedcolor"></div>\n              <span class="bb-tooltip">').concat($e.translateText("pickAColor"), '</span>\n            </div>\n            <div class="bb-capture-toolbar-item bb-capture-toolbar-drawingitem bb-capture-toolbar-item-tool" data-type="undo">\n              ').concat(u("undo"), '\n              <span class="bb-tooltip">').concat($e.translateText("undo"), "</span>\n            </div>\n            ").concat("capture" !== this.type ? '<div class="bb-capture-button-next">'.concat($e.translateText("next"), "</div>") : "", '\n          </div>\n          <div class="bb-capture-toolbar-item-colorpicker">\n            <div class="bb-capture-toolbar-item-color" data-color="#EB144C"></div>\n            <div class="bb-capture-toolbar-item-color" data-color="#FF6705"></div>\n            <div class="bb-capture-toolbar-item-color" data-color="#FDB903"></div>\n            <div class="bb-capture-toolbar-item-color" data-color="#9900EE"></div>\n            <div class="bb-capture-toolbar-item-color" data-color="#00D082"></div>\n            <div class="bb-capture-toolbar-item-color" data-color="#0A93E4"></div>\n            <div class="bb-capture-toolbar-item-color" data-color="#CCCCCC"></div>\n          </div>\n          <div class="bb-capture-preview">\n            <div class="bb-capture-preview-inner">\n              <video controls muted autoplay></video>\n              <div class="bb-capture-preview-buttons">\n                <div class="bb-capture-preview-retrybutton">').concat($e.translateText("retry"), '</div>\n                <div class="bb-capture-preview-sendbutton">').concat($e.translateText("next"), "</div>\n              </div>\n            </div>\n          </div>\n        "), document.body.appendChild(e), e.setAttribute("dir", $e.getInstance().isRTLLayout ? "rtl" : "ltr");
        }
      }, {
        key: "unregisterListeners",
        value: function value() {
          this.escListener && document.removeEventListener("keydown", this.escListener), this.pageLeaveListener && window.removeEventListener("beforeunload", this.pageLeaveListener);
        }
      }, {
        key: "registerListeners",
        value: function value() {
          var e = this;
          this.escListener = function (t) {
            var n = !1,
              a = !1;
            "key" in (t = t || window.event) && (n = "Escape" === t.key, a = "Enter" === t.key), n && e.dismiss(), "screenshot" === e.type && a && e.showNextStep();
          }, document.addEventListener("keydown", this.escListener), this.pageLeaveListener = function (e) {
            e.preventDefault(), e.returnValue = "";
          }, window.addEventListener("beforeunload", this.pageLeaveListener);
        }
      }, {
        key: "show",
        value: function value(e) {
          this.callback = e, this.registerListeners(), this.hideWidgetUI(), this.createEditorUI(), this.setupMousePointer(), "screenshot" === this.type ? (Tt.getInstance().setGlobalDataItem("snapshotPosition", {
            x: window.scrollX,
            y: window.scrollY
          }), Ve.disableScroll()) : this.setupScreenRecording(), this.screenDrawer = new ze(this.captureScreenDrawerRerender.bind(this)), this.setupColorPicker(), this.setupToolbar();
        }
      }, {
        key: "setupColorPicker",
        value: function value() {
          for (var t = this, n = document.querySelector(".bb-capture-toolbar-item-selectedcolor"), a = document.querySelectorAll(".bb-capture-toolbar-item-color"), r = document.querySelector(".bb-capture-toolbar-item-colorpicker"), o = function o() {
              var o = a[i],
                s = o.getAttribute("data-color");
              o.style.backgroundColor = s, o.onclick = function () {
                o && (t.screenDrawer.setColor(s), r && (r.style.display = "none"), n.style.backgroundColor = o.style.backgroundColor, e.setPenColor(s));
              };
            }, i = 0; i < a.length; i++) {
            o();
          }
        }
      }, {
        key: "dismiss",
        value: function value() {
          this.showWidgetUI(), this.callback && this.callback(!1);
        }
      }, {
        key: "setupToolbar",
        value: function value() {
          var e = this;
          document.querySelector(".bb-capture-dismiss").onclick = function () {
            e.dismiss();
          };
          var t = document.querySelector(".bb-capture-button-next");
          t && (t.onclick = this.showNextStep.bind(this));
          for (var n = document.querySelector(".bb-capture-toolbar-item-colorpicker"), a = document.querySelector(".bb-capture-svg"), r = function r(t, n) {
              for (var r = document.querySelectorAll(".bb-capture-toolbar-item-tool"), o = 0; o < r.length; o++) {
                r[o].classList.remove("bb-capture-toolbar-item--active");
              }
              if (n.classList.add("bb-capture-toolbar-item--active"), e.screenDrawer.setTool(t), e.dragCursor.innerHTML = "", "pointer" === t) a.style.pointerEvents = "none";else {
                a.style.pointerEvents = "auto";
                try {
                  var i = n.querySelector("svg").cloneNode(!0);
                  i && e.dragCursor && e.dragCursor.appendChild(i);
                } catch (s) {}
              }
            }, o = document.querySelectorAll(".bb-capture-toolbar-item"), i = function i() {
              var t = o[s];
              t.onclick = function () {
                var a = t.getAttribute("data-type");
                n && "colorpicker" !== a && (n.style.display = "none"), "mic" === a && e.screenRecorder.toggleAudio(), "recording" === a && (e.screenRecorder.isRecording ? e.screenRecorder.stopScreenRecording() : (e.screenRecorder.startScreenRecording(), r("pointer", document.querySelector(".bb-capture-toolbar-item[data-type='pointer']")))), ("capture" !== e.type || e.screenRecorder.isRecording) && ("pen" !== a && "blur" !== a && "rect" !== a && "pointer" !== a || r(a, t), "colorpicker" === a && ("flex" === n.style.display ? n.style.display = "none" : n.style.display = "flex"), "undo" === a && e.screenDrawer.removeLastAddedPathFromSvg());
              };
            }, s = 0; s < o.length; s++) {
            i();
          }
        }
      }, {
        key: "captureScreenDrawerRerender",
        value: function value() {
          if (this.screenDrawer) for (var e = "bb-capture-editor-item-inactive", t = document.querySelectorAll(".bb-capture-toolbar-item"), n = 0; n < t.length; n++) {
            var a = t[n];
            switch (a.getAttribute("data-type")) {
              case "undo":
                null != this.screenDrawer.pathBuffer && this.screenDrawer.pathBuffer.length > 0 ? a.classList.remove(e) : a.classList.add(e);
            }
          }
        }
      }, {
        key: "captureRenderer",
        value: function value() {
          if (this.screenRecorder) {
            this.screenRecorder.file && Tt.getInstance().setGlobalDataItem("screenRecordingData", this.screenRecorder.file);
            var e = "bb-capture-editor-item-inactive",
              t = document.querySelector(".bb-capture-toolbar-item-timer"),
              n = document.querySelectorAll(".bb-capture-toolbar-item"),
              a = document.querySelector(".bb-tooltip-screen-recording"),
              r = document.querySelector(".bb-tooltip-audio-recording"),
              o = document.querySelector(".bb-capture-editor"),
              i = "bb-capture-editor-recording",
              s = "bb-capture-editor-notrecording";
            this.screenRecorder.isRecording ? (o.classList.add(i), o.classList.remove(s)) : (o.classList.add(s), o.classList.remove(i));
            var c = document.querySelector(".bb-capture-toolbar");
            document.querySelector(".bb-capture-preview").style.display = this.screenRecorder.file ? "flex" : "none", c.style.display = this.screenRecorder.file ? "none" : "flex";
            for (var l = 0; l < n.length; l++) {
              var u = n[l];
              switch (u.getAttribute("data-type")) {
                case "mic":
                  this.screenRecorder.audioAvailable && this.screenRecorder.available ? (u.classList.remove(e), this.screenRecorder.audioMuted ? (u.classList.add("bb-capture-toolbar-item--inactivecross"), r.innerHTML = $e.translateText("unmute")) : (u.classList.remove("bb-capture-toolbar-item--inactivecross"), r.innerHTML = $e.translateText("mute"))) : (u.classList.add(e), u.classList.add("bb-capture-toolbar-item--inactivecross"), r.innerHTML = $e.translateText("browserNotSupported"));
                  break;
                case "recording":
                  this.screenRecorder.available ? (u.classList.remove(e), this.screenRecorder.isRecording ? (u.setAttribute("data-active", "true"), a.innerHTML = $e.translateText("stopRecording"), t.style.display = "block") : (u.setAttribute("data-active", "false"), a.innerHTML = $e.translateText("stopRecording"), t.style.display = "none")) : (u.classList.add(e), a.innerHTML = $e.translateText("browserNotSupported"));
              }
            }
          }
        }
      }, {
        key: "setupScreenRecording",
        value: function value() {
          var e = this;
          document.querySelector(".bb-capture-preview-sendbutton").onclick = this.showNextStep.bind(this), document.querySelector(".bb-capture-preview-retrybutton").onclick = function () {
            e.screenRecorder.clearPreview(), e.screenDrawer && e.screenDrawer.clear();
          }, this.screenRecorder = new Y(this.captureRenderer.bind(this), $e.translateText("accessToScreenSharingDenied"));
        }
      }]) && Ke(t.prototype, n), a && Ke(t, a), e;
    }();
    function Je(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function Qe(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var $e = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Qe(this, "overrideLanguage", ""), Qe(this, "isRTLLayout", !1);
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }, {
        key: "translateText",
        value: function value(e) {
          if (!e) return "";
          var t = B.getInstance().getFlowConfig().staticTranslations;
          return t && t[e] ? t[e] : e;
        }
      }], (n = [{
        key: "getOverrideLanguage",
        value: function value() {
          return this.overrideLanguage;
        }
      }, {
        key: "setOverrideLanguage",
        value: function value(e) {
          this.overrideLanguage = e;
        }
      }, {
        key: "updateRTLSupport",
        value: function value() {
          var e = B.getInstance().getFlowConfig();
          this.isRTLLayout = !1, e && e.localizationOptions && e.localizationOptions.rtl && (this.isRTLLayout = !0), r.getInstance().updateFeedbackButtonState(), re.getInstance().updateFrameStyle();
        }
      }, {
        key: "getActiveLanguage",
        value: function value() {
          var e = "en";
          return "undefined" != typeof navigator && (e = navigator.language.substring(0, 2).toLowerCase()), this.overrideLanguage && "" !== this.overrideLanguage && (e = this.overrideLanguage.toLowerCase()), e;
        }
      }]) && Je(t.prototype, n), a && Je(t, a), e;
    }();
    function et(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function tt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    Qe($e, "instance", void 0);
    var nt = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), tt(this, "shortCutListener", void 0);
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "start",
        value: function value() {
          this.shortCutListener || (this.shortCutListener = document.addEventListener("keyup", function (e) {
            var t,
              n,
              a = (void 0 !== (t = e).key ? n = t.key : void 0 !== t.keyIdentifier ? n = t.keyIdentifier : void 0 !== t.keyCode && (n = t.keyCode), n);
            !e.ctrlKey || "i" !== a && "I" !== a && 73 !== a || Tt.startFeedbackFlowWithOptions("bugreporting", {
              autostartDrawing: !0
            });
          }));
        }
      }, {
        key: "stop",
        value: function value() {
          this.shortCutListener && (document.removeEventListener("keyup", this.shortCutListener), this.shortCutListener = void 0);
        }
      }]) && et(t.prototype, n), a && et(t, a), e;
    }();
    function at(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function rt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    tt(nt, "instance", void 0);
    var ot = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), rt(this, "formPreFill", {});
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = null) && at(t.prototype, n), a && at(t, a), e;
    }();
    function it(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function st(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    rt(ot, "instance", void 0);
    var ct = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), st(this, "notificationContainer", null), st(this, "notifications", []), st(this, "unreadCount", 0), st(this, "unreadNotificationsKey", "unread-notifications"), st(this, "isTabActive", !0), st(this, "showNotificationBadge", !0);
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "updateTabBarNotificationCount",
        value: function value() {
          Ie.notifyEvent("unread-count-changed", this.unreadCount);
        }
      }, {
        key: "injectNotificationUI",
        value: function value() {
          if (!this.notificationContainer) {
            var e = document.createElement("div");
            e.className = "gleap-notification-container gleap-font", document.body.appendChild(e), this.notificationContainer = e, this.updateContainerStyle(), this.reloadNotificationsFromCache();
          }
        }
      }, {
        key: "reloadNotificationsFromCache",
        value: function value() {
          var e = w(this.unreadNotificationsKey);
          e && e.length > 0 && (this.notifications = e, this.renderNotifications());
        }
      }, {
        key: "setNotificationCount",
        value: function value(e) {
          re.getInstance().isOpened() ? (this.unreadCount = 0, this.updateTabBarNotificationCount()) : this.unreadCount = e, this.updateTabBarNotificationCount(), r.getInstance().updateNotificationBadge(this.unreadCount);
        }
      }, {
        key: "showNotification",
        value: function value(e) {
          this.notificationContainer && e && e.data && (this.notifications.find(function (t) {
            return e.outbound === t.outbound;
          }) || (this.notifications.push(e), e.sound && mt.ping()), this.notifications.length > 3 && this.notifications.shift(), C(this.unreadNotificationsKey, this.notifications), this.renderNotifications());
        }
      }, {
        key: "renderNotifications",
        value: function value() {
          var e = this;
          if (this.notificationContainer) {
            this.clearAllNotifications(!0);
            var t = document.createElement("div");
            t.onclick = function () {
              e.clearAllNotifications();
            }, t.className = "gleap-notification-close", t.innerHTML = u("dismiss"), this.notificationContainer.appendChild(t);
            for (var n = function n() {
                var t = e.notifications[a];
                r = (r = t.data.text).replaceAll("{{name}}", M.getInstance().getName());
                var n = document.createElement("div");
                n.onclick = function () {
                  t.data.conversation ? Tt.openConversation(t.data.conversation.shareToken) : t.data.news ? Tt.openNewsArticle(t.data.news.id) : Tt.open();
                }, t.data.news ? (n.className = "gleap-notification-item-news", n.innerHTML = '\n        <div class="gleap-notification-item-news-container">\n          '.concat(t.data.coverImageUrl && "" !== t.data.coverImageUrl && !t.data.coverImageUrl.includes("NewsImagePlaceholder") ? '<img class="gleap-notification-item-news-image" src="'.concat(t.data.coverImageUrl, '" />') : "", '\n          <div class="gleap-notification-item-news-content">\n          <div class="gleap-notification-item-news-content-title">').concat(r, "</div>\n          ").concat(t.data.previewText && t.data.previewText.length > 0 ? '<div class="gleap-notification-item-news-preview">'.concat(t.data.previewText, "</div>") : "".concat(t.data.sender ? '\n          <div class="gleap-notification-item-news-sender">\n            '.concat(t.data.sender.profileImageUrl && '<img src="'.concat(t.data.sender.profileImageUrl, '" />'), " ").concat(t.data.sender.name, "</div>") : ""), "\n          </div>\n        </div>")) : (n.className = "gleap-notification-item", n.innerHTML = "\n            ".concat(t.data.sender && t.data.sender.profileImageUrl && '<img src="'.concat(t.data.sender.profileImageUrl, '" />'), '\n            <div class="gleap-notification-item-container">\n                ').concat(t.data.sender ? '<div  class="gleap-notification-item-sender">'.concat(t.data.sender.name, "</div>") : "", '\n                <div class="gleap-notification-item-content">').concat(r, "</div>\n            </div>")), e.notificationContainer.appendChild(n);
              }, a = 0; a < this.notifications.length; a++) {
              var r;
              n();
            }
          }
        }
      }, {
        key: "clearAllNotifications",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (this.notificationContainer) for (e || (this.notifications = [], C(this.unreadNotificationsKey, this.notifications)); this.notificationContainer.firstChild;) {
            this.notificationContainer.removeChild(this.notificationContainer.firstChild);
          }
        }
      }, {
        key: "updateContainerStyle",
        value: function value() {
          if (this.notificationContainer) {
            var e = B.getInstance().getFlowConfig(),
              t = "gleap-notification-container--left",
              n = "gleap-notification-container--no-button";
            this.notificationContainer.classList.remove(t), this.notificationContainer.classList.remove(n), e.feedbackButtonPosition !== r.FEEDBACK_BUTTON_CLASSIC_LEFT && e.feedbackButtonPosition !== r.FEEDBACK_BUTTON_BOTTOM_LEFT || this.notificationContainer.classList.add(t), null === r.getInstance().buttonHidden ? e.feedbackButtonPosition === r.FEEDBACK_BUTTON_NONE && this.notificationContainer.classList.add(n) : r.getInstance().buttonHidden && this.notificationContainer.classList.add(n);
          }
        }
      }]) && it(t.prototype, n), a && it(t, a), e;
    }();
    function lt(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        t && (a = a.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, a);
      }
      return n;
    }
    function ut(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? lt(Object(n), !0).forEach(function (t) {
          pt(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lt(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function dt(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function pt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    st(ct, "instance", void 0);
    var ft = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), pt(this, "bannerUrl", "https://outboundmedia.gleap.io"), pt(this, "bannerContainer", null), pt(this, "bannerData", null), this.startCommunication();
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "setBannerUrl",
        value: function value(e) {
          this.bannerUrl = e;
        }
      }, {
        key: "startCommunication",
        value: function value() {
          var e = this;
          window.addEventListener("message", function (t) {
            if (t.origin === e.bannerUrl) try {
              var n,
                a,
                r,
                o,
                i,
                s,
                c,
                l,
                u = JSON.parse(t.data);
              "banner-loaded" === u.name && e.bannerData && e.sendMessage({
                name: "banner-data",
                data: e.bannerData
              }), "banner-height" === u.name && document.documentElement.style.setProperty("--gleap-margin-top", u.data.height + "px"), "banner-data-set" === u.name && (document.body.classList.add("gleap-b-shown"), "floating" === (null === (n = e.bannerData) || void 0 === n ? void 0 : n.format) && document.body.classList.add("gleap-b-f")), "banner-close" === u.name && e.removeBannerUI(), "start-conversation" === u.name && Tt.startBot(null === (a = u.data) || void 0 === a ? void 0 : a.botId), "start-custom-action" === u.name && Tt.triggerCustomAction(null === (r = u.data) || void 0 === r ? void 0 : r.action), "show-form" === u.name && Tt.startFeedbackFlow(null === (o = u.data) || void 0 === o ? void 0 : o.formId), "show-survey" === u.name && Tt.showSurvey(null === (i = u.data) || void 0 === i ? void 0 : i.formId, null === (s = u.data) || void 0 === s ? void 0 : s.surveyFormat), "show-news-article" === u.name && Tt.openNewsArticle(null === (c = u.data) || void 0 === c ? void 0 : c.articleId), "show-help-article" === u.name && Tt.openHelpCenterArticle(null === (l = u.data) || void 0 === l ? void 0 : l.articleId);
            } catch (d) {}
          });
        }
      }, {
        key: "removeBannerUI",
        value: function value() {
          this.bannerContainer && (document.body.removeChild(this.bannerContainer), this.bannerContainer = null), document.body.classList.remove("gleap-b-shown"), document.body.classList.remove("gleap-b-f");
        }
      }, {
        key: "injectBannerUI",
        value: function value(e) {
          if (this.bannerContainer || !document.body) return !1;
          this.bannerData = e;
          var t = document.createElement("div");
          t.className = "gleap-b", t.innerHTML = '<iframe src="'.concat(this.bannerUrl, '" class="gleap-b-frame" scrolling="no" title="Gleap Banner" role="dialog" frameborder="0"></iframe>'), document.body.appendChild(t), this.bannerContainer = t;
        }
      }, {
        key: "sendMessage",
        value: function value(e) {
          try {
            var t = document.querySelector(".gleap-b-frame");
            t && t.contentWindow && t.contentWindow.postMessage(JSON.stringify(ut(ut({}, e), {}, {
              type: "banner"
            })), "*");
          } catch (n) {}
        }
      }, {
        key: "showBanner",
        value: function value(e) {
          this.injectBannerUI(e);
        }
      }]) && dt(t.prototype, n), a && dt(t, a), e;
    }();
    function ht(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function gt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    pt(ft, "instance", void 0);
    var mt = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      }
      var t, n, a;
      return t = e, a = [{
        key: "playSound",
        value: function value(e) {
          this.settings.play = e;
        }
      }, {
        key: "ping",
        value: function value() {
          try {
            if (!this.settings.play) return;
            this.audio || (this.audio = new Audio("https://js.gleap.io/res/ping.mp3"));
            var e = this.audio.play();
            void 0 !== e && e.then(function (e) {}).catch(function (e) {});
          } catch (t) {}
        }
      }], (n = null) && ht(t.prototype, n), a && ht(t, a), e;
    }();
    function bt(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function vt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    gt(mt, "audio", void 0), gt(mt, "settings", {
      play: !0
    });
    var yt = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), vt(this, "tags", []);
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }], (n = [{
        key: "getTags",
        value: function value() {
          return this.tags;
        }
      }, {
        key: "setTags",
        value: function value(e) {
          this.tags = e;
        }
      }]) && bt(t.prototype, n), a && bt(t, a), e;
    }();
    function wt(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }
    function Ct(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        t && (a = a.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, a);
      }
      return n;
    }
    function kt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ct(Object(n), !0).forEach(function (t) {
          It(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ct(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function It(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    vt(yt, "instance", void 0), "undefined" != typeof HTMLCanvasElement && HTMLCanvasElement.prototype && void 0 === HTMLCanvasElement.prototype.__originalGetContext && (HTMLCanvasElement.prototype.__originalGetContext = HTMLCanvasElement.prototype.getContext, HTMLCanvasElement.prototype.getContext = function (e, t) {
      return this.__originalGetContext(e, kt(kt({}, t), {}, {
        preserveDrawingBuffer: !0
      }));
    });
    var xt = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), It(this, "initialized", !1), It(this, "offlineMode", !1), It(this, "disablePageTracking", !1), It(this, "disableInAppNotifications", !1), It(this, "globalData", {
          screenRecordingData: null,
          webReplay: null,
          snapshotPosition: {
            x: 0,
            y: 0
          }
        }), "undefined" != typeof window && (se.getInstance(), pe.getInstance().start(), be.getInstance().start());
      }
      var t, n, a;
      return t = e, a = [{
        key: "getInstance",
        value: function value() {
          return this.instance || (this.instance = new e()), this.instance;
        }
      }, {
        key: "setEnvironment",
        value: function value(e) {
          se.getInstance().environment = e;
        }
      }, {
        key: "setTags",
        value: function value(e) {
          yt.getInstance().setTags(e);
        }
      }, {
        key: "setUrlHandler",
        value: function value(e) {
          re.getInstance().setUrlHandler(e);
        }
      }, {
        key: "setOfflineMode",
        value: function value(e) {
          this.getInstance().offlineMode = e;
        }
      }, {
        key: "setDisableInAppNotifications",
        value: function value(e) {
          this.getInstance().disableInAppNotifications = e;
        }
      }, {
        key: "setDisablePageTracking",
        value: function value(e) {
          this.getInstance().disablePageTracking = e;
        }
      }, {
        key: "disableConsoleLogOverwrite",
        value: function value() {
          pe.getInstance().stop();
        }
      }, {
        key: "attachNetworkLogs",
        value: function value(e) {
          g.getInstance().externalRequests = b(e);
        }
      }, {
        key: "log",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "INFO";
          pe.getInstance().addLog(e, t);
        }
      }, {
        key: "initialize",
        value: function value(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            a = this.getInstance();
          if (a.initialized) console.warn("Gleap already initialized.");else {
            a.initialized = !0, n && R.getInstance().stop();
            var o = M.getInstance();
            o.sdkKey = t, o.setOnSessionReady(function () {
              setTimeout(function () {
                B.getInstance().start().then(function () {
                  n || R.getInstance().start(), x(function () {
                    r.getInstance().injectFeedbackButton(), ct.getInstance().injectNotificationUI(), e.checkForUrlParams(), Ie.notifyEvent("initialized");
                  });
                }).catch(function (e) {
                  console.warn("Failed to initialize Gleap.");
                });
              }, 0);
            }), o.startSession();
          }
        }
      }, {
        key: "checkForUrlParams",
        value: function value() {
          if ("undefined" != typeof window && window.location.search) try {
            var t = new URLSearchParams(window.location.search),
              n = t.get("gleap_feedback");
            n && n.length > 0 && e.startFeedbackFlow(n);
            var a = t.get("gleap_survey"),
              r = t.get("gleap_survey_format");
            a && a.length > 0 && e.showSurvey(a, "survey_full" === r ? "survey_full" : "survey");
          } catch (o) {
            console.log(o);
          }
        }
      }, {
        key: "destroy",
        value: function value() {
          _e.getInstance().stop(), R.getInstance().stop(), re.getInstance().destroy(), r.getInstance().toggleFeedbackButton(!1), ct.getInstance().clearAllNotifications(!0), M.getInstance().clearSession(0, !1);
        }
      }, {
        key: "setUseCookies",
        value: function value(e) {
          M.getInstance().useCookies = e;
        }
      }, {
        key: "identify",
        value: function value(e, t, n) {
          return M.getInstance().identifySession(e, b(t), n);
        }
      }, {
        key: "clearIdentity",
        value: function value() {
          M.getInstance().clearSession();
        }
      }, {
        key: "getIdentity",
        value: function value() {
          return M.getInstance().getSession();
        }
      }, {
        key: "isUserIdentified",
        value: function value() {
          var e = M.getInstance().session;
          return !!(e && e.userId && e.userId.length > 0);
        }
      }, {
        key: "isOpened",
        value: function value() {
          return re.getInstance().isOpened();
        }
      }, {
        key: "hide",
        value: function value() {
          re.getInstance().hideWidget();
        }
      }, {
        key: "setMaxNetworkRequests",
        value: function value(e) {
          g.getInstance().setMaxRequests(e);
        }
      }, {
        key: "close",
        value: function value() {
          re.getInstance().hideWidget();
        }
      }, {
        key: "open",
        value: function value() {
          re.getInstance().setAppMode("widget"), re.getInstance().showWidget();
        }
      }, {
        key: "trackEvent",
        value: function value(e, t) {
          R.getInstance().logEvent(e, t);
        }
      }, {
        key: "logEvent",
        value: function value(e, t) {
          R.getInstance().logEvent(e, t);
        }
      }, {
        key: "preFillForm",
        value: function value(e) {
          var t = b(e);
          ot.getInstance().formPreFill = t, re.getInstance().sendMessage({
            name: "prefill-form-data",
            data: t
          }, !0);
        }
      }, {
        key: "on",
        value: function value(e, t) {
          Ie.on(e, t);
        }
      }, {
        key: "enableShortcuts",
        value: function value(e) {
          e ? nt.getInstance().start() : nt.getInstance().stop();
        }
      }, {
        key: "showFeedbackButton",
        value: function value(e) {
          r.getInstance().toggleFeedbackButton(e);
        }
      }, {
        key: "setAppVersionCode",
        value: function value(e) {
          se.setAppVersionCode(e);
        }
      }, {
        key: "setAppBuildNumber",
        value: function value(e) {
          se.setAppBuildNumber(e);
        }
      }, {
        key: "setApiUrl",
        value: function value(e) {
          M.getInstance().apiUrl = e;
        }
      }, {
        key: "setBannerUrl",
        value: function value(e) {
          ft.getInstance().setBannerUrl(e);
        }
      }, {
        key: "setFrameUrl",
        value: function value(e) {
          re.getInstance().frameUrl = e;
        }
      }, {
        key: "attachCustomData",
        value: function value(e) {
          we.getInstance().attachCustomData(e);
        }
      }, {
        key: "setCustomData",
        value: function value(e, t) {
          we.getInstance().setCustomData(e, t);
        }
      }, {
        key: "removeCustomData",
        value: function value(e) {
          we.getInstance().removeCustomData(e);
        }
      }, {
        key: "clearCustomData",
        value: function value() {
          we.getInstance().clearCustomData();
        }
      }, {
        key: "playSound",
        value: function value(e) {
          mt.playSound(e);
        }
      }, {
        key: "showTabNotificationBadge",
        value: function value(e) {
          var t = ct.getInstance();
          t.showNotificationBadge = e, t.updateTabBarNotificationCount();
        }
      }, {
        key: "setLanguage",
        value: function value(t) {
          $e.getInstance().setOverrideLanguage(t), e.getInstance().initialized && setTimeout(function () {
            e.getInstance().softReInitialize();
          }, 1e3);
        }
      }, {
        key: "registerCustomAction",
        value: function value(e) {
          Le.registerCustomAction(e);
        }
      }, {
        key: "triggerCustomAction",
        value: function value(e) {
          Le.triggerCustomAction(e);
        }
      }, {
        key: "setStyles",
        value: function value(e, t, n) {
          var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "#ffffff",
            o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 20,
            i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 20,
            s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 20,
            c = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : r.FEEDBACK_BUTTON_BOTTOM_LEFT;
          x(function () {
            l(e, t, n, o, a, i, s, c);
          });
        }
      }, {
        key: "sendSilentCrashReport",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "MEDIUM",
            a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
              screenshot: !0,
              replays: !0,
              attachments: !0
            };
          return e.sendSilentCrashReportWithFormData({
            description: t
          }, n, a);
        }
      }, {
        key: "sendSilentCrashReportWithFormData",
        value: function value(e) {
          var t = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "MEDIUM",
            a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
              screenshot: !0,
              replays: !0,
              attachments: !0
            };
          if (!this.silentCrashReportSent) {
            this.silentCrashReportSent = !0, setTimeout(function () {
              t.silentCrashReportSent = !1;
            }, 1e4);
            var r = a ? b(a) : {},
              o = M.getInstance();
            if (o.ready) {
              var i = e || {};
              o.session.email && (i.reportedBy = o.session.email);
              var s = new $("CRASH", n, i, !0, r);
              s.sendFeedback().then(function () {}).catch(function (e) {});
            }
          }
        }
      }, {
        key: "showSurvey",
        value: function value(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "survey";
          e.startFeedbackFlowWithOptions(t, {
            hideBackButton: !0,
            format: n
          }, !0);
        }
      }, {
        key: "startFeedbackFlow",
        value: function value(t, n) {
          e.startFeedbackFlowWithOptions(t, {
            hideBackButton: !n
          });
        }
      }, {
        key: "startFeedbackFlowWithOptions",
        value: function value(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = n.autostartDrawing,
            o = n.hideBackButton,
            i = n.format,
            s = M.getInstance();
          if (s.ready) {
            e.getInstance().setGlobalDataItem("snapshotPosition", {
              x: window.scrollX,
              y: window.scrollY
            });
            var c = "start-feedbackflow";
            a && (c = "start-survey"), re.getInstance().setAppMode(a ? i : "widget"), re.getInstance().sendMessage({
              name: c,
              data: {
                flow: t,
                hideBackButton: o,
                format: i
              }
            }, !0), r ? re.getInstance().showDrawingScreen("screenshot") : re.getInstance().showWidget();
          }
        }
      }, {
        key: "openConversations",
        value: function value() {
          var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "open-conversations",
            data: {
              hideBackButton: !e
            }
          }, !0), re.getInstance().showWidget();
        }
      }, {
        key: "openConversation",
        value: function value(e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          e && (re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "open-conversation",
            data: {
              shareToken: e,
              hideBackButton: !t
            }
          }, !0), re.getInstance().showWidget());
        }
      }, {
        key: "startBot",
        value: function value(e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "start-bot",
            data: {
              botId: e || "",
              hideBackButton: !t
            }
          }, !0), re.getInstance().showWidget();
        }
      }, {
        key: "openHelpCenterCollection",
        value: function value(e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          e && (re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "open-help-collection",
            data: {
              collectionId: e,
              hideBackButton: !t
            }
          }, !0), re.getInstance().showWidget());
        }
      }, {
        key: "openHelpCenterArticle",
        value: function value(e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          e && (re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "open-help-article",
            data: {
              articleId: e,
              hideBackButton: !t
            }
          }, !0), re.getInstance().showWidget());
        }
      }, {
        key: "openHelpCenter",
        value: function value() {
          var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "open-helpcenter",
            data: {
              hideBackButton: !e
            }
          }, !0), re.getInstance().showWidget();
        }
      }, {
        key: "searchHelpCenter",
        value: function value(e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          e && (re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "open-helpcenter-search",
            data: {
              term: e,
              hideBackButton: !t
            }
          }, !0), re.getInstance().showWidget());
        }
      }, {
        key: "openNewsArticle",
        value: function value(e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          e && (re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "open-news-article",
            data: {
              id: e,
              hideBackButton: !t
            }
          }, !0), re.getInstance().showWidget());
        }
      }, {
        key: "openNews",
        value: function value() {
          var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "open-news",
            data: {
              hideBackButton: !e
            }
          }, !0), re.getInstance().showWidget();
        }
      }, {
        key: "openFeatureRequests",
        value: function value() {
          var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          re.getInstance().setAppMode("widget"), re.getInstance().sendMessage({
            name: "open-feature-requests",
            data: {
              hideBackButton: !e
            }
          }, !0), re.getInstance().showWidget();
        }
      }, {
        key: "showBanner",
        value: function value(e) {
          try {
            ft.getInstance().showBanner(e);
          } catch (t) {
            console.log(t);
          }
        }
      }, {
        key: "showNotification",
        value: function value(e) {
          ct.getInstance().showNotification(e);
        }
      }], (n = [{
        key: "isLiveMode",
        value: function value() {
          if (!0 === this.offlineMode) return !1;
          var e = window.location.hostname;
          return !(["localhost", "127.0.0.1", "0.0.0.0", "", "::1"].includes(e) || e.startsWith("192.168.") || e.startsWith("10.0.") || e.endsWith(".local") || !e.includes("."));
        }
      }, {
        key: "softReInitialize",
        value: function value() {
          re.getInstance().destroy(), B.getInstance().start().then(function () {
            r.getInstance().refresh(), ct.getInstance().injectNotificationUI();
          }).catch(function (e) {
            console.warn("Failed to initialize Gleap.");
          });
        }
      }, {
        key: "performActions",
        value: function value(t) {
          for (var n = 0; n < t.length; n++) {
            var a = t[n];
            a && a.actionType && ("notification" === a.actionType ? this.disableInAppNotifications || e.showNotification(a) : "banner" === a.actionType ? e.showBanner(a) : e.showSurvey(a.actionType, a.format));
          }
        }
      }, {
        key: "setGlobalDataItem",
        value: function value(e, t) {
          this.globalData[e] = t;
        }
      }, {
        key: "getGlobalDataItem",
        value: function value(e) {
          return this.globalData[e];
        }
      }, {
        key: "takeCurrentReplay",
        value: function value() {
          var e = _e.getInstance().getReplayData();
          this.setGlobalDataItem("webReplay", e);
        }
      }]) && wt(t.prototype, n), a && wt(t, a), e;
    }();
    if (It(xt, "invoked", !0), It(xt, "silentCrashReportSent", !1), It(xt, "instance", void 0), "undefined" != typeof window) {
      var St = window.GleapActions;
      if (St && St.length > 0) for (var Lt = 0; Lt < St.length; Lt++) {
        var At = St[Lt];
        At && At.e && xt[At.e] && xt[At.e].apply(xt, At.a);
      }
    }
    var Tt = xt,
      Mt = Tt;
    return t = t.default;
  }();
});